var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 484.43 556.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-2 {\n        fill: gray;\n      }\n\n      .cls-3 {\n        fill: #a3a3a3;\n      }\n\n      .cls-4 {\n        fill: #818181;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: #3c3c3b;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-8 {\n        fill: #adadad;\n      }\n\n      .cls-9 {\n        fill: #8f8f8f;\n      }\n\n      .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-11 {\n        fill: #9e9e9e;\n      }\n\n      .cls-12 {\n        fill: #121211;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-15 {\n        fill: #8a8a8a;\n      }\n\n      .cls-16 {\n        fill: #9b9b9b;\n      }\n\n      .cls-17 {\n        fill: #a8a8a8;\n      }\n\n      .cls-18 {\n        fill: #858585;\n      }\n\n      .cls-19 {\n        fill: #979797;\n      }\n\n      .cls-20 {\n        fill: #999;\n      }\n\n      .cls-21 {\n        fill: #949494;\n      }\n\n      .cls-22 {\n        fill: #d6d6d6;\n      }\n\n      .cls-23 {\n        fill: #212121;\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-25 {\n        fill: #d8d9d8;\n      }\n\n      .cls-26 {\n        fill: #82c341;\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M175.49,265.68l1.41-5.62c1.4-1.42,2.91-1.89,4.3-1.89l-1.41,5.62c-1.39,0-2.9.47-4.3,1.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.79,263.8l1.41-5.62c2.78,0,4.98,1.79,5.1,1.89l-1.41,5.62c-.12-.09-2.31-1.89-5.1-1.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.95,283.91l1.41-5.62c.36-.02.7-.03,1.05-.04l-1.41,5.62c-.35,0-.69.02-1.05.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.52,262.45l1.41-5.62c2.92-3.88,6.13-5.07,8.97-5.07l-1.41,5.62c-2.84,0-6.05,1.19-8.97,5.07Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.49,257.39l1.41-5.62c4.52,0,7.93,2.87,8.11,3.02l-1.41,5.62c-.18-.15-3.58-3.02-8.11-3.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M339.77,248.01l1.41-5.62s.56-.04,1.54-.04c5.36,0,23.12,1.11,27.39,15.52l-1.41,5.62c-4.26-14.41-22.02-15.52-27.39-15.52-.97,0-1.51.03-1.54.04Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M439.32,279.22c0,110.04-88.68,199.25-198.08,199.25S43.15,389.26,43.15,279.22,131.84,81.16,241.23,79.98c114.29-1.24,198.08,89.21,198.08,199.25Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "86.16 355.77 74.28 355.85 74.27 354.14 86.16 354.06 86.16 351.15 74.26 351.22 74.25 349.5 86.16 349.43 86.16 346.51 74.24 346.59 74.23 344.87 86.16 344.8 86.16 341.89 74.21 341.96 74.21 341.96 74.21 340.25 86.16 340.18 86.16 337.26 74.2 337.33 74.19 335.62 86.16 335.55 86.16 332.63 74.17 332.7 74.17 330.99 86.16 330.91 86.16 328 74.16 328.08 74.15 326.37 86.16 326.29 86.16 323.38 74.13 323.45 74.12 321.74 86.16 321.66 86.16 318.74 74.11 318.82 74.11 317.1 86.16 317.03 86.16 314.11 74.09 314.19 74.09 314.19 74.08 312.48 86.16 312.4 86.16 309.49 74.07 309.57 74.07 307.85 86.16 307.78 86.16 304.86 74.05 304.93 74.04 303.22 86.16 303.15 86.16 300.23 74.03 300.31 74.02 298.59 86.16 298.52 86.16 295.61 74.01 295.68 74 293.97 74 293.97 86.16 293.89 86.16 290.98 73.99 291.05 73.99 291.05 73.98 289.35 73.98 289.34 86.16 289.26 86.16 285.72 73.13 285.8 73.11 281.88 73.04 266.65 58.8 266.74 59.21 356.58 57.9 356.98 57.11 357.07 61.2 357.04 61.2 357.04 60.81 269.88 60.81 269.88 61.49 269.87 61.88 357.04 64.39 357.02 64.39 357.02 63.99 269.86 64.67 269.86 65.07 357.02 67.57 357 67.18 269.84 67.86 269.84 68.26 357 68.26 357 70.75 356.98 70.75 356.98 70.37 269.82 71.05 269.82 71.44 356.98 86.16 356.89 86.16 355.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "57.9 356.98 57.9 356.98 59.21 356.58 57.9 356.58 57.9 356.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 354.06 74.27 354.14 74.28 355.85 86.16 355.77 86.16 354.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "57.12 356.59 57.11 356.98 57.9 356.98 57.9 356.98 57.9 356.58 57.12 356.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 349.43 74.25 349.5 74.26 351.22 86.16 351.15 86.16 349.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 344.8 74.23 344.87 74.24 346.59 86.16 346.51 86.16 344.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 340.18 74.21 340.25 74.21 341.96 74.21 341.96 86.16 341.89 86.16 340.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 335.55 74.19 335.62 74.2 337.33 86.16 337.26 86.16 335.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 330.91 74.17 330.99 74.17 332.7 86.16 332.63 86.16 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 326.29 74.15 326.37 74.16 328.08 86.16 328 86.16 326.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 321.66 74.12 321.74 74.13 323.45 86.16 323.38 86.16 321.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 317.03 74.11 317.1 74.11 318.82 86.16 318.74 86.16 317.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 312.4 74.08 312.48 74.09 314.19 74.09 314.19 86.16 314.11 86.16 312.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 307.78 74.07 307.85 74.07 309.57 86.16 309.49 86.16 307.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 303.15 74.04 303.22 74.05 304.93 86.16 304.86 86.16 303.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 298.52 74.02 298.59 74.03 300.31 86.16 300.23 86.16 298.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 293.89 74 293.97 74 293.97 74.01 295.68 86.16 295.61 86.16 293.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.16 289.26 73.98 289.34 73.98 289.35 73.99 291.05 73.99 291.05 86.16 290.98 86.16 289.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "70.37 269.82 70.75 356.98 71.44 356.98 71.05 269.82 70.37 269.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "67.18 269.84 67.57 357 68.26 357 67.86 269.84 67.18 269.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "63.99 269.86 64.39 357.02 64.39 357.02 65.07 357.02 64.67 269.86 63.99 269.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "60.81 269.88 61.2 357.04 61.2 357.04 61.88 357.04 61.49 269.87 60.81 269.88"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 419.25,
    y: 353.96,
    width: 5.8,
    height: 2.06,
    transform: "translate(-1.03 1.23) rotate(-.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 419.23,
    y: 349.16,
    width: 5.8,
    height: 2.06,
    transform: "translate(-2.09 2.53) rotate(-.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M389.83,353.4c-.05-.03-.1-.06-.15-.07,0,0,0,0,0,0-.74.17-1.11,1.28-1.19,1.55,0,.03-.02.06-.02.07v2.06s2.28-.02,2.28-.02v-2.06c-.42-1-.69-1.38-.91-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M385.75,353.34c-.68.14-1.05,1.29-1.13,1.56,0,.03-.02.05-.02.06v2.07s2.28-.02,2.28-.02l-.02-2.06c-.51-1.28-.83-1.59-1.11-1.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "415.15 348.47 412.94 348.48 412.95 351.74 415.17 351.72 415.16 348.47 415.15 348.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "407.29 348.52 405.09 348.53 405.1 351.79 407.32 351.77 407.31 348.52 407.29 348.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "397.24 348.58 397.25 351.84 399.45 351.82 399.47 351.82 399.45 348.56 397.24 348.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 412.91,
    y: 341.73,
    width: 2.22,
    height: 3.26,
    transform: "translate(-1.87 2.27) rotate(-.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "425 341.6 424.99 339.54 419.22 339.58 419.18 339.58 419.2 341.64 419.22 341.64 425 341.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "407.29 345.04 407.28 341.77 405.06 341.79 405.07 345.05 405.08 345.05 406.77 345.04 407.29 345.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "397.24 345.1 399.44 345.08 399.42 341.82 397.21 341.83 397.22 345.1 397.24 345.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.57 336.81 424.98 336.8 424.97 334.75 419.17 334.78 419.17 336.84 419.24 336.84 424.57 336.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M386.6,340.7c-.3-.7-.59-1-.85-1.06-.03,0-.06-.01-.1-.01-.04,0-.08,0-.12.02-.15.05-.29.16-.41.32,0,.01-.02.03-.03.04-.03.04-.06.09-.09.14-.01.02-.02.04-.03.06-.01.02-.02.04-.03.06,0,0,0,0,0,0-.03.05-.05.1-.07.15-.01.03-.03.05-.04.08,0,.01-.01.03-.02.04,0,.02-.01.03-.02.05-.02.03-.03.07-.04.1,0,.02-.02.04-.02.06,0,.02-.02.03-.02.05-.02.05-.03.09-.05.13,0,.02-.01.03-.02.05,0,.01,0,.02-.01.03,0,0,0,0,0,.02-.01.04-.02.06-.03.09,0,.03-.02.05-.02.07-.01.04-.02.07-.02.08l.04,8.71h.38s.09,0,.09,0h.07s.06,0,.06,0h.11s.07,0,.07,0h.42s1.09-.01,1.09-.01h.02l-.07-8.71c-.07-.2-.14-.38-.21-.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.59 338.24 415.09 338.24 415.11 338.24 415.1 334.98 412.88 335 412.89 338.26 414.59 338.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 405.03,
    y: 335.04,
    width: 2.22,
    height: 3.26,
    transform: "translate(-1.83 2.23) rotate(-.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.95 332 424.95 329.95 419.14 329.98 419.15 332.04 419.19 332.04 424.95 332"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "415.07 328.24 415.04 328.24 412.85 328.25 412.86 331.51 415.08 331.5 415.07 328.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 405,
    y: 328.29,
    width: 2.22,
    height: 3.26,
    transform: "translate(-1.51 1.86) rotate(-.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.52 327.2 424.9 327.2 424.93 327.2 424.92 325.15 419.12 325.18 419.13 327.24 424.52 327.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "399.36 331.59 399.37 331.59 399.36 328.34 397.16 328.35 397.15 328.35 397.16 331.61 399.36 331.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M386.75,327.53c-.05-.14-.1-.27-.14-.38-.01-.03-.02-.05-.03-.08-.34-.82-.66-1.13-.94-1.15-.01,0-.02,0-.03,0-.05,0-.1.01-.15.03-.07.03-.14.07-.21.13,0,0-.02.02-.03.03-.03.03-.07.07-.1.11-.03.03-.06.06-.08.1-.01.02-.02.03-.03.05-.02.03-.04.06-.05.08,0,0-.01.02-.02.03-.02.03-.04.06-.05.09,0,0,0,.01,0,.02-.02.04-.04.08-.06.13-.02.04-.04.08-.06.12-.02.05-.04.1-.06.15,0,.01-.01.03-.02.04,0,.02-.02.05-.03.07h0s0,.02-.01.03c0,.02-.02.04-.02.06-.03.08-.05.15-.07.21,0,.02-.01.03-.01.05,0,.02-.01.03-.01.05,0,.03-.02.05-.02.06l.04,8.71h2.3s-.07-8.73-.07-8.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.5 322.41 424.91 322.4 424.9 320.35 419.1 320.38 419.1 322.44 419.17 322.44 424.5 322.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "407.19 321.55 404.98 321.56 404.96 321.56 404.98 324.82 407.2 324.8 407.19 321.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.89 317.6 424.88 315.55 419.07 315.58 419.09 317.64 419.12 317.64 424.89 317.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.49 318.01 415.02 318.01 415.01 314.75 412.8 314.77 412.78 314.77 412.8 318.03 414.49 318.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "406.65 318.06 407.17 318.06 407.15 314.81 404.93 314.82 404.95 318.07 406.65 318.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 419.06,
    y: 310.76,
    width: 5.8,
    height: 2.06,
    transform: "translate(-1.86 2.53) rotate(-.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M390.6,322.5l-.07-8.71c-.35-1.02-.69-1.47-.99-1.58-.05-.02-.11-.03-.16-.03-.04,0-.08,0-.12.02-.24.07-.44.33-.6.62-.03.05-.05.09-.07.14,0,0,0,0,0,0,0,.02-.02.04-.03.06,0,.02-.02.04-.03.06-.02.05-.04.1-.06.15-.01.03-.02.06-.03.09,0,0,0,.02-.01.02-.02.05-.03.09-.05.13-.06.18-.1.32-.11.34l.04,8.71,2.29-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 412.76,
    y: 308.02,
    width: 2.22,
    height: 3.26,
    transform: "translate(-1.42 1.9) rotate(-.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M384.85,322.53h.32s.07,0,.07,0h.42s1.09,0,1.09,0h.01l-.07-8.71c-.03-.1-.07-.19-.1-.28-.32-.82-.62-1.2-.88-1.3-.05-.02-.11-.03-.16-.03-.04,0-.07,0-.11.02,0,0-.01,0-.02,0h0s-.05.03-.08.05c-.03.02-.05.03-.08.04-.03.02-.06.04-.09.07-.04.03-.07.07-.1.11-.03.03-.05.06-.08.09-.03.04-.06.09-.09.14,0,.01-.01.02-.02.03-.02.03-.03.05-.05.08-.02.03-.04.07-.06.11,0,.02-.02.03-.02.05-.01.02-.02.04-.03.06,0,.02-.02.04-.03.05-.01.02-.02.05-.03.07-.01.03-.02.06-.04.09-.01.04-.03.07-.04.11,0,0,0,.02,0,.03-.09.23-.14.42-.15.45l.04,8.71h.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.85 308 424.84 305.94 419.03 305.99 419.04 308.04 424.43 308 424.85 308"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "407.13 308.06 404.92 308.08 404.9 308.08 404.92 311.33 407.14 311.32 407.13 308.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.41 303.2 424.83 303.2 424.81 301.14 419.01 301.18 419.02 303.24 419.06 303.24 424.41 303.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.94 301.27 412.72 301.29 412.74 304.54 414.96 304.52 414.94 301.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 404.88,
    y: 301.32,
    width: 2.22,
    height: 3.26,
    transform: "translate(-1.54 2.07) rotate(-.29)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "399.24 301.37 397.04 301.38 397.02 301.38 397.04 304.64 397.05 304.64 399.25 304.63 399.24 301.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.39 298.41 424.8 298.41 424.8 296.35 418.99 296.39 419 298.44 422.8 298.42 424.39 298.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M390.47,300.08c-.05-.14-.09-.26-.14-.38-.01-.03-.02-.05-.03-.08-.34-.82-.66-1.13-.94-1.15-.01,0-.02,0-.03,0-.03,0-.06,0-.09.01-.08.02-.15.06-.22.11-.02.01-.03.03-.05.05,0,0,0,0,0,0-.04.03-.07.06-.1.1-.02.02-.04.05-.06.07,0,0-.01.02-.02.02-.03.04-.06.09-.09.14,0,0-.01.02-.02.02-.02.03-.04.06-.05.09-.02.04-.04.08-.07.12,0,0,0,.02-.01.02,0,0,0,0,0,0-.02.04-.04.08-.06.13-.03.05-.05.11-.07.16-.01.03-.02.05-.03.08,0,0,0,.01,0,.02-.02.06-.04.11-.06.16,0,.02-.02.05-.03.07-.01.05-.03.08-.04.12,0,.02-.01.04-.02.05-.01.04-.02.07-.02.08l.04,8.71h2.29s-.07-8.73-.07-8.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 412.7,
    y: 294.53,
    width: 2.22,
    height: 3.26,
    transform: "translate(-1.6 2.25) rotate(-.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M384.4,308.83l2.3-.02-.07-8.71c-.05-.14-.1-.27-.14-.38-.01-.03-.02-.05-.03-.08-.34-.82-.66-1.13-.94-1.15-.01,0-.02,0-.04,0-.03,0-.05.01-.08.02-.03,0-.05,0-.08.02h0s-.1.05-.14.09c-.02.01-.04.03-.06.04-.01,0-.02.01-.03.02-.03.03-.07.07-.1.11-.03.03-.05.06-.08.09-.02.02-.03.04-.04.06-.02.02-.03.05-.05.07-.02.03-.04.06-.06.1,0,0,0,0,0,.01-.03.05-.05.1-.08.15-.01.03-.03.06-.04.09,0,0,0,.02-.01.02-.02.06-.05.11-.07.16-.01.03-.03.07-.04.1,0,.01,0,.03-.01.04-.01.04-.03.08-.04.11,0,.02-.02.05-.02.07-.01.05-.03.08-.04.11,0,.02-.01.04-.02.05-.01.04-.02.07-.02.08l.04,8.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "407.07 297.83 407.08 297.83 407.06 294.58 404.85 294.59 404.84 294.59 404.86 297.85 407.07 297.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.78 293.61 424.77 291.55 418.97 291.58 418.98 293.64 419.01 293.64 424.78 293.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "399.22 297.88 399.21 294.62 396.99 294.64 397.01 297.9 399.22 297.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.9 291.04 414.88 287.79 412.67 287.8 412.66 287.8 412.68 291.05 412.69 291.05 414.37 291.05 414.9 291.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.75 286.75 418.95 286.78 418.95 288.84 424.76 288.81 424.75 286.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "406.52 291.09 407.05 291.09 407.03 287.83 404.81 287.85 404.83 291.11 404.84 291.11 406.52 291.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 396.97,
    y: 287.89,
    width: 2.21,
    height: 3.26,
    transform: "translate(-1.57 2.18) rotate(-.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 412.64,
    y: 281.05,
    width: 2.22,
    height: 3.26,
    transform: "translate(-1.3 1.91) rotate(-.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M388.19,295.09h.38s.09,0,.09,0h.07s.06,0,.06,0h.6s1.11,0,1.11,0l-.08-8.71c-.05-.14-.09-.27-.14-.38-.01-.03-.02-.05-.03-.08-.34-.82-.66-1.13-.94-1.15-.01,0-.02,0-.04,0-.03,0-.06,0-.09.01-.15.04-.29.15-.42.3-.01.02-.03.04-.04.06-.03.04-.05.07-.08.11,0,0,0,.01-.01.02h0s-.05.08-.07.12c-.03.05-.05.1-.08.15-.02.04-.04.08-.06.11,0,0,0,0,0,0-.02.05-.04.1-.07.16,0,.02-.01.03-.02.05,0,.02-.02.04-.02.06-.02.05-.04.1-.05.15,0,.02-.01.03-.02.05,0,.01,0,.02-.01.03h0s-.02.06-.03.09c0,0,0,0,0,0-.02.06-.03.11-.04.14,0,0,0,.01,0,.02l.04,8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M384.81,295.11h1.81s-.07-8.72-.07-8.72c-.05-.14-.1-.27-.14-.38-.01-.03-.02-.05-.03-.08-.34-.82-.66-1.13-.94-1.15-.01,0-.02,0-.03,0-.05,0-.1.01-.15.03-.07.03-.14.07-.21.13,0,0-.02.02-.03.03-.03.03-.06.06-.09.09,0,0,0,0-.01.02-.03.03-.06.06-.08.1,0,0-.01.02-.02.03-.02.04-.05.07-.07.11-.02.03-.04.06-.06.09,0,0,0,.01-.01.02,0,0,0,0,0,0-.03.05-.05.1-.07.15,0,.01-.01.02-.01.03-.02.03-.03.06-.04.09-.02.05-.04.09-.05.13-.02.04-.04.08-.05.12-.02.05-.03.09-.05.13,0,.02-.01.04-.02.05,0,.01,0,.02-.01.03-.01.03-.02.06-.03.08,0,.03-.02.06-.02.08-.01.04-.02.07-.02.08l.04,8.71h.47s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "399.15 281.14 396.95 281.15 396.93 281.15 396.95 284.41 399.16 284.4 399.15 281.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.3 279.21 424.72 279.21 424.7 277.15 418.9 277.18 418.91 279.24 424.3 279.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.82 274.3 412.6 274.31 412.61 277.57 412.63 277.57 414.83 277.56 414.82 274.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.69 274.41 424.69 272.35 418.94 272.38 418.88 272.38 418.89 274.44 424.69 274.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "406.46 277.61 406.99 277.61 406.97 274.35 404.75 274.36 404.77 277.62 406.46 277.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 396.91,
    y: 274.4,
    width: 2.22,
    height: 3.26,
    transform: "translate(-1.32 1.91) rotate(-.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 418.86,
    y: 267.57,
    width: 5.8,
    height: 2.05,
    transform: "translate(-1.88 2.97) rotate(-.4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.8 270.82 414.79 267.55 412.57 267.57 412.58 270.83 412.59 270.83 412.69 270.83 414.8 270.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.64 262.75 424.6 262.75 418.83 262.79 418.85 264.85 424.65 264.8 424.64 262.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "406.4 264.12 406.92 264.12 406.91 260.87 404.69 260.88 404.7 264.13 406.4 264.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "399.05 260.91 396.84 260.93 396.85 264.18 399.08 264.17 399.05 260.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.74 257.33 414.74 255.68 414.73 254.07 412.51 254.08 412.52 255.69 412.52 257.34 412.53 258.96 414.75 258.94 414.74 257.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "404.67 257.39 404.68 259 406.9 258.99 406.89 257.37 406.88 255.73 406.88 254.12 404.66 254.14 404.67 255.74 404.67 257.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "396.82 257.44 396.83 259.05 398.76 259.03 399.05 259.03 399.04 257.42 399.03 255.78 399.03 254.17 396.81 254.18 396.81 255.79 396.82 257.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "418.76 246.46 418.77 248.39 418.77 248.39 418.76 246.45 418.17 246.46 418.76 246.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "393.78 356.96 393.78 356.97 393.29 251.07 393.78 356.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.71 252.2 414.72 252.2 414.71 250.58 414.71 248.94 414.7 247.33 414.68 247.33 412.48 247.35 412.49 248.95 412.5 250.6 412.5 252.21 414.44 252.2 414.71 252.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "406.86 250.63 406.85 248.99 406.85 247.38 404.63 247.39 404.64 249 404.64 250.64 404.65 252.26 406.87 252.25 406.86 250.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "399.01 250.69 399 249.04 399 247.42 396.8 247.44 396.78 247.44 396.78 249.05 396.79 250.7 396.8 252.31 399.02 252.29 399.01 250.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "409.02 356.87 409.02 356.87 408.5 242.18 409.02 356.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.68 243.84 414.68 242.19 414.67 240.59 412.45 240.6 412.46 242.21 412.47 243.85 412.47 245.47 414.69 245.46 414.68 243.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "400.31 242.23 400.83 356.92 400.31 242.23 400.31 242.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "406.83 243.89 406.82 242.25 406.82 240.63 404.6 240.65 404.61 242.26 404.61 243.9 404.62 245.52 406.84 245.5 406.83 243.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "396.76 243.96 396.77 245.56 398.71 245.55 398.99 245.55 398.98 243.94 398.97 242.3 398.97 240.68 396.75 240.69 396.75 242.31 396.76 243.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M411.3,356.85l15.83-.1v-101.57h-.29s-.02-3.92-.02-3.92l-.02-4.86h-2.23s0,1.94,0,1.94v.81s0,1.25,0,1.25v.81s.02,1.93.02,1.93v.81s0,1.25,0,1.25v.81s.01,1.93.01,1.93v.81s.01,1.25.01,1.25l-5.81.03h0v-1.25s0-.81,0-.81v-1.93s-.02-.81-.02-.81v-1.25s0-.81,0-.81v-1.93s-.01-.81-.01-.81v-1.25s0-.81,0-.81h0s-.01-1.93-.01-1.93h-.59s-.93.01-.93.01l-.02-3.92v-2.93s-2.71,0-2.71,0h-1.42s-15.68.13-15.68.13h-.02s-.79,0-.79,0h-.45s-2.16.02-2.16.02l.05,9.25-3.41.02.14,32.1s0,0,0,0c-.02,0-.04,0-.07,0h0s-.1,0-.17,0h0s-.09,0-.14.01c-.04,0-.08,0-.12.01-.08,0-.17.02-.27.03-.06,0-.12.02-.19.02h0s-.06,0-.09.01c0,0,0,0,0,0-.11.02-.23.03-.35.06-.03,0-.06,0-.09.02-.12.02-.25.05-.38.07-.02,0-.04,0-.07.01-.02,0-.04,0-.06.01t0,0s0,0,0,0c-.01,0-.03,0-.04.01-.02,0-.04,0-.05.01-.02,0-.04.01-.07.02s-.04.01-.07.02c0,0-.01,0-.02,0-.22.05-.44.11-.68.18-.23.07-.47.15-.71.24-.1.04-.19.07-.29.11-.3.12-.61.25-.92.4-.02.01-.04.02-.07.03h0s-.08.04-.12.06c-.16.08-.32.17-.47.26-.02.01-.04.02-.06.04-.02.01-.04.02-.05.03,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.03.02-.04.03-.02.01-.03.02-.05.03-.02.01-.04.02-.06.04-.03.02-.06.04-.08.06-.35.22-.69.47-1.02.75-.06.05-.12.1-.19.16-.24.21-.46.43-.69.67-.02.02-.03.04-.05.06-.2.22-.39.45-.57.69-.03.03-.05.07-.08.1-.19.26-.37.53-.54.82-.02.04-.04.08-.07.12-.15.27-.29.55-.42.84-.03.08-.07.15-.1.23-.13.3-.24.61-.34.94,0,0,0,0,0,.01-.02.07-.04.14-.06.22-.1.34-.19.69-.26,1.06-.02.1-.04.21-.05.31-.06.32-.1.66-.14,1.01,0,.08-.02.17-.03.25,0,.05,0,.1-.01.15-.04.45-.06.92-.06,1.42,0,.36.01.74.04,1.12l-2.55.02v3.77h1.14s0,.68,0,.68h-1.13v4.12h1.16s0,.68,0,.68h-1.16v8.92h1.2s0,.68,0,.68h-1.2v4.12h1.22s0,.68,0,.68h0s-1.23,0-1.23,0v4.11h1.24s0,.68,0,.68h0s-1.25,0-1.25,0v4.11h1.26s0,.67,0,.67h-1.27v4.12h1.29s0,.68,0,.68h0s-1.29,0-1.29,0v4.11h1.26s.05,0,.05,0v.69s-1.31,0-1.31,0v4.11h1.33s0,.67,0,.67h0s-1.33.01-1.33.01v4.11h1.35s0,.68,0,.68h-1.36v4.12h1.38s0,.68,0,.68h-1.38v4.12h1.39s0,.68,0,.68h-1.4v1.13l6.92-.04h0s-.01-2.06-.01-2.06h0s0-.03.01-.04c0,0,0-.01,0-.02.08-.27.46-1.42,1.13-1.56.28.02.6.33,1.11,1.61l.02,2.06h1.58s0-2.06,0-2.06h0s0-.03.02-.05c0,0,0,0,0-.02.08-.28.45-1.38,1.19-1.55,0,0,0,0,0,0,.03,0,.06.02.08.03.02,0,.04.02.06.03,0,0,.01,0,.01,0,.22.15.48.53.89,1.53v2.06h.01l3.04-.02h0s-.49-105.89-.49-105.89h1.03s.48,105.89.48,105.89h0s6.04-.04,6.04-.04h0l-.52-114.69h2.28s.52,114.68.52,114.68h0l5.91-.03h0s-.51-114.7-.51-114.7h0s2.27-.01,2.27-.01h.01l.51,114.69h0ZM425.07,356h0l-5.81.03h0v-2.06s5.79-.03,5.79-.03v2.06ZM425.04,351.2l-5.8.03v-2.06s5.8-.03,5.8-.03v2.06ZM425.02,346.4l-5.81.04h0s0-2.06,0-2.06h0s5.78-.04,5.78-.04h.02v2.06ZM425,341.6h-.41s-5.35.04-5.35.04h-.04s-.01-2.06-.01-2.06h.04s5.77-.04,5.77-.04v2.06ZM424.98,336.8h-.41s-5.33.03-5.33.03h-.07s0-2.06,0-2.06l5.8-.03.02,2.06ZM424.95,332h0l-5.77.03h-.03s-.01-2.06-.01-2.06h0l5.81-.03v2.06ZM424.93,327.2h-.41s-5.39.03-5.39.03h0s0-2.06,0-2.06h0l5.8-.03v2.06ZM424.91,322.4h-.41s-5.33.03-5.33.03h-.07s0-2.06,0-2.06l5.8-.03v2.06ZM424.89,317.6h0l-5.77.03h-.03s-.01-2.06-.01-2.06h0l5.81-.03v2.06ZM424.87,312.8l-5.81.03v-2.06h0l5.8-.03v2.06ZM424.85,308h0s-.41,0-.41,0l-5.39.03v-2.05s5.79-.04,5.79-.04v2.06ZM424.83,303.2h0s-.41,0-.41,0l-5.35.04h-.04s0-2.06,0-2.06l5.8-.04v2.06ZM424.8,298.41h0s-.41,0-.41,0l-5.39.03h0v-2.06h-.01l5.81-.03v2.06ZM424.78,293.61h0s-5.77.03-5.77.03h-.03s0-2.06,0-2.06h0l5.8-.03v2.06ZM424.76,288.81l-5.81.03h0s0-2.06,0-2.06l5.81-.03v2.06ZM424.73,284.01l-5.8.03v-2.06h0l5.8-.03v2.06ZM424.72,279.21h-.41s-5.39.03-5.39.03h0s0-2.06,0-2.06l5.8-.03v2.06ZM424.69,274.41h-.41s-5.39.03-5.39.03h0s-.01-2.06-.01-2.06h.07l5.74-.03v2.06ZM424.67,269.61l-5.81.03h0s0-2.05,0-2.05h0l5.8-.04v2.06ZM424.6,262.75h.04v2.06s-5.79.04-5.79.04h0s-.01-2.06-.01-2.06l5.77-.04ZM384.3,286.4h0s.01-.04.02-.08c0-.02.02-.05.02-.08,0-.02.01-.04.02-.06,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.02.01-.03,0-.02.01-.04.02-.05,0-.01,0-.02.01-.04.01-.03.02-.06.03-.09,0,0,0,0,0,0,.01-.04.03-.08.05-.12.02-.04.03-.09.05-.13.01-.03.03-.06.04-.09,0-.01.01-.02.02-.04.02-.05.05-.09.07-.14,0,0,0,0,0,0,0,0,0-.01.01-.02.02-.03.04-.06.06-.1.02-.04.05-.07.07-.11,0,0,.01-.02.02-.03.03-.03.05-.06.08-.1,0,0,0-.01.01-.02.03-.03.06-.07.09-.09,0,0,.02-.02.03-.03.07-.06.13-.1.21-.13.05-.02.1-.03.15-.03.01,0,.02,0,.03,0,.28.02.6.33.94,1.15.01.03.02.05.03.08.05.12.09.25.14.38l.07,8.71h-1.1s-.42,0-.42,0h-.07s-.06,0-.06,0h-.17s-.09,0-.09,0h-.39s-.04-8.71-.04-8.71ZM384.36,300.11h0s.01-.04.02-.08c0-.01.01-.03.02-.05,0-.03.02-.06.03-.1,0,0,0,0,0,0,.01-.04.03-.08.04-.12,0-.02.01-.04.02-.06,0-.01,0-.03.01-.04.01-.03.03-.06.04-.1,0,0,0-.01,0-.02.02-.05.04-.09.06-.14,0,0,0-.02.01-.02.01-.03.03-.06.04-.09,0,0,0,0,0,0,.02-.05.05-.1.07-.15,0,0,0,0,0-.01.02-.03.04-.06.06-.1.02-.03.03-.05.05-.07.01-.02.03-.04.04-.06.03-.04.05-.06.08-.1.03-.04.06-.08.1-.11.01,0,.02-.02.03-.02.02-.02.04-.03.06-.05.05-.03.09-.07.14-.09h0s.05-.01.08-.02c.03,0,.05-.01.08-.02.01,0,.02,0,.04,0,.28.02.6.33.94,1.15.01.02.02.05.03.08.05.12.09.25.14.38l.07,8.71h0l-2.3.02h0s-.04-8.71-.04-8.71ZM384.42,313.83s.06-.21.15-.45c0,0,0-.02,0-.03.01-.03.03-.07.04-.11.01-.03.02-.06.04-.09.01-.02.02-.05.03-.07,0-.02.02-.04.03-.06.01-.02.02-.04.03-.06,0-.02.02-.03.02-.05.02-.03.03-.07.05-.11.02-.03.03-.05.05-.08,0-.01.01-.02.02-.03.03-.05.06-.09.09-.14.03-.03.05-.06.08-.1.03-.04.07-.07.1-.11.03-.03.06-.05.09-.07.03-.02.05-.03.08-.04.03-.02.05-.04.08-.04t0,0h0s.01,0,.02,0c.03,0,.07-.02.11-.02.05,0,.11,0,.16.03.27.1.57.48.88,1.3.03.09.07.18.1.28l.07,8.71h-1.1s-.42,0-.42,0h-.07s-.06,0-.06,0h-.26s-.39,0-.39,0h0s-.04-8.71-.04-8.71ZM384.52,336.25h0s-.04-8.71-.04-8.71h0s0-.03.02-.06c0-.01,0-.03.01-.05,0-.02,0-.03.01-.05.02-.06.04-.13.07-.21,0,0,0,0,0-.01,0-.02.01-.04.02-.05,0-.01,0-.02.01-.03h0s.02-.05.03-.07c0-.02.02-.04.03-.06.02-.04.03-.08.05-.13,0,0,0,0,0,0,.02-.04.04-.08.06-.12,0,0,0,0,0,0,.02-.04.04-.08.06-.12,0,0,0-.01,0-.02.02-.03.04-.06.05-.09,0,0,.01-.02.02-.03.02-.03.04-.05.05-.08.01-.02.02-.03.03-.05.03-.03.05-.06.08-.1.03-.04.06-.08.1-.11,0,0,.02-.02.03-.03.07-.06.13-.1.21-.13.05-.02.1-.03.15-.03.01,0,.02,0,.03,0,.28.02.6.33.94,1.15.01.02.02.05.03.08.05.12.09.24.14.38l.07,8.71h-2.28s-.01.01-.01.01ZM386.86,349.95h-1.09s-.42.01-.42.01h-.07s-.06,0-.06,0h-.11s-.07,0-.07,0h-.47s0,0,0,0l-.04-8.71s.01-.04.02-.08c0-.02.01-.05.02-.07.01-.03.02-.06.03-.09,0,0,0,0,0-.02,0-.01,0-.02.01-.03,0-.02.01-.03.02-.05.02-.04.03-.08.05-.13,0-.02.01-.03.02-.05,0-.02.02-.04.03-.06.01-.03.03-.07.04-.1,0-.02.01-.03.02-.05,0-.01.01-.03.02-.04.01-.03.03-.05.04-.08.03-.05.05-.1.07-.15h0s.02-.04.03-.06c.01-.02.02-.04.03-.06.03-.05.06-.09.09-.14,0-.01.02-.03.03-.04.12-.15.26-.27.41-.32.04-.01.08-.02.12-.02.03,0,.06,0,.1.01.26.06.54.36.85,1.06.07.16.14.34.21.54l.07,8.71h-.02ZM388.14,286.37h0s0-.01,0-.02c0-.02.02-.07.04-.14,0,0,0,0,0,0,0-.03.02-.05.03-.09h0s0-.02.01-.04c0-.02.01-.04.02-.06.01-.04.03-.08.05-.13,0,0,0,0,0,0,0-.02.02-.04.02-.06,0-.02.01-.04.02-.05.02-.05.04-.1.06-.15h0s0-.01,0-.01c.02-.04.04-.07.06-.11.02-.05.05-.1.08-.15.02-.04.05-.08.07-.12h0s0-.01.01-.02c.02-.04.05-.08.08-.11.01-.02.03-.04.04-.06.12-.15.26-.27.42-.3.03,0,.06-.01.09-.01.01,0,.02,0,.04,0,.28.02.6.33.94,1.15.01.03.02.05.03.08.05.12.09.24.14.38l.08,8.71h-1.11s-.42,0-.42,0h-.18s-.06,0-.06,0h-.54s0,0,0,0l-.04-8.71ZM388.21,300.09h0s.01-.04.02-.08c0-.01.01-.03.02-.05,0-.02.01-.04.02-.07,0-.01,0-.02.01-.04.01-.04.03-.08.04-.12.01-.03.03-.07.04-.11,0,0,0,0,0,0,0,0,0-.01,0-.02.01-.03.03-.06.04-.1.02-.05.04-.09.06-.14h0s.04-.08.06-.13c0,0,0,0,0,0,0,0,0-.02.01-.02.02-.04.04-.08.06-.12.02-.03.04-.06.06-.09,0,0,.01-.02.02-.02,0,0,0,0,0,0,.03-.05.06-.09.09-.13h0s.01-.02.02-.02c.02-.03.04-.05.06-.07.03-.04.07-.07.1-.1,0,0,0,0,0,0,.02-.02.03-.03.05-.05.07-.05.14-.09.22-.11.03,0,.06-.01.09-.01.01,0,.02,0,.03,0,.28.02.6.33.94,1.15.01.03.02.05.03.08.05.12.09.24.14.38l.07,8.71h-2.29s-.04-8.7-.04-8.7ZM388.27,313.8s.04-.16.11-.34c.02-.04.03-.08.05-.13,0,0,0-.02.01-.02.01-.03.02-.06.04-.09.02-.05.04-.1.06-.15,0-.02.02-.04.03-.06.01-.02.02-.04.03-.06,0,0,0,0,0,0,.02-.05.04-.09.07-.14.16-.29.36-.55.6-.62.04-.01.08-.02.12-.02.05,0,.11,0,.16.03.3.11.63.56.99,1.58l.07,8.71h0s-1.1.01-1.1.01h-.42s-.07,0-.07,0h-.06s0,0,0,0h-.17s-.09,0-.09,0h-.38s0,0,0,0l-.04-8.71ZM388.33,327.51h0s0-.02.01-.04c0-.01,0-.02.01-.04,0-.01,0-.03.01-.04,0,0,0-.02,0-.02,0-.02.01-.03.02-.05,0-.02,0-.03.01-.05,0-.02.01-.03.02-.05,0,0,0-.02,0-.03,0,0,0,0,0-.01,0,0,0-.02,0-.03.01-.04.03-.08.04-.12,0,0,0,0,0,0t0,0s.01-.03.02-.04c0-.02.02-.05.03-.07.02-.05.04-.1.06-.15.02-.04.04-.08.06-.12.03-.05.05-.1.08-.15h0s0,0,0,0c.02-.04.04-.07.07-.11h0s.06-.1.09-.14c.01-.02.03-.04.05-.05.01-.01.02-.03.03-.04.03-.04.07-.07.11-.1.02-.02.03-.03.05-.05.07-.05.14-.09.22-.11.03,0,.06-.01.09-.01h.04c.28.02.6.33.94,1.15,0,.03.02.05.03.08.05.12.09.24.14.38l.07,8.71h-1.1s-.42,0-.42,0h-.3s-.09,0-.09,0h-.39s-.04-8.71-.04-8.71ZM388.43,349.94l-.04-8.71h0s0-.03.02-.06t0-.01s0-.02,0-.03c0,0,0,0,0-.01,0-.01.01-.03.01-.04,0-.02.01-.05.03-.08,0-.03.02-.06.03-.08,0-.01,0-.03.01-.04,0-.01,0-.02.01-.04,0-.02.01-.03.02-.05,0-.01.01-.03.02-.04.01-.03.02-.05.03-.08t0,0s0-.02.01-.03c.02-.04.03-.08.05-.12.02-.04.04-.08.06-.13.02-.05.04-.09.07-.14.02-.04.05-.08.07-.12.03-.05.06-.09.09-.13,0,0,.01-.02.02-.03.12-.15.25-.28.39-.33.05-.02.1-.03.15-.03.01,0,.02,0,.04,0,.28.02.6.33.94,1.15.01.02.02.05.03.08.05.12.09.24.14.38l.07,8.71-2.3.02ZM396.76,243.96v-1.65s-.01-1.61-.01-1.61h2.22s0,1.6,0,1.6v1.64s.02,1.61.02,1.61h-.28s-1.94.01-1.94.01h0s0-1.61,0-1.61ZM396.79,250.7v-1.65s-.01-1.61-.01-1.61h.02l2.2-.02v1.61s.01,1.65.01,1.65v1.61s-2.22.02-2.22.02h0s0-1.61,0-1.61ZM396.82,257.44v-1.64s-.01-1.61-.01-1.61h2.22s0,1.6,0,1.6v1.65s.01,1.61.01,1.61h-.29s-1.94.02-1.94.02h0s0-1.61,0-1.61ZM396.84,260.93l2.21-.02.02,3.26-2.22.02v-3.26ZM396.87,267.67h2.21s.02,3.24.02,3.24h0s-2.22.01-2.22.01l-.02-3.25ZM396.9,274.41h2.22s.02,3.24.02,3.24h0l-2.22.02v-3.26ZM396.93,281.15h.02l2.2-.02v3.26h.01-2.21s-.02-3.24-.02-3.24ZM396.98,291.15h0s-.01-3.25-.01-3.25h2.21s.01,3.24.01,3.24h-2.21ZM396.99,294.64h0l2.21-.02v3.25h.01-.53s-1.69.02-1.69.02h0s-.01-3.26-.01-3.26ZM397.04,304.64h0s-.01-3.26-.01-3.26h2.21s.01,3.24.01,3.24h-2.2s-.01.01-.01.01ZM397.05,308.12h0s2.21-.01,2.21-.01v3.26s0,0,0,0h-.51s-1.69.02-1.69.02h0s-.01-3.26-.01-3.26ZM397.12,321.61h2.21s.02,3.24.02,3.24h-.53s-1.69.01-1.69.01h0s-.01-3.26-.01-3.26ZM397.16,331.61h0s-.01-3.26-.01-3.26h2.21s.01,3.24.01,3.24h0s-.53,0-.53,0h-1.67s-.02.02-.02.02h0ZM397.18,335.1h0s2.21-.01,2.21-.01v3.25s.01,0,.01,0h-.53s-1.69.01-1.69.01h0s-.02-3.25-.02-3.25ZM397.21,341.83h2.21s.01,3.24.01,3.24h-.52s-1.69.02-1.69.02h0s-.01-3.26-.01-3.26ZM399.47,351.82l-2.21.02h0s-.01-3.26-.01-3.26h0l2.21-.02v3.25s.01,0,.01,0ZM404.61,243.9v-1.65s-.02-1.61-.02-1.61l2.22-.02v1.61s.01,1.65.01,1.65v1.61s-2.21.02-2.21.02v-1.61ZM404.64,250.65v-1.64s-.01-1.61-.01-1.61h2.22s0,1.6,0,1.6v1.65s.01,1.61.01,1.61h-2.21s-.01-1.6-.01-1.6ZM404.67,257.39v-1.65s-.01-1.61-.01-1.61l2.22-.02v1.61s.01,1.64.01,1.64v1.61s0,0,0,0h-2.21s0,0,0,0v-1.6ZM404.69,260.88h2.22s.01,3.24.01,3.24h0s-.52,0-.52,0h-1.7s0,0,0,0v-3.25ZM404.72,267.62h2.22s.01,3.24.01,3.24h-.53s-1.7.02-1.7.02h0s-.01-3.26-.01-3.26ZM404.75,274.36l2.22-.02v3.26h.01-.52s-1.7.01-1.7.01h0s-.01-3.26-.01-3.26ZM404.78,281.1h0s2.22-.01,2.22-.01v3.25s0,0,0,0h-.51s-1.7.01-1.7.01h0s-.01-3.26-.01-3.26ZM404.81,287.85l2.22-.02v3.26s.01,0,.01,0h-.53s-1.68.02-1.68.02h-.02s-.01-3.26-.01-3.26ZM404.84,294.59h2.22s.01,3.24.01,3.24h-2.22s0,0,0,0l-.02-3.25ZM404.87,301.33h2.22s.02,3.24.02,3.24h-2.22s-.01-3.24-.01-3.24ZM404.9,308.08h.02l2.2-.02v3.26h.01-.53s-1.7.01-1.7.01h0v-3.26ZM404.93,314.82h2.22s.01,3.24.01,3.24h-.52s-1.7.01-1.7.01h0s-.01-3.25-.01-3.25ZM404.98,324.82h0s-.01-3.25-.01-3.25h.02l2.2-.02.02,3.25-2.22.02h0ZM405,328.3l2.22-.02v3.26s-2.21.01-2.21.01h0s-.01-3.26-.01-3.26ZM405.04,338.3h0s-.01-3.25-.01-3.25h2.22s.01,3.24.01,3.24h-2.22ZM405.07,345.05h0s-.01-3.25-.01-3.25l2.22-.02v3.26h.01-.52s-1.69.01-1.69.01h-.01ZM405.1,351.79h0s-.02-3.26-.02-3.26h2.2s.02-.01.02-.01v3.26s-2.21.01-2.21.01ZM415.16,348.47l.02,3.25h0l-2.22.02-.02-3.26h2.21s.01-.01.01-.01ZM415.14,344.98h-2.22s0,0,0,0l-.02-3.25h2.22s.01,3.24.01,3.24ZM415.11,338.24h-.53s-1.7.02-1.7.02h0s-.01-3.25-.01-3.25l2.22-.02.02,3.26ZM415.08,331.5h-2.22s0,0,0,0l-.02-3.25h2.2s.02-.01.02-.01l.02,3.25ZM415.05,324.76h-2.22s0,.01,0,.01v-3.25h-.01,2.22s.01,3.24.01,3.24ZM415.02,318.01h-.52s-1.7.02-1.7.02h0s-.01-3.26-.01-3.26h2.22s.01,3.24.01,3.24ZM414.99,311.27h0s-.52,0-.52,0h-1.7s0,0,0,0l-.02-3.25h2.22s.01,3.24.01,3.24ZM414.96,304.52l-2.22.02v-3.25s2.21-.02,2.21-.02v3.25ZM414.93,297.78h-2.22s0,0,0,0v-3.25s-.01,0-.01,0h2.22s.01,3.24.01,3.24ZM414.9,291.04h0s-.52,0-.52,0h-1.69s-.01,0-.01,0h0s-.01-3.26-.01-3.26h2.22s.01,3.24.01,3.24ZM414.87,284.3h0s-.53,0-.53,0h-1.7s0,.01,0,.01v-3.26s2.21-.01,2.21-.01l.02,3.25ZM414.83,277.56h-2.21s-.01.01-.01.01h0s-.02-3.26-.02-3.26h2.22s.01,3.24.01,3.24ZM414.8,270.82h0s-.53,0-.53,0h-1.56s-.03,0-.03,0h-.1s-.01-3.25-.01-3.25h0l2.22-.02v3.26ZM414.74,255.68v1.65s.02,1.61.02,1.61l-2.22.02v-1.61s-.01-1.65-.01-1.65v-1.61s2.21-.01,2.21-.01v1.61ZM414.67,240.59v1.61s.01,1.65.01,1.65v1.61h.01-2.22s0-1.6,0-1.6v-1.64s-.02-1.61-.02-1.61h2.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "397.1 318.12 397.1 318.12 397.1 318.12 397.09 314.87 397.09 314.87 399.3 314.85 399.3 314.85 399.31 318.11 399.31 318.11 399.31 318.11 398.79 318.12 397.11 318.12 397.1 318.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "412.5 250.6 412.49 248.95 412.48 247.35 412.48 247.35 414.68 247.33 414.7 247.33 414.71 248.94 414.71 250.58 414.72 252.2 414.71 252.2 414.44 252.2 412.5 252.21 412.5 252.21 412.5 250.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "425.01 344.34 425.01 344.34 424.99 344.34 419.21 344.38 419.21 344.38 419.22 346.44 425.02 346.4 425.01 344.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M390.52,340.83s-.02-.05-.03-.08c-.34-.82-.66-1.13-.94-1.15-.01,0-.02,0-.04,0-.05,0-.1.01-.15.03-.15.05-.28.18-.39.33,0,0-.01.02-.02.03-.03.04-.06.09-.09.13-.02.04-.05.08-.07.11-.03.05-.05.1-.07.15-.02.04-.04.08-.06.12-.02.05-.04.1-.06.15t0,0s-.02.05-.03.08c0,.01,0,.02-.01.03-.01.03-.02.06-.04.1,0,.01,0,.03-.01.04-.01.03-.02.06-.03.08-.01.03-.02.05-.03.08,0,.01,0,.03-.01.04,0,0,0,0,0,.01,0,0,0,.02,0,.03t0,.01s-.01.06-.02.06l.04,8.71,2.3-.02-.07-8.71c-.05-.14-.1-.27-.14-.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "398.88 338.34 399.41 338.34 399.41 338.34 399.39 335.08 397.18 335.09 397.18 335.1 397.19 338.35 398.88 338.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M390.67,336.22l-.07-8.71c-.05-.14-.1-.26-.14-.38,0-.03-.02-.05-.03-.08-.34-.82-.66-1.13-.94-1.15h-.04s-.06,0-.09.01c-.08.02-.15.06-.22.11-.02.01-.03.03-.05.05-.04.03-.07.07-.11.1-.01.01-.02.03-.03.04-.02.02-.03.03-.04.05-.03.04-.06.09-.09.14h0s-.04.07-.07.11t0,0c-.03.05-.06.11-.08.16-.02.04-.04.07-.05.11-.03.06-.05.11-.07.17,0,.02-.01.04-.02.05,0,.01-.01.03-.02.04t0,0c-.02.05-.04.1-.05.15,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,.01,0,.03-.01.04-.01.04-.03.08-.04.11,0,0,0,.02,0,.02,0,.01,0,.03-.01.04,0,.02,0,.03-.01.04,0,.01-.01.03-.01.04l.04,8.71h2.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "415.04 321.5 412.82 321.51 412.82 321.51 412.83 324.77 415.05 324.76 415.04 321.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "397.14 324.86 399.34 324.85 399.33 321.6 397.12 321.61 397.12 321.61 397.13 324.86 397.14 324.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "399.31 318.11 399.31 318.11 399.3 314.85 399.3 314.85 397.09 314.87 397.1 318.12 397.11 318.12 398.79 318.11 399.31 318.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "398.76 311.37 399.27 311.37 399.28 311.37 399.27 308.11 397.05 308.12 397.05 308.12 397.07 311.38 398.76 311.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "424.73 281.95 418.93 281.98 418.93 281.98 418.93 284.04 424.73 284.01 424.73 281.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "406.49 284.35 407.01 284.35 407.02 284.35 407 281.09 404.78 281.1 404.78 281.1 404.8 284.36 406.49 284.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "406.43 270.87 406.96 270.86 406.94 267.6 404.72 267.62 404.72 267.62 404.73 270.88 406.43 270.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "399.11 270.91 399.08 267.66 399.08 267.66 396.87 267.67 396.89 270.92 399.11 270.91 399.11 270.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "414.76 264.07 414.77 264.07 414.76 260.81 414.76 260.81 412.54 260.83 412.55 264.08 414.76 264.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "394.32 251.06 393.29 251.07 393.78 356.97 394.8 356.96 394.32 251.06 394.32 251.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "410.78 242.16 410.78 242.16 410.77 242.16 408.5 242.18 408.5 242.18 409.02 356.87 411.3 356.85 411.3 356.85 410.78 242.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "402.59 242.22 402.59 242.22 400.31 242.23 400.83 356.92 403.11 356.91 403.11 356.91 402.59 242.22"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "75.06 265.22 65.16 265.29 65.16 265.28 65.16 265.29 75.06 265.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 115.43,
    y: 214.35,
    width: 1.82,
    height: 142.58,
    transform: "translate(-1.29 .53) rotate(-.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "111.92 214.38 112.57 356.96 111.93 214.38 111.92 214.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "105.55 214.42 106.2 357 105.55 214.42 105.55 214.42"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 102.69,
    y: 214.44,
    width: 0,
    height: 142.58,
    transform: "translate(-1.29 .47) rotate(-.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "128.13 210.16 120.7 210.21 120.71 212.42 120.71 212.42 120.71 212.42 111.7 212.47 111.7 212.47 111.68 210.27 96.73 210.36 96.8 226.82 94.69 226.83 94.69 226.83 94.69 228.42 94.7 229.23 94.74 237.33 94.73 238.14 94.75 240.41 94.75 241.23 94.79 249.33 94.79 250.14 94.8 252.41 94.81 253.23 94.85 261.33 94.85 261.33 94.53 261.33 94.53 264.42 94.85 264.42 94.9 273.32 94.85 273.33 94.53 273.33 94.53 276.42 94.91 276.41 94.95 285.33 94.95 285.33 94.53 285.33 94.53 288.41 94.96 288.41 95.01 297.33 94.53 297.33 94.53 300.41 95.02 300.41 95.06 309.32 94.59 309.33 94.53 309.33 94.53 312.41 95.04 312.41 95.07 312.41 95.12 321.32 94.65 321.33 94.53 321.33 94.53 324.42 95.12 324.41 95.17 333.32 94.53 333.32 94.53 336.41 95.18 336.41 95.22 345.32 95.19 345.32 94.76 345.33 94.53 345.33 94.53 348.41 95.23 348.41 95.28 357.06 99.83 357.03 99.18 214.46 99.18 214.46 101 214.45 101.64 357.03 101.64 357.03 103.01 357.02 103.01 357.01 102.36 214.44 102.37 214.44 104.19 214.43 104.83 357.01 106.2 357 106.2 357 105.55 214.42 105.55 214.42 107.37 214.41 107.37 214.41 108.02 356.99 108.02 356.99 109.38 356.98 108.74 214.4 110.56 214.39 111.2 356.97 111.2 356.97 112.57 356.96 111.92 214.38 111.93 214.38 111.93 214.38 113.75 214.37 114.39 356.95 115.76 356.94 115.76 356.94 115.11 214.36 116.93 214.35 117.58 356.93 118.94 356.92 118.94 356.92 118.3 214.34 120.12 214.33 120.76 356.91 122.13 356.9 121.48 214.32 121.48 214.32 123.29 214.31 123.31 214.31 123.95 356.89 123.95 356.89 125.32 356.88 125.32 356.88 124.67 214.3 126.49 214.29 127.14 356.87 128.8 356.86 128.13 210.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 124.99,
    y: 214.3,
    width: 1.82,
    height: 142.58,
    transform: "translate(-1.29 .57) rotate(-.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "123.31 214.31 123.29 214.31 121.48 214.32 121.48 214.32 122.13 356.9 123.95 356.89 123.31 214.31 123.31 214.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 118.62,
    y: 214.33,
    width: 1.82,
    height: 142.58,
    transform: "translate(-1.29 .54) rotate(-.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "111.93 214.38 111.93 214.38 112.57 356.96 114.39 356.95 113.75 214.37 111.93 214.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 109.06,
    y: 214.39,
    width: 1.82,
    height: 142.58,
    transform: "translate(-1.29 .5) rotate(-.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "107.37 214.41 105.55 214.42 106.2 357 108.02 356.99 107.37 214.41 107.37 214.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 102.69,
    y: 214.43,
    width: 1.82,
    height: 142.58,
    transform: "translate(-1.29 .47) rotate(-.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "99.18 214.46 99.18 214.46 99.83 357.03 101.64 357.03 101 214.45 99.18 214.46"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.98 357.04 137.39 351.42 139.38 351.42 137.97 357.04 135.98 357.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.97 354.24 137.38 348.62 137.39 351.42 135.98 357.04 135.97 354.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.96 354.24 137.97 357.04 135.98 357.04 135.97 354.24 137.96 354.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.96 354.24 139.37 348.62 139.38 351.42 137.97 357.04 137.96 354.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.97 354.24 137.38 348.62 139.37 348.62 137.96 354.24 135.97 354.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.36 357.05 148.77 351.43 150.76 351.43 149.35 357.05 147.36 357.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.35 354.24 148.76 348.62 148.77 351.43 147.36 357.05 147.35 354.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.97 351.55 137.38 345.93 139.36 345.93 137.95 351.55 135.97 351.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.35 354.24 148.76 348.62 150.75 348.62 149.34 354.24 147.35 354.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.34 354.24 149.35 357.05 147.36 357.05 147.35 354.24 149.34 354.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.34 354.24 150.75 348.62 150.76 351.43 149.35 357.05 149.34 354.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.96 348.74 137.37 343.12 137.38 345.93 135.97 351.55 135.96 348.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.77 358.48 177.18 352.86 177.18 353.83 175.77 359.45 175.77 358.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.96 348.74 137.37 343.12 139.36 343.12 137.95 348.74 135.96 348.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.95 348.74 139.36 343.12 139.36 345.93 137.95 351.55 137.95 348.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.95 348.74 137.95 351.55 135.97 351.55 135.96 348.74 137.95 348.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.35 351.55 148.76 345.93 150.74 345.93 149.33 351.55 147.35 351.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.77 358.48 177.18 352.86 186.68 352.86 185.27 358.48 175.77 358.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.27 358.48 185.27 359.45 175.77 359.45 175.77 358.48 185.27 358.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.27 358.48 186.68 352.86 186.68 353.83 185.27 359.45 185.27 358.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.34 348.75 148.75 343.13 148.76 345.93 147.35 351.55 147.34 348.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.95 346.15 137.36 340.53 139.35 340.53 137.94 346.15 135.95 346.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.33 348.75 149.33 351.55 147.35 351.55 147.34 348.75 149.33 348.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.33 348.75 150.74 343.13 150.74 345.93 149.33 351.55 149.33 348.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.34 348.75 148.75 343.13 150.74 343.13 149.33 348.75 147.34 348.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.75 353.71 177.16 348.09 177.17 350.13 175.76 355.75 175.75 353.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.76 355.75 177.17 350.13 186.67 350.13 185.26 355.75 175.76 355.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.94 343.34 137.35 337.72 137.36 340.53 135.95 346.15 135.94 343.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.93 343.34 139.34 337.72 139.35 340.53 137.94 346.15 137.93 343.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.93 343.34 137.94 346.15 135.95 346.15 135.94 343.34 137.93 343.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.94 343.34 137.35 337.72 139.34 337.72 137.93 343.34 135.94 343.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.33 346.15 148.74 340.53 150.73 340.53 149.32 346.15 147.33 346.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.26 353.71 186.67 348.09 186.67 350.13 185.26 355.75 185.26 353.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.75 353.71 177.16 348.09 186.67 348.09 185.26 353.71 175.75 353.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.26 353.71 185.26 355.75 175.76 355.75 175.75 353.71 185.26 353.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.67 356.45 194.08 350.83 197.73 350.83 196.32 356.45 192.67 356.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.32 343.34 148.73 337.72 148.74 340.53 147.33 346.15 147.32 343.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.93 340.74 137.34 335.12 139.33 335.12 137.92 340.74 135.93 340.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.31 343.34 149.32 346.15 147.33 346.15 147.32 343.34 149.31 343.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.31 343.34 150.72 337.72 150.73 340.53 149.32 346.15 149.31 343.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.32 343.34 148.73 337.72 150.72 337.72 149.31 343.34 147.32 343.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "200.02 356.45 201.43 350.83 205.07 350.83 203.66 356.45 200.02 356.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.66 353.38 194.07 347.76 194.08 350.83 192.67 356.45 192.66 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.74 348.95 177.15 343.33 177.16 345.36 175.75 350.98 175.74 348.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.75 350.98 177.16 345.36 186.66 345.37 185.25 350.99 175.75 350.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.31 353.38 196.32 356.45 192.67 356.45 192.66 353.38 196.31 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.66 353.38 194.07 347.76 197.72 347.76 196.31 353.38 192.66 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.31 353.38 197.72 347.76 197.73 350.83 196.32 356.45 196.31 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.93 337.93 137.34 332.31 137.34 335.12 135.93 340.74 135.93 337.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.37 356.45 208.78 350.83 212.42 350.83 211.01 356.45 207.37 356.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.91 337.93 139.32 332.31 139.33 335.12 137.92 340.74 137.91 337.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.93 337.93 137.34 332.31 139.32 332.31 137.91 337.93 135.93 337.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.91 337.93 137.92 340.74 135.93 340.74 135.93 337.93 137.91 337.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.31 340.74 148.72 335.12 150.71 335.12 149.3 340.74 147.31 340.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "200.01 353.38 201.42 347.76 201.43 350.83 200.02 356.45 200.01 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.24 348.95 185.25 350.99 175.75 350.98 175.74 348.95 185.24 348.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.24 348.95 186.65 343.33 186.66 345.37 185.25 350.99 185.24 348.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.74 348.95 177.15 343.33 186.65 343.33 185.24 348.95 175.74 348.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.65 353.38 205.06 347.76 205.07 350.83 203.66 356.45 203.65 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "200.01 353.38 201.42 347.76 205.06 347.76 203.65 353.38 200.01 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.65 350.83 194.06 345.21 197.71 345.21 196.3 350.83 192.65 350.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.36 353.38 208.77 347.76 208.78 350.83 207.37 356.45 207.36 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.31 337.93 148.72 332.31 148.72 335.12 147.31 340.74 147.31 337.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.92 335.34 137.33 329.72 139.32 329.72 137.91 335.34 135.92 335.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.29 337.93 149.3 340.74 147.31 340.74 147.31 337.93 149.29 337.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.31 337.93 148.72 332.31 150.7 332.31 149.29 337.93 147.31 337.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.29 337.93 150.7 332.31 150.71 335.12 149.3 340.74 149.29 337.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "211 353.38 212.41 347.76 212.42 350.83 211.01 356.45 211 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.36 353.38 208.77 347.76 212.41 347.76 211 353.38 207.36 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "211 353.38 211.01 356.45 207.37 356.45 207.36 353.38 211 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.73 344.18 177.14 338.56 177.14 340.6 175.73 346.22 175.73 344.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.73 346.22 177.14 340.6 186.64 340.6 185.23 346.22 175.73 346.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "200 350.83 201.41 345.21 205.05 345.21 203.64 350.83 200 350.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.64 347.77 194.05 342.15 194.06 345.21 192.65 350.83 192.64 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.29 347.77 197.7 342.15 197.71 345.21 196.3 350.83 196.29 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.64 347.77 194.05 342.15 197.7 342.15 196.29 347.77 192.64 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.29 347.77 196.3 350.83 192.65 350.83 192.64 347.77 196.29 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.91 332.53 137.32 326.91 137.33 329.72 135.92 335.34 135.91 332.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.9 332.53 137.91 335.34 135.92 335.34 135.91 332.53 137.9 332.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.91 332.53 137.32 326.91 139.31 326.91 137.9 332.53 135.91 332.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.9 332.53 139.31 326.91 139.32 329.72 137.91 335.34 137.9 332.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.3 335.34 148.71 329.72 150.7 329.72 149.29 335.34 147.3 335.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.35 350.83 208.76 345.21 212.4 345.21 210.99 350.83 207.35 350.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.23 344.18 186.64 338.56 186.64 340.6 185.23 346.22 185.23 344.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.23 344.18 185.23 346.22 175.73 346.22 175.73 344.18 185.23 344.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.73 344.18 177.14 338.56 186.64 338.56 185.23 344.18 175.73 344.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.99 347.77 201.4 342.15 201.41 345.21 200 350.83 199.99 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.99 347.77 201.4 342.15 205.04 342.15 203.63 347.77 199.99 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.63 347.77 203.64 350.83 200 350.83 199.99 347.77 203.63 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.63 347.77 205.04 342.15 205.05 345.21 203.64 350.83 203.63 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.63 345.21 194.04 339.59 197.7 339.59 196.29 345.21 192.63 345.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.34 347.77 208.75 342.15 208.76 345.21 207.35 350.83 207.34 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.29 332.53 148.7 326.91 148.71 329.72 147.3 335.34 147.29 332.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.71 339.41 177.12 333.79 177.13 335.83 175.72 341.45 175.71 339.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.9 329.76 137.31 324.14 139.3 324.14 137.89 329.76 135.9 329.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.28 332.53 150.69 326.91 150.7 329.72 149.29 335.34 149.28 332.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.28 332.53 149.29 335.34 147.3 335.34 147.29 332.53 149.28 332.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.29 332.53 148.7 326.91 150.69 326.91 149.28 332.53 147.29 332.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.72 341.45 177.13 335.83 186.63 335.83 185.22 341.45 175.72 341.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.98 347.77 212.39 342.15 212.4 345.21 210.99 350.83 210.98 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.98 347.77 210.99 350.83 207.35 350.83 207.34 347.77 210.98 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.34 347.77 208.75 342.15 212.39 342.15 210.98 347.77 207.34 347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.98 345.21 201.39 339.59 205.04 339.59 203.63 345.21 199.98 345.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.62 342.14 194.03 336.52 194.04 339.59 192.63 345.21 192.62 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.71 339.41 177.12 333.79 186.62 333.79 185.21 339.41 175.71 339.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.21 339.41 185.22 341.45 175.72 341.45 175.71 339.41 185.21 339.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.21 339.41 186.62 333.79 186.63 335.83 185.22 341.45 185.21 339.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.28 342.14 196.29 345.21 192.63 345.21 192.62 342.14 196.28 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.62 342.14 194.03 336.52 197.69 336.52 196.28 342.14 192.62 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.28 342.14 197.69 336.52 197.7 339.59 196.29 345.21 196.28 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.89 326.95 137.3 321.33 137.31 324.14 135.9 329.76 135.89 326.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.89 326.95 137.3 321.33 139.29 321.33 137.88 326.95 135.89 326.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.88 326.95 139.29 321.33 139.3 324.14 137.89 329.76 137.88 326.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.88 326.95 137.89 329.76 135.9 329.76 135.89 326.95 137.88 326.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.28 329.76 148.69 324.14 150.68 324.14 149.27 329.76 147.28 329.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.33 345.21 208.74 339.59 212.39 339.59 210.98 345.21 207.33 345.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.97 342.14 201.38 336.52 201.39 339.59 199.98 345.21 199.97 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.97 342.14 201.38 336.52 205.03 336.52 203.62 342.14 199.97 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.62 342.14 203.63 345.21 199.98 345.21 199.97 342.14 203.62 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.62 342.14 205.03 336.52 205.04 339.59 203.63 345.21 203.62 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.7 334.64 177.11 329.02 177.11 331.06 175.7 336.68 175.7 334.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.62 339.59 194.03 333.97 197.68 333.97 196.27 339.59 192.62 339.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.7 336.68 177.11 331.06 186.61 331.07 185.2 336.69 175.7 336.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.32 342.14 208.73 336.52 208.74 339.59 207.33 345.21 207.32 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.27 326.95 148.68 321.33 148.69 324.14 147.28 329.76 147.27 326.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.88 324.36 137.29 318.74 139.28 318.74 137.87 324.36 135.88 324.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.27 326.95 148.68 321.33 150.67 321.33 149.26 326.95 147.27 326.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.26 326.95 149.27 329.76 147.28 329.76 147.27 326.95 149.26 326.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.26 326.95 150.67 321.33 150.68 324.14 149.27 329.76 149.26 326.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.97 342.14 210.98 345.21 207.33 345.21 207.32 342.14 210.97 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.97 342.14 212.38 336.52 212.39 339.59 210.98 345.21 210.97 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.32 342.14 208.73 336.52 212.38 336.52 210.97 342.14 207.32 342.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.61 336.52 194.02 330.9 194.03 333.97 192.62 339.59 192.61 336.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.2 334.65 186.61 329.03 186.61 331.07 185.2 336.69 185.2 334.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.2 334.65 185.2 336.69 175.7 336.68 175.7 334.64 185.2 334.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.7 334.64 177.11 329.02 186.61 329.03 185.2 334.65 175.7 334.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.88 321.55 137.29 315.93 137.29 318.74 135.88 324.36 135.88 321.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.61 336.52 194.02 330.9 197.67 330.91 196.26 336.53 192.61 336.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.26 336.53 196.27 339.59 192.62 339.59 192.61 336.52 196.26 336.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.26 336.53 197.67 330.91 197.68 333.97 196.27 339.59 196.26 336.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.86 321.55 137.87 324.36 135.88 324.36 135.88 321.55 137.86 321.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.88 321.55 137.29 315.93 139.27 315.93 137.86 321.55 135.88 321.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.86 321.55 139.27 315.93 139.28 318.74 137.87 324.36 137.86 321.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.26 324.36 148.67 318.74 150.66 318.74 149.25 324.36 147.26 324.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.32 339.59 208.73 333.97 212.37 333.97 210.96 339.59 207.32 339.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.68 329.88 177.09 324.26 177.1 326.3 175.69 331.92 175.68 329.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.69 331.92 177.1 326.3 186.6 326.3 185.19 331.92 175.69 331.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.6 333.97 194.01 328.35 197.66 328.35 196.25 333.97 192.6 333.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.26 321.55 148.67 315.93 148.67 318.74 147.26 324.36 147.26 321.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.31 336.53 208.72 330.91 208.73 333.97 207.32 339.59 207.31 336.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.87 318.86 137.28 313.24 139.27 313.25 137.86 318.87 135.87 318.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.26 321.55 148.67 315.93 150.65 315.93 149.24 321.55 147.26 321.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.24 321.55 150.65 315.93 150.66 318.74 149.25 324.36 149.24 321.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.24 321.55 149.25 324.36 147.26 324.36 147.26 321.55 149.24 321.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.95 336.53 212.36 330.91 212.37 333.97 210.96 339.59 210.95 336.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.31 336.53 208.72 330.91 212.36 330.91 210.95 336.53 207.31 336.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.18 329.88 186.59 324.26 186.6 326.3 185.19 331.92 185.18 329.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.68 329.88 177.09 324.26 186.59 324.26 185.18 329.88 175.68 329.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.18 329.88 185.19 331.92 175.69 331.92 175.68 329.88 185.18 329.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.95 333.97 201.36 328.35 205 328.35 203.59 333.97 199.95 333.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.59 330.91 194 325.29 194.01 328.35 192.6 333.97 192.59 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.86 316.06 137.27 310.44 137.28 313.24 135.87 318.86 135.86 316.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.59 330.91 194 325.29 197.65 325.29 196.24 330.91 192.59 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.24 330.91 197.65 325.29 197.66 328.35 196.25 333.97 196.24 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.24 330.91 196.25 333.97 192.6 333.97 192.59 330.91 196.24 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.85 316.06 137.86 318.87 135.87 318.86 135.86 316.06 137.85 316.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.85 316.06 139.26 310.44 139.27 313.25 137.86 318.87 137.85 316.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.86 316.06 137.27 310.44 139.26 310.44 137.85 316.06 135.86 316.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.25 318.87 148.66 313.25 150.65 313.25 149.24 318.87 147.25 318.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.3 333.97 208.71 328.35 212.35 328.35 210.94 333.97 207.3 333.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.67 325.1 177.08 319.48 177.08 321.53 175.67 327.15 175.67 325.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.94 330.91 201.35 325.29 201.36 328.35 199.95 333.97 199.94 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.67 327.15 177.08 321.53 186.58 321.53 185.17 327.15 175.67 327.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.58 330.91 203.59 333.97 199.95 333.97 199.94 330.91 203.58 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.58 330.91 204.99 325.29 205 328.35 203.59 333.97 203.58 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.94 330.91 201.35 325.29 204.99 325.29 203.58 330.91 199.94 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.24 316.06 148.65 310.44 148.66 313.25 147.25 318.87 147.24 316.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.58 328.35 193.99 322.73 197.65 322.73 196.24 328.35 192.58 328.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.29 330.91 208.7 325.29 208.71 328.35 207.3 333.97 207.29 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.85 313.45 137.26 307.83 139.25 307.83 137.84 313.45 135.85 313.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.17 325.1 186.58 319.48 186.58 321.53 185.17 327.15 185.17 325.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.67 325.1 177.08 319.48 186.58 319.48 185.17 325.1 175.67 325.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.17 325.1 185.17 327.15 175.67 327.15 175.67 325.1 185.17 325.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.23 316.06 149.24 318.87 147.25 318.87 147.24 316.06 149.23 316.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.24 316.06 148.65 310.44 150.64 310.44 149.23 316.06 147.24 316.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.23 316.06 150.64 310.44 150.65 313.25 149.24 318.87 149.23 316.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.93 330.91 210.94 333.97 207.3 333.97 207.29 330.91 210.93 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.29 330.91 208.7 325.29 212.34 325.29 210.93 330.91 207.29 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.93 330.91 212.34 325.29 212.35 328.35 210.94 333.97 210.93 330.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.93 328.35 201.34 322.73 204.99 322.73 203.58 328.35 199.93 328.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.57 325.28 193.98 319.66 193.99 322.73 192.58 328.35 192.57 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.84 310.65 137.25 305.03 137.26 307.83 135.85 313.45 135.84 310.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.65 320.34 177.06 314.72 177.07 316.76 175.66 322.38 175.65 320.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.84 310.65 137.25 305.03 139.24 305.03 137.83 310.65 135.84 310.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.83 310.65 137.84 313.45 135.85 313.45 135.84 310.65 137.83 310.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.83 310.65 139.24 305.03 139.25 307.83 137.84 313.45 137.83 310.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.23 325.28 197.64 319.66 197.65 322.73 196.24 328.35 196.23 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.23 325.28 196.24 328.35 192.58 328.35 192.57 325.28 196.23 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.57 325.28 193.98 319.66 197.64 319.66 196.23 325.28 192.57 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.23 313.46 148.64 307.84 150.63 307.84 149.22 313.46 147.23 313.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.66 322.38 177.07 316.76 186.57 316.76 185.16 322.38 175.66 322.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.28 328.35 208.69 322.73 212.34 322.73 210.93 328.35 207.28 328.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.92 325.28 201.33 319.66 201.34 322.73 199.93 328.35 199.92 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.57 325.28 203.58 328.35 199.93 328.35 199.92 325.28 203.57 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.57 325.28 204.98 319.66 204.99 322.73 203.58 328.35 203.57 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.92 325.28 201.33 319.66 204.98 319.66 203.57 325.28 199.92 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.15 320.34 185.16 322.38 175.66 322.38 175.65 320.34 185.15 320.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.65 320.34 177.06 314.72 186.56 314.72 185.15 320.34 175.65 320.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.15 320.34 186.56 314.72 186.57 316.76 185.16 322.38 185.15 320.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.22 310.65 148.63 305.03 148.64 307.84 147.23 313.46 147.22 310.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.57 322.73 193.98 317.11 197.63 317.11 196.22 322.73 192.57 322.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.83 308.01 137.24 302.39 139.23 302.39 137.82 308.01 135.83 308.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.27 325.28 208.68 319.66 208.69 322.73 207.28 328.35 207.27 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.21 310.65 150.62 305.03 150.63 307.84 149.22 313.46 149.21 310.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.22 310.65 148.63 305.03 150.62 305.03 149.21 310.65 147.22 310.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.21 310.65 149.22 313.46 147.23 313.46 147.22 310.65 149.21 310.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.27 325.28 208.68 319.66 212.33 319.66 210.92 325.28 207.27 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.92 325.28 212.33 319.66 212.34 322.73 210.93 328.35 210.92 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.92 322.74 201.33 317.12 204.97 317.12 203.56 322.74 199.92 322.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.64 315.57 177.05 309.95 177.06 312 175.65 317.62 175.64 315.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.56 319.67 193.97 314.05 193.98 317.11 192.57 322.73 192.56 319.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.65 317.62 177.06 312 186.56 312 185.15 317.62 175.65 317.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.83 305.2 137.24 299.58 137.24 302.39 135.83 308.01 135.83 305.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.83 305.2 137.24 299.58 139.22 299.58 137.81 305.2 135.83 305.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.81 305.2 139.22 299.58 139.23 302.39 137.82 308.01 137.81 305.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.81 305.2 137.82 308.01 135.83 308.01 135.83 305.2 137.81 305.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.22 308.01 148.63 302.39 150.61 302.39 149.2 308.01 147.22 308.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.21 319.67 197.62 314.05 197.63 317.11 196.22 322.73 196.21 319.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.21 319.67 196.22 322.73 192.57 322.73 192.56 319.67 196.21 319.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.56 319.67 193.97 314.05 197.62 314.05 196.21 319.67 192.56 319.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.91 319.67 201.32 314.05 201.33 317.12 199.92 322.74 199.91 319.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.14 315.57 185.15 317.62 175.65 317.62 175.64 315.57 185.14 315.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.14 315.57 186.55 309.95 186.56 312 185.15 317.62 185.14 315.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.64 315.57 177.05 309.95 186.55 309.95 185.14 315.57 175.64 315.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.55 319.67 204.96 314.05 204.97 317.12 203.56 322.74 203.55 319.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.91 319.67 201.32 314.05 204.96 314.05 203.55 319.67 199.91 319.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.21 305.2 148.62 299.58 148.63 302.39 147.22 308.01 147.21 305.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.82 302.52 137.23 296.9 139.22 296.9 137.81 302.52 135.82 302.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.55 317.11 193.96 311.49 197.61 311.49 196.2 317.11 192.55 317.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.21 305.2 148.62 299.58 150.6 299.58 149.19 305.2 147.21 305.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.19 305.2 149.2 308.01 147.22 308.01 147.21 305.2 149.19 305.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.19 305.2 150.6 299.58 150.61 302.39 149.2 308.01 149.19 305.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.63 310.8 177.04 305.18 177.04 307.23 175.63 312.85 175.63 310.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.63 312.85 177.04 307.23 186.54 307.23 185.13 312.85 175.63 312.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.9 317.11 201.31 311.49 204.95 311.49 203.54 317.11 199.9 317.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.54 314.05 193.95 308.43 193.96 311.49 192.55 317.11 192.54 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.81 299.71 137.22 294.09 137.23 296.9 135.82 302.52 135.81 299.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.81 299.71 137.22 294.09 139.21 294.09 137.8 299.71 135.81 299.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.8 299.71 139.21 294.09 139.22 296.9 137.81 302.52 137.8 299.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.8 299.71 137.81 302.52 135.82 302.52 135.81 299.71 137.8 299.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.2 302.52 148.61 296.9 150.6 296.9 149.19 302.52 147.2 302.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.19 314.05 197.6 308.43 197.61 311.49 196.2 317.11 196.19 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.54 314.05 193.95 308.43 197.6 308.43 196.19 314.05 192.54 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.19 314.05 196.2 317.11 192.55 317.11 192.54 314.05 196.19 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.13 310.8 185.13 312.85 175.63 312.85 175.63 310.8 185.13 310.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.63 310.8 177.04 305.18 186.54 305.18 185.13 310.8 175.63 310.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.13 310.8 186.54 305.18 186.54 307.23 185.13 312.85 185.13 310.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.25 317.11 208.66 311.49 212.3 311.49 210.89 317.11 207.25 317.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.89 314.05 201.3 308.43 201.31 311.49 199.9 317.11 199.89 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.53 314.05 204.94 308.43 204.95 311.49 203.54 317.11 203.53 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.89 314.05 201.3 308.43 204.94 308.43 203.53 314.05 199.89 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.53 314.05 203.54 317.11 199.9 317.11 199.89 314.05 203.53 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.19 299.71 148.6 294.09 148.61 296.9 147.2 302.52 147.19 299.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.8 297.1 137.21 291.48 139.2 291.48 137.79 297.1 135.8 297.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.18 299.71 150.59 294.09 150.6 296.9 149.19 302.52 149.18 299.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.18 299.71 149.19 302.52 147.2 302.52 147.19 299.71 149.18 299.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.19 299.71 148.6 294.09 150.59 294.09 149.18 299.71 147.19 299.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.53 311.49 193.94 305.87 197.59 305.87 196.18 311.49 192.53 311.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.24 314.05 208.65 308.43 208.66 311.49 207.25 317.11 207.24 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.61 306.04 177.02 300.42 177.03 302.46 175.62 308.08 175.61 306.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.62 308.08 177.03 302.46 186.53 302.46 185.12 308.08 175.62 308.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.88 314.05 212.29 308.43 212.3 311.49 210.89 317.11 210.88 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.88 314.05 210.89 317.11 207.25 317.11 207.24 314.05 210.88 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.24 314.05 208.65 308.43 212.29 308.43 210.88 314.05 207.24 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.79 294.29 137.2 288.67 137.21 291.48 135.8 297.1 135.79 294.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.52 308.43 193.93 302.81 193.94 305.87 192.53 311.49 192.52 308.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.78 294.29 139.19 288.67 139.2 291.48 137.79 297.1 137.78 294.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.78 294.29 137.79 297.1 135.8 297.1 135.79 294.29 137.78 294.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.79 294.29 137.2 288.67 139.19 288.67 137.78 294.29 135.79 294.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.18 297.1 148.59 291.48 150.58 291.48 149.17 297.1 147.18 297.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.61 306.04 177.02 300.42 186.52 300.42 185.11 306.04 175.61 306.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.11 306.04 185.12 308.08 175.62 308.08 175.61 306.04 185.11 306.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.11 306.04 186.52 300.42 186.53 302.46 185.12 308.08 185.11 306.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.52 308.43 193.93 302.81 197.58 302.81 196.17 308.43 192.52 308.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.17 308.43 196.18 311.49 192.53 311.49 192.52 308.43 196.17 308.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.17 308.43 197.58 302.81 197.59 305.87 196.18 311.49 196.17 308.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.23 311.49 208.64 305.87 212.29 305.87 210.88 311.49 207.23 311.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.17 294.29 148.58 288.67 148.59 291.48 147.18 297.1 147.17 294.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.6 301.27 177.01 295.65 177.01 297.7 175.6 303.32 175.6 301.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.79 291.75 137.2 286.13 139.18 286.13 137.77 291.75 135.79 291.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.17 294.29 148.58 288.67 150.57 288.67 149.16 294.29 147.17 294.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.16 294.29 150.57 288.67 150.58 291.48 149.17 297.1 149.16 294.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.16 294.29 149.17 297.1 147.18 297.1 147.17 294.29 149.16 294.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.6 303.32 177.01 297.7 186.51 297.7 185.1 303.32 175.6 303.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.51 305.88 193.92 300.26 197.58 300.26 196.17 305.88 192.51 305.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.22 308.43 208.63 302.81 208.64 305.87 207.23 311.49 207.22 308.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.87 308.43 212.28 302.81 212.29 305.87 210.88 311.49 210.87 308.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.87 308.43 210.88 311.49 207.23 311.49 207.22 308.43 210.87 308.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.22 308.43 208.63 302.81 212.28 302.81 210.87 308.43 207.22 308.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.78 288.94 137.19 283.32 137.2 286.13 135.79 291.75 135.78 288.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.1 301.27 185.1 303.32 175.6 303.32 175.6 301.27 185.1 301.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.1 301.27 186.51 295.65 186.51 297.7 185.1 303.32 185.1 301.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.6 301.27 177.01 295.65 186.51 295.65 185.1 301.27 175.6 301.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.86 305.88 201.27 300.26 204.92 300.26 203.51 305.88 199.86 305.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.51 302.81 193.92 297.19 193.92 300.26 192.51 305.88 192.51 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.77 288.94 137.77 291.75 135.79 291.75 135.78 288.94 137.77 288.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.77 288.94 139.18 283.32 139.18 286.13 137.77 291.75 137.77 288.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.78 288.94 137.19 283.32 139.18 283.32 137.77 288.94 135.78 288.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.17 291.75 148.58 286.13 150.56 286.13 149.15 291.75 147.17 291.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.51 302.81 193.92 297.19 197.57 297.19 196.16 302.81 192.51 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.16 302.81 196.17 305.88 192.51 305.88 192.51 302.81 196.16 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.16 302.81 197.57 297.19 197.58 300.26 196.17 305.88 196.16 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.21 305.88 208.62 300.26 212.27 300.26 210.86 305.88 207.21 305.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.86 302.81 201.27 297.19 201.27 300.26 199.86 305.88 199.86 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.58 296.5 176.99 290.88 177 292.93 175.59 298.55 175.58 296.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.59 298.55 177 292.93 186.5 292.93 185.09 298.55 175.59 298.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.16 288.94 148.57 283.32 148.58 286.13 147.17 291.75 147.16 288.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.86 302.81 201.27 297.19 204.91 297.19 203.5 302.81 199.86 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.5 302.81 204.91 297.19 204.92 300.26 203.51 305.88 203.5 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.5 302.81 203.51 305.88 199.86 305.88 199.86 302.81 203.5 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.77 286.26 137.18 280.64 139.17 280.64 137.76 286.26 135.77 286.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.15 288.94 150.56 283.32 150.56 286.13 149.15 291.75 149.15 288.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.16 288.94 148.57 283.32 150.56 283.32 149.15 288.94 147.16 288.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.15 288.94 149.15 291.75 147.17 291.75 147.16 288.94 149.15 288.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.5 300.25 193.91 294.63 197.56 294.63 196.15 300.25 192.5 300.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.21 302.81 208.62 297.19 208.62 300.26 207.21 305.88 207.21 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.08 296.5 186.49 290.88 186.5 292.93 185.09 298.55 185.08 296.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.08 296.5 185.09 298.55 175.59 298.55 175.58 296.5 185.08 296.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.58 296.5 176.99 290.88 186.49 290.88 185.08 296.5 175.58 296.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.21 302.81 208.62 297.19 212.26 297.19 210.85 302.81 207.21 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.85 302.81 212.26 297.19 212.27 300.26 210.86 305.88 210.85 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.76 283.44 137.17 277.82 137.18 280.64 135.77 286.26 135.76 283.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.85 300.25 201.26 294.63 204.9 294.63 203.49 300.25 199.85 300.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.75 283.44 139.16 277.82 139.17 280.64 137.76 286.26 137.75 283.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.75 283.44 137.76 286.26 135.77 286.26 135.76 283.44 137.75 283.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.76 283.44 137.17 277.82 139.16 277.82 137.75 283.44 135.76 283.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.49 297.19 193.9 291.57 193.91 294.63 192.5 300.25 192.49 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.15 286.26 148.56 280.64 150.55 280.64 149.14 286.26 147.15 286.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.49 297.19 193.9 291.57 197.55 291.57 196.14 297.19 192.49 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.14 297.19 196.15 300.25 192.5 300.25 192.49 297.19 196.14 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.14 297.19 197.55 291.57 197.56 294.63 196.15 300.25 196.14 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.57 291.74 176.98 286.12 176.98 288.16 175.57 293.78 175.57 291.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.57 293.78 176.98 288.16 186.48 288.16 185.07 293.78 175.57 293.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.2 300.25 208.61 294.63 212.25 294.63 210.84 300.25 207.2 300.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.84 297.19 201.25 291.57 201.26 294.63 199.85 300.25 199.84 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.14 283.44 148.55 277.82 148.56 280.64 147.15 286.26 147.14 283.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.75 280.77 137.16 275.15 139.15 275.15 137.74 280.77 135.75 280.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.84 297.19 201.25 291.57 204.89 291.57 203.48 297.19 199.84 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.48 297.19 204.89 291.57 204.9 294.63 203.49 300.25 203.48 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.48 297.19 203.49 300.25 199.85 300.25 199.84 297.19 203.48 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.14 283.44 148.55 277.82 150.54 277.82 149.13 283.44 147.14 283.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.13 283.44 149.14 286.26 147.15 286.26 147.14 283.44 149.13 283.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.13 283.44 150.54 277.82 150.55 280.64 149.14 286.26 149.13 283.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.48 294.63 193.89 289.01 197.54 289.01 196.13 294.63 192.48 294.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.57 291.74 176.98 286.12 186.48 286.12 185.07 291.74 175.57 291.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.07 291.74 186.48 286.12 186.48 288.16 185.07 293.78 185.07 291.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.07 291.74 185.07 293.78 175.57 293.78 175.57 291.74 185.07 291.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.19 297.19 208.6 291.57 208.61 294.63 207.2 300.25 207.19 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.83 297.19 210.84 300.25 207.2 300.25 207.19 297.19 210.83 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.83 297.19 212.24 291.57 212.25 294.63 210.84 300.25 210.83 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.19 297.19 208.6 291.57 212.24 291.57 210.83 297.19 207.19 297.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.74 277.95 137.15 272.33 137.16 275.15 135.75 280.77 135.74 277.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.83 294.64 201.24 289.02 204.88 289.02 203.47 294.64 199.83 294.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.73 277.95 139.14 272.33 139.15 275.15 137.74 280.77 137.73 277.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.73 277.95 137.74 280.77 135.75 280.77 135.74 277.95 137.73 277.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.74 277.95 137.15 272.33 139.14 272.33 137.73 277.95 135.74 277.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.13 280.77 148.54 275.15 150.53 275.15 149.12 280.77 147.13 280.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.47 291.58 193.88 285.96 193.89 289.01 192.48 294.63 192.47 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.55 286.97 176.96 281.35 176.97 283.4 175.56 289.02 175.55 286.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.56 289.02 176.97 283.4 186.47 283.4 185.06 289.02 175.56 289.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.12 291.58 197.53 285.96 197.54 289.01 196.13 294.63 196.12 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.47 291.58 193.88 285.96 197.53 285.96 196.12 291.58 192.47 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.12 291.58 196.13 294.63 192.48 294.63 192.47 291.58 196.12 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.18 294.64 208.59 289.02 212.23 289.02 210.82 294.64 207.18 294.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.82 291.58 201.23 285.96 201.24 289.02 199.83 294.64 199.82 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.12 277.95 148.53 272.33 148.54 275.15 147.13 280.77 147.12 277.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.74 275.27 137.15 269.65 139.13 269.65 137.72 275.27 135.74 275.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.11 277.95 150.52 272.33 150.53 275.15 149.12 280.77 149.11 277.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.12 277.95 148.53 272.33 150.52 272.33 149.11 277.95 147.12 277.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.11 277.95 149.12 280.77 147.13 280.77 147.12 277.95 149.11 277.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.05 286.97 186.46 281.35 186.47 283.4 185.06 289.02 185.05 286.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.55 286.97 176.96 281.35 186.46 281.35 185.05 286.97 175.55 286.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.05 286.97 185.06 289.02 175.56 289.02 175.55 286.97 185.05 286.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.47 291.58 204.88 285.96 204.88 289.02 203.47 294.64 203.47 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.47 291.58 203.47 294.64 199.83 294.64 199.82 291.58 203.47 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.82 291.58 201.23 285.96 204.88 285.96 203.47 291.58 199.82 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.46 289.02 193.87 283.4 197.53 283.4 196.12 289.02 192.46 289.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.17 291.58 208.58 285.96 208.59 289.02 207.18 294.64 207.17 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.17 291.58 208.58 285.96 212.23 285.96 210.82 291.58 207.17 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.82 291.58 212.23 285.96 212.23 289.02 210.82 294.64 210.82 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.82 291.58 210.82 294.64 207.18 294.64 207.17 291.58 210.82 291.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.73 272.46 137.14 266.84 137.15 269.65 135.74 275.27 135.73 272.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.54 282.2 176.95 276.58 176.96 278.63 175.55 284.25 175.54 282.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.81 289.02 201.22 283.4 204.87 283.4 203.46 289.02 199.81 289.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.72 272.46 137.72 275.27 135.74 275.27 135.73 272.46 137.72 272.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.73 272.46 137.14 266.84 139.13 266.84 137.72 272.46 135.73 272.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.72 272.46 139.13 266.84 139.13 269.65 137.72 275.27 137.72 272.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.12 275.27 148.53 269.65 150.51 269.65 149.1 275.27 147.12 275.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.55 284.25 176.96 278.63 186.46 278.63 185.05 284.25 175.55 284.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.45 285.95 193.86 280.33 193.87 283.4 192.46 289.02 192.45 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.11 285.95 197.52 280.33 197.53 283.4 196.12 289.02 196.11 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.11 285.95 196.12 289.02 192.46 289.02 192.45 285.95 196.11 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.45 285.95 193.86 280.33 197.52 280.33 196.11 285.95 192.45 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.16 289.02 208.57 283.4 212.22 283.4 210.81 289.02 207.16 289.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.8 285.95 201.21 280.33 201.22 283.4 199.81 289.02 199.8 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.04 282.2 186.45 276.58 186.46 278.63 185.05 284.25 185.04 282.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.54 282.2 176.95 276.58 186.45 276.58 185.04 282.2 175.54 282.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.04 282.2 185.05 284.25 175.54 284.25 175.54 282.2 185.04 282.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.11 272.46 148.52 266.84 148.53 269.65 147.12 275.27 147.11 272.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.72 269.78 137.13 264.16 139.12 264.16 137.71 269.78 135.72 269.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.11 272.46 148.52 266.84 150.51 266.84 149.1 272.46 147.11 272.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.1 272.46 150.51 266.84 150.51 269.65 149.1 275.27 149.1 272.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.1 272.46 149.1 275.27 147.12 275.27 147.11 272.46 149.1 272.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.45 285.95 204.86 280.33 204.87 283.4 203.46 289.02 203.45 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.45 285.95 203.46 289.02 199.81 289.02 199.8 285.95 203.45 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.8 285.95 201.21 280.33 204.86 280.33 203.45 285.95 199.8 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.45 283.4 193.86 277.78 197.51 277.78 196.1 283.4 192.45 283.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.15 285.95 208.56 280.33 208.57 283.4 207.16 289.02 207.15 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.52 277.43 176.93 271.81 176.94 273.86 175.53 279.48 175.52 277.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.53 279.48 176.94 273.86 186.44 273.86 185.03 279.48 175.53 279.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.15 285.95 208.56 280.33 212.21 280.33 210.8 285.95 207.15 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.8 285.95 212.21 280.33 212.22 283.4 210.81 289.02 210.8 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.71 266.97 137.12 261.35 137.13 264.16 135.72 269.78 135.71 266.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "137.7 266.97 139.11 261.35 139.12 264.16 137.71 269.78 137.7 266.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "135.71 266.97 137.12 261.35 139.11 261.35 137.7 266.97 135.71 266.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "137.7 266.97 137.71 269.78 135.72 269.78 135.71 266.97 137.7 266.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.1 269.78 148.51 264.16 150.5 264.16 149.09 269.78 147.1 269.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "213.56 285.7 214.97 280.08 215.19 353.84 213.78 359.46 213.56 285.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.44 280.33 193.85 274.71 193.86 277.78 192.45 283.4 192.44 280.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "213.56 285.7 214.97 280.08 216.3 280.08 214.89 285.7 213.56 285.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "214.89 285.7 216.3 280.08 216.52 353.84 215.11 359.46 214.89 285.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.44 280.33 193.85 274.71 197.5 274.71 196.09 280.33 192.44 280.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.09 280.33 197.5 274.71 197.51 277.78 196.1 283.4 196.09 280.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.09 280.33 196.1 283.4 192.45 283.4 192.44 280.33 196.09 280.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "175.52 277.43 176.93 271.81 186.43 271.82 185.02 277.44 175.52 277.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "185.02 277.44 186.43 271.82 186.44 273.86 185.03 279.48 185.02 277.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "185.02 277.44 185.03 279.48 175.53 279.48 175.52 277.43 185.02 277.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.15 283.4 208.56 277.78 212.2 277.78 210.79 283.4 207.15 283.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.09 266.97 148.5 261.35 148.51 264.16 147.1 269.78 147.09 266.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "149.08 266.97 149.09 269.78 147.1 269.78 147.09 266.97 149.08 266.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.09 266.97 148.5 261.35 150.49 261.35 149.08 266.97 147.09 266.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "149.08 266.97 150.49 261.35 150.5 264.16 149.09 269.78 149.08 266.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.43 277.78 193.84 272.16 197.49 272.16 196.08 277.78 192.43 277.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.52 274.89 176.93 269.27 186.32 269.27 184.91 274.89 175.52 274.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.14 280.34 208.55 274.72 208.56 277.78 207.15 283.4 207.14 280.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.78 280.34 212.19 274.72 212.2 277.78 210.79 283.4 210.78 280.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.14 280.34 208.55 274.72 212.19 274.72 210.78 280.34 207.14 280.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.78 280.34 210.79 283.4 207.15 283.4 207.14 280.34 210.78 280.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.78 277.78 201.19 272.16 204.83 272.16 203.42 277.78 199.78 277.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.42 274.72 193.83 269.1 193.84 272.16 192.43 277.78 192.42 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.07 274.72 196.08 277.78 192.43 277.78 192.42 274.72 196.07 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.42 274.72 193.83 269.1 197.48 269.1 196.07 274.72 192.42 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.07 274.72 197.48 269.1 197.49 272.16 196.08 277.78 196.07 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.13 277.78 208.54 272.16 212.18 272.16 210.77 277.78 207.13 277.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "156.03 263.81 157.44 258.19 157.73 353.83 156.32 359.45 156.03 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.77 274.72 201.18 269.1 201.19 272.16 199.78 277.78 199.77 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "156.91 263.81 158.32 258.19 158.61 353.83 157.2 359.45 156.91 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "156.03 263.81 157.44 258.19 158.32 258.19 156.91 263.81 156.03 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "160.01 263.81 161.42 258.19 161.71 353.83 160.3 359.45 160.01 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.41 274.72 203.42 277.78 199.78 277.78 199.77 274.72 203.41 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.77 274.72 201.18 269.1 204.82 269.1 203.41 274.72 199.77 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.41 274.72 204.82 269.1 204.83 272.16 203.42 277.78 203.41 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "160.01 263.81 161.42 258.19 162.31 258.19 160.9 263.81 160.01 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "160.9 263.81 162.31 258.19 162.6 353.83 161.19 359.45 160.9 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.41 272.16 193.82 266.54 197.48 266.54 196.07 272.16 192.41 272.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.12 274.72 208.53 269.1 208.54 272.16 207.13 277.78 207.12 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "163.99 263.81 165.4 258.19 165.69 353.83 164.28 359.45 163.99 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "164.88 263.81 166.29 258.19 166.58 353.83 165.17 359.45 164.88 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "163.99 263.81 165.4 258.19 166.29 258.19 164.88 263.81 163.99 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.76 274.72 210.77 277.78 207.13 277.78 207.12 274.72 210.76 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.76 274.72 212.17 269.1 212.18 272.16 210.77 277.78 210.76 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.12 274.72 208.53 269.1 212.17 269.1 210.76 274.72 207.12 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "167.97 263.81 169.38 258.19 169.67 353.83 168.26 359.45 167.97 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.49 265.68 176.9 260.06 176.93 269.27 175.52 274.89 175.49 265.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "168.85 263.81 170.26 258.19 170.55 353.83 169.14 359.45 168.85 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "167.97 263.81 169.38 258.19 170.26 258.19 168.85 263.81 167.97 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.76 272.16 201.17 266.54 204.82 266.54 203.41 272.16 199.76 272.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.4 269.09 193.81 263.47 193.82 266.54 192.41 272.16 192.4 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.4 269.09 193.81 263.47 197.47 263.47 196.06 269.09 192.4 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.06 269.09 197.47 263.47 197.48 266.54 196.07 272.16 196.06 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.06 269.09 196.07 272.16 192.41 272.16 192.4 269.09 196.06 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "184.88 265.68 186.29 260.06 186.32 269.27 184.91 274.89 184.88 265.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.11 272.16 208.52 266.54 212.17 266.54 210.76 272.16 207.11 272.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.75 269.09 201.16 263.47 201.17 266.54 199.76 272.16 199.75 269.09"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M175.49,265.68l1.41-5.62c.59-.6,1.2-1.03,1.81-1.32l-1.41,5.62c-.61.3-1.22.73-1.81,1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M177.3,264.36l1.41-5.62c.27-.13.53-.23.8-.31l-1.41,5.62c-.26.08-.53.19-.8.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M178.09,264.05l1.41-5.62c.23-.07.45-.12.68-.16l-1.41,5.62c-.22.04-.45.09-.68.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M178.77,263.88l1.41-5.62c.22-.04.44-.06.66-.08l-1.41,5.62c-.22.01-.44.04-.66.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M179.43,263.81l1.41-5.62c.12,0,.24-.01.36-.01l-1.41,5.62c-.12,0-.24,0-.36.01"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.75 269.09 201.16 263.47 204.81 263.47 203.4 269.09 199.75 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.4 269.09 203.41 272.16 199.76 272.16 199.75 269.09 203.4 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.4 269.09 204.81 263.47 204.82 266.54 203.41 272.16 203.4 269.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M179.79,263.8c2.78,0,4.98,1.79,5.1,1.89l.03,9.2h-9.39s-.03-9.2-.03-9.2c1.4-1.42,2.91-1.89,4.3-1.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M179.79,263.8l1.41-5.62c.12,0,.23,0,.35,0l-1.41,5.62c-.11,0-.23,0-.35,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M180.13,263.8l1.41-5.62c.27.01.54.05.8.09l-1.41,5.62c-.26-.04-.53-.08-.8-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.93,263.89l1.41-5.62c.33.06.66.14.96.23l-1.41,5.62c-.3-.09-.63-.17-.96-.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M181.89,264.12l1.41-5.62c.48.15.92.33,1.3.51l-1.41,5.62c-.39-.19-.82-.37-1.3-.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.2,264.64l1.41-5.62c.99.48,1.62,1,1.68,1.05l-1.41,5.62c-.06-.05-.69-.57-1.68-1.05"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.4 266.54 193.81 260.92 197.46 260.92 196.05 266.54 192.4 266.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.1 269.09 208.51 263.47 208.52 266.54 207.11 272.16 207.1 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.75 269.09 210.76 272.16 207.11 272.16 207.1 269.09 210.75 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.1 269.09 208.51 263.47 212.16 263.47 210.75 269.09 207.1 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.75 269.09 212.16 263.47 212.17 266.54 210.76 272.16 210.75 269.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.75 266.54 201.16 260.92 204.8 260.92 203.39 266.54 199.75 266.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.39 263.48 193.8 257.86 193.81 260.92 192.4 266.54 192.39 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.39 263.48 193.8 257.86 197.45 257.86 196.04 263.48 192.39 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.04 263.48 197.45 257.86 197.46 260.92 196.05 266.54 196.04 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.04 263.48 196.05 266.54 192.4 266.54 192.39 263.48 196.04 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.1 266.55 208.51 260.93 212.15 260.93 210.74 266.55 207.1 266.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.74 263.48 201.15 257.86 201.16 260.92 199.75 266.54 199.74 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.74 263.48 201.15 257.86 204.79 257.86 203.38 263.48 199.74 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.38 263.48 203.39 266.54 199.75 266.54 199.74 263.48 203.38 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.38 263.48 204.79 257.86 204.8 260.92 203.39 266.54 203.38 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.38 260.92 193.79 255.3 197.44 255.3 196.03 260.92 192.38 260.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.09 263.48 208.5 257.86 208.51 260.93 207.1 266.55 207.09 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.73 263.48 210.74 266.55 207.1 266.55 207.09 263.48 210.73 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.73 263.48 212.14 257.86 212.15 260.93 210.74 266.55 210.73 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.09 263.48 208.5 257.86 212.14 257.86 210.73 263.48 207.09 263.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.73 260.92 201.14 255.3 204.78 255.3 203.37 260.92 199.73 260.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "192.38 260.92 193.79 255.3 195.98 252.24 194.57 257.86 192.38 260.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.02 257.86 197.43 252.24 197.44 255.3 196.03 260.92 196.02 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "196.02 257.86 196.03 260.92 192.38 260.92 194.57 257.86 196.02 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "194.57 257.86 195.98 252.24 197.43 252.24 196.02 257.86 194.57 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.08 260.92 208.49 255.3 212.13 255.3 210.72 260.92 207.08 260.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.72 257.86 201.13 252.24 201.14 255.3 199.73 260.92 199.72 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.36 257.86 204.77 252.24 204.78 255.3 203.37 260.92 203.36 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.36 257.86 203.37 260.92 199.73 260.92 199.72 257.86 203.36 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.72 257.86 201.13 252.24 204.77 252.24 203.36 257.86 199.72 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.07 257.86 208.48 252.24 208.49 255.3 207.08 260.92 207.07 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.07 257.86 208.48 252.24 212.12 252.24 210.71 257.86 207.07 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.71 257.86 212.12 252.24 212.13 255.3 210.72 260.92 210.71 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.71 255.3 201.12 249.68 204.77 249.68 203.36 255.3 199.71 255.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.06 255.3 208.47 249.68 212.12 249.68 210.71 255.3 207.06 255.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.7 252.24 201.11 246.62 201.12 249.68 199.71 255.3 199.7 252.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.35 252.24 204.76 246.62 204.77 249.68 203.36 255.3 203.35 252.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.35 252.24 203.36 255.3 199.71 255.3 199.7 252.24 203.35 252.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "199.7 252.24 201.11 246.62 204.76 246.62 203.35 252.24 199.7 252.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.05 252.24 208.46 246.62 208.47 249.68 207.06 255.3 207.05 252.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.05 252.24 208.46 246.62 212.11 246.62 210.7 252.24 207.05 252.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.7 252.24 212.11 246.62 212.12 249.68 210.71 255.3 210.7 252.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "200.41 249.69 201.82 244.07 204.75 244.07 203.34 249.69 200.41 249.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.05 249.69 208.46 244.07 212.1 244.07 210.69 249.69 207.05 249.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "200.41 249.69 201.82 244.07 204.02 241 202.61 246.62 200.41 249.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.33 246.62 203.34 249.69 200.41 249.69 202.61 246.62 203.33 246.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "202.61 246.62 204.02 241 204.74 241 203.33 246.62 202.61 246.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "203.33 246.62 204.74 241 204.75 244.07 203.34 249.69 203.33 246.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.04 246.62 208.45 241 208.46 244.07 207.05 249.69 207.04 246.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.04 246.62 208.45 241 212.09 241 210.68 246.62 207.04 246.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.68 246.62 210.69 249.69 207.05 249.69 207.04 246.62 210.68 246.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.68 246.62 212.09 241 212.1 244.07 210.69 249.69 210.68 246.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.03 244.06 208.44 238.44 212.08 238.44 210.67 244.06 207.03 244.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.02 241 208.43 235.38 208.44 238.44 207.03 244.06 207.02 241"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.66 241 212.07 235.38 212.08 238.44 210.67 244.06 210.66 241"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.02 241 208.43 235.38 212.07 235.38 210.66 241 207.02 241"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "208.45 238.45 209.86 232.83 212.06 232.83 210.65 238.45 208.45 238.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "210.65 235.39 212.06 229.77 212.06 232.83 210.65 238.45 210.65 235.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "208.45 238.45 209.86 232.83 212.06 229.77 210.65 235.39 208.45 238.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.95,283.91c.36-.02.7-.03,1.05-.04l.23,75.58-.34-73.76h-1.33s.22,73.76.22,73.76h-28.51s0-.98,0-.98h-9.5s0,.97,0,.97h-6.63s-.29-95.64-.29-95.64h-.88s.29,95.64.29,95.64h-3.09s-.29-95.64-.29-95.64h-.88s.29,95.64.29,95.64h-3.09s-.29-95.64-.29-95.64h-.89s.29,95.64.29,95.64h-3.09s-.29-95.64-.29-95.64h-.88s.29,95.64.29,95.64h-21.99s-.3-97.92-.3-97.92l3.2-2.49h8.75s8.77,3.41,8.77,3.41h15.76c2.92-3.88,6.13-5.07,8.97-5.07,4.52,0,7.93,2.87,8.11,3.02l26.17-36.43.18,59.94ZM175.49,265.68l.03,9.2h9.39s-.03-9.2-.03-9.2c-.12-.09-2.31-1.89-5.1-1.89-1.39,0-2.9.47-4.3,1.89M185.05,284.25v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.06,289.02v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.12,308.08v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.17,327.15v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.1,303.32v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.09,298.55v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.13,312.85v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.07,293.78v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.03,279.48v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.16,322.38v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.15,317.62v-2.05s-9.51,0-9.51,0v2.05s9.51,0,9.51,0M185.26,355.75v-2.04s-9.51,0-9.51,0v2.04s9.51,0,9.51,0M185.19,331.92v-2.04s-9.51,0-9.51,0v2.04s9.51,0,9.51,0M185.25,350.99v-2.04s-9.51,0-9.51,0v2.04s9.51,0,9.51,0M185.2,336.69v-2.04s-9.51,0-9.51,0v2.04s9.51,0,9.51,0M185.23,346.22v-2.04s-9.51,0-9.51,0v2.04s9.51,0,9.51,0M185.22,341.45v-2.04s-9.51,0-9.51,0v2.04s9.51,0,9.51,0M196.32,356.45v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.17,305.88v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.29,345.21v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.22,322.73v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.24,328.35v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.05,266.54v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.12,289.02v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.1,283.4v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.27,339.59v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.07,272.16v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M196.18,311.49v-3.07s-3.66,0-3.66,0v3.07s3.66,0,3.66,0M210.98,345.21v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.86,305.88v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M203.66,356.45v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M203.63,345.21v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M211.01,356.45v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M203.51,305.88v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M203.58,328.35v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M203.36,255.3v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.93,328.35v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.71,255.3v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M203.56,322.74v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.69,249.69v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M203.39,266.54v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.74,266.55v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M203.41,272.16v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.88,311.49v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.76,272.16v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.81,289.02v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.79,283.4v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M210.96,339.59v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M203.46,289.02v-3.07s-3.65,0-3.65,0v3.07s3.65,0,3.65,0M196.2,317.11v-3.06s-3.66,0-3.66,0v3.06s3.66,0,3.66,0M196.25,333.97v-3.06s-3.66,0-3.66,0v3.06s3.66,0,3.66,0M196.3,350.83v-3.06s-3.66,0-3.66,0v3.06s3.66,0,3.66,0M196.15,300.25v-3.06s-3.66,0-3.66,0v3.06s3.66,0,3.66,0M196.03,260.92v-3.06s-1.46,0-1.46,0l-2.19,3.06h3.65M196.13,294.63v-3.06s-3.66,0-3.66,0v3.06s3.66,0,3.66,0M196.08,277.78v-3.06s-3.66,0-3.66,0v3.06s3.66,0,3.66,0M203.54,317.11v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M210.67,244.06v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M210.84,300.25v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M210.89,317.11v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M210.94,333.97v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M203.64,350.83v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M210.72,260.92v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M203.59,333.97v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M203.49,300.25v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M210.99,350.83v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M203.37,260.92v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M203.47,294.64v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M210.82,294.64v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M210.77,277.78v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M203.42,277.78v-3.06s-3.65,0-3.65,0v3.06s3.65,0,3.65,0M203.34,249.69v-3.07s-.73,0-.73,0l-2.19,3.07h2.92M210.65,238.45v-3.06s-2.2,3.06-2.2,3.06h2.2M137.74,280.77v-2.82s-2,0-2,0v2.82s2,0,2,0M137.76,286.26v-2.82s-2,0-2,0v2.82s2,0,2,0M149.12,280.77v-2.82s-2,0-2,0v2.82s2,0,2,0M149.14,286.26v-2.82s-2,0-2,0v2.82s2,0,2,0M137.77,291.75v-2.81s-2,0-2,0v2.81s2,0,2,0M137.89,329.76v-2.81s-2,0-2,0v2.81s2,0,2,0M137.91,335.34v-2.81s-2,0-2,0v2.81s2,0,2,0M137.81,302.52v-2.81s-2,0-2,0v2.81s2,0,2,0M137.92,340.74v-2.81s-2,0-2,0v2.81s2,0,2,0M137.82,308.01v-2.81s-2,0-2,0v2.81s2,0,2,0M137.97,357.04v-2.81s-2,0-2,0v2.81s2,0,2,0M137.71,269.78v-2.81s-2,0-2,0v2.81s2,0,2,0M137.79,297.1v-2.81s-2,0-2,0v2.81s2,0,2,0M137.84,313.45v-2.81s-2,0-2,0v2.81s2,0,2,0M137.87,324.36v-2.81s-2,0-2,0v2.81s2,0,2,0M149.27,329.76v-2.81s-2,0-2,0v2.81s2,0,2,0M149.15,291.75v-2.81s-2,0-2,0v2.81s2,0,2,0M149.19,302.52v-2.81s-2,0-2,0v2.81s2,0,2,0M149.29,335.34v-2.81s-2,0-2,0v2.81s2,0,2,0M149.3,340.74v-2.81s-2,0-2,0v2.81s2,0,2,0M149.22,313.46v-2.81s-2,0-2,0v2.81s2,0,2,0M149.17,297.1v-2.81s-2,0-2,0v2.81s2,0,2,0M149.25,324.36v-2.81s-2,0-2,0v2.81s2,0,2,0M149.09,269.78v-2.81s-2,0-2,0v2.81s2,0,2,0M149.35,357.05v-2.81s-2,0-2,0v2.81s2,0,2,0M149.2,308.01v-2.81s-2,0-2,0v2.81s2,0,2,0M137.95,351.55v-2.81s-2,0-2,0v2.81s2,0,2,0M137.94,346.15v-2.81s-2,0-2,0v2.81s2,0,2,0M137.72,275.27v-2.81s-2,0-2,0v2.81s2,0,2,0M137.86,318.87v-2.81s-2,0-2,0v2.81s2,0,2,0M149.33,351.55v-2.81s-2,0-2,0v2.81s2,0,2,0M149.32,346.15v-2.81s-2,0-2,0v2.81s2,0,2,0M149.1,275.27v-2.81s-2,0-2,0v2.81s2,0,2,0M149.24,318.87v-2.81s-2,0-2,0v2.81s2,0,2,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.65 353.38 203.66 356.45 200.02 356.45 200.01 353.38 203.65 353.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.95 336.53 210.96 339.59 207.32 339.59 207.31 336.53 210.95 336.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.92 325.28 210.93 328.35 207.28 328.35 207.27 325.28 210.92 325.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "203.55 319.67 203.56 322.74 199.92 322.73 199.91 319.67 203.55 319.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.85 302.81 210.86 305.88 207.21 305.88 207.21 302.81 210.85 302.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.8 285.95 210.81 289.02 207.16 289.02 207.15 285.95 210.8 285.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "214.89 285.7 215.11 359.46 213.78 359.46 213.56 285.7 214.89 285.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "215 283.88 216.41 278.26 216.64 353.84 215.23 359.46 215 283.88"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.95,283.91l1.41-5.62c.36-.02.7-.03,1.05-.04l-1.41,5.62c-.35,0-.69.02-1.05.04"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "134.04 261.53 135.45 255.91 138.64 253.42 137.23 259.04 134.04 261.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "156.91 263.81 157.2 359.45 156.32 359.45 156.03 263.81 156.91 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "160.9 263.81 161.19 359.45 160.3 359.45 160.01 263.81 160.9 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "164.88 263.81 165.17 359.45 164.28 359.45 163.99 263.81 164.88 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "145.99 259.04 147.4 253.42 156.17 256.83 154.76 262.45 145.99 259.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "137.23 259.04 138.64 253.42 147.4 253.42 145.99 259.04 137.23 259.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "168.85 263.81 169.14 359.45 168.26 359.45 167.97 263.81 168.85 263.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "154.76 262.45 156.17 256.83 171.93 256.83 170.52 262.45 154.76 262.45"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.52,262.45l1.41-5.62c1.53-2.03,3.13-3.32,4.72-4.09l-1.41,5.62c-1.59.77-3.2,2.06-4.72,4.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.25,258.36l1.41-5.62c.47-.23.93-.41,1.39-.55l-1.41,5.62c-.46.14-.92.32-1.39.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M176.63,257.81l1.41-5.62c.39-.12.78-.21,1.16-.28l-1.41,5.62c-.38.07-.77.16-1.16.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177.8,257.53l1.41-5.62c.37-.07.74-.11,1.1-.13l-1.41,5.62c-.36.02-.73.06-1.1.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.9,257.4l1.41-5.62c.2-.01.4-.02.59-.02l-1.41,5.62c-.2,0-.4,0-.59.02"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.49,257.39l1.41-5.62c.19,0,.38,0,.57.02l-1.41,5.62c-.19,0-.38-.02-.57-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.07,257.4l1.41-5.62c.44.02.88.07,1.3.14l-1.41,5.62c-.42-.07-.85-.12-1.3-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.36,257.55l1.41-5.62c.53.09,1.04.21,1.52.36l-1.41,5.62c-.48-.15-.99-.27-1.52-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.88,257.91l1.41-5.62c.74.23,1.42.51,2.01.79l-1.41,5.62c-.59-.29-1.27-.57-2.01-.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184.9,258.7l1.41-5.62c1.6.78,2.61,1.62,2.7,1.71l-1.41,5.62c-.1-.08-1.1-.93-2.7-1.71"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.71 257.86 210.72 260.92 207.08 260.92 207.07 257.86 210.71 257.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.7 252.24 210.71 255.3 207.06 255.3 207.05 252.24 210.7 252.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.66 241 210.67 244.06 207.03 244.06 207.02 241 210.66 241"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "210.65 235.39 210.65 238.45 208.45 238.45 210.65 235.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "213.77 223.98 215.18 218.36 215.36 278.29 213.95 283.91 213.77 223.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "187.6 260.41 189.01 254.79 215.18 218.36 213.77 223.98 187.6 260.41"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "258.24 241.59 259.65 235.97 260 353.68 258.59 359.3 258.24 241.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "256.73 241.59 258.14 235.97 259.65 235.97 258.24 241.59 256.73 241.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "224.36 227.92 225.77 222.3 226.17 353.68 224.76 359.3 224.36 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "224.36 227.92 225.77 222.3 228.86 222.3 227.45 227.92 224.36 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "227.45 227.92 227.84 359.3 224.76 359.3 224.36 227.92 227.45 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "227.45 227.92 228.86 222.3 229.25 353.68 227.84 359.3 227.45 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "229.77 227.92 231.18 222.3 231.58 353.68 230.17 359.3 229.77 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "229.77 227.92 231.18 222.3 234.26 222.3 232.85 227.92 229.77 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "232.85 227.92 233.25 359.3 230.17 359.3 229.77 227.92 232.85 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "232.85 227.92 234.26 222.3 234.66 353.68 233.25 359.3 232.85 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "235.17 227.92 236.58 222.3 236.97 353.68 235.56 359.3 235.17 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220.66 224.94 222.07 219.32 227.65 219.32 226.24 224.94 220.66 224.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "235.17 227.92 236.58 222.3 239.66 222.3 238.25 227.92 235.17 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "238.25 227.92 238.65 359.3 235.56 359.3 235.17 227.92 238.25 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "238.25 227.92 239.66 222.3 240.06 353.68 238.65 359.3 238.25 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "240.56 227.92 241.97 222.3 242.37 353.68 240.96 359.3 240.56 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "243.66 227.92 244.06 359.3 240.96 359.3 240.56 227.92 243.66 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "240.56 227.92 241.97 222.3 245.07 222.3 243.66 227.92 240.56 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "243.66 227.92 245.07 222.3 245.47 353.68 244.06 359.3 243.66 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "245.97 227.92 247.38 222.3 247.78 353.68 246.37 359.3 245.97 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "249.06 227.92 250.47 222.3 250.86 353.68 249.45 359.3 249.06 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "245.97 227.92 247.38 222.3 250.47 222.3 249.06 227.92 245.97 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "249.06 227.92 249.45 359.3 246.37 359.3 245.97 227.92 249.06 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "251.37 227.92 252.78 222.3 253.18 353.68 251.77 359.3 251.37 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "253.81 227.92 255.22 222.3 255.61 353.68 254.2 359.3 253.81 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "253.81 227.92 254.2 359.3 251.77 359.3 251.37 227.92 253.81 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "251.37 227.92 252.78 222.3 255.22 222.3 253.81 227.92 251.37 227.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "252.65 224.94 254.06 219.32 254.97 219.32 253.56 224.94 252.65 224.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "256.67 223.76 258.08 218.14 258.14 235.97 256.73 241.59 256.67 223.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "253.56 223.75 254.97 218.13 258.08 218.14 256.67 223.76 253.56 223.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "226.2 212.47 227.61 206.85 233.35 206.85 231.94 212.47 226.2 212.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "246.1 212.47 247.51 206.85 254.02 206.85 252.61 212.47 246.1 212.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "252.61 212.47 254.02 206.85 254.06 219.32 252.65 224.94 252.61 212.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "231.91 202.49 233.32 196.87 239.44 196.87 238.03 202.49 231.91 202.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "246.07 202.49 247.48 196.87 247.51 206.85 246.1 212.47 246.07 202.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "241.1 202.49 242.51 196.87 247.48 196.87 246.07 202.49 241.1 202.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "241.02 174.83 242.43 169.21 242.51 196.87 241.1 202.49 241.02 174.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "241.02 174.83 241.1 202.49 246.07 202.49 246.1 212.47 252.61 212.47 252.65 224.94 253.56 224.94 253.56 223.75 256.67 223.76 256.73 241.59 258.24 241.59 258.59 359.3 254.2 359.3 253.81 227.92 251.37 227.92 251.77 359.3 249.45 359.3 249.06 227.92 245.97 227.92 246.37 359.3 244.06 359.3 243.66 227.92 240.56 227.92 240.96 359.3 238.65 359.3 238.25 227.92 235.17 227.92 235.56 359.3 233.25 359.3 232.85 227.92 229.77 227.92 230.17 359.3 227.84 359.3 227.45 227.92 224.36 227.92 224.76 359.3 221.05 359.3 220.69 238.02 220.66 224.94 226.24 224.94 226.2 212.47 231.94 212.47 231.91 202.49 238.03 202.49 237.95 174.83 241.02 174.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "237.95 174.83 239.36 169.21 242.43 169.21 241.02 174.83 237.95 174.83"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.2 356.2 343.61 350.58 343.62 353.87 342.21 359.49 342.2 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.35 356.2 347.76 350.58 347.77 353.87 346.36 359.49 346.35 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "342.2 356.2 343.61 350.58 347.76 350.58 346.35 356.2 342.2 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.35 356.2 346.36 359.49 342.21 359.49 342.2 356.2 346.35 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.44 356.2 352.85 350.58 352.85 353.87 351.44 359.49 351.44 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.58 356.2 355.59 359.49 351.44 359.49 351.43 356.2 355.58 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.43 356.2 352.84 350.58 356.99 350.58 355.58 356.2 351.43 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.58 356.2 356.99 350.58 357 353.87 355.59 359.49 355.58 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.67 356.2 362.08 350.58 362.09 353.87 360.68 359.49 360.67 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.81 356.2 366.22 350.58 366.23 353.87 364.82 359.49 364.81 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.67 356.2 362.08 350.58 366.22 350.58 364.81 356.2 360.67 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.81 356.2 364.82 359.49 360.68 359.49 360.67 356.2 364.81 356.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.43 353.3 352.84 347.68 356.98 347.68 355.57 353.3 351.43 353.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.67 353.3 362.08 347.68 366.21 347.68 364.8 353.3 360.67 353.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.41 349.23 352.82 343.61 352.84 347.68 351.43 353.3 351.41 349.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.41 349.23 352.82 343.61 356.97 343.61 355.56 349.23 351.41 349.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.56 349.23 356.97 343.61 356.98 347.68 355.57 353.3 355.56 349.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.56 349.23 355.57 353.3 351.43 353.3 351.41 349.23 355.56 349.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.17 346.33 343.58 340.71 347.73 340.71 346.32 346.33 342.17 346.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.65 349.23 362.06 343.61 362.08 347.68 360.67 353.3 360.65 349.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.65 349.23 362.06 343.61 366.2 343.61 364.79 349.23 360.65 349.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.79 349.23 364.8 353.3 360.67 353.3 360.65 349.23 364.79 349.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.79 349.23 366.2 343.61 366.21 347.68 364.8 353.3 364.79 349.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.41 346.33 352.82 340.71 356.96 340.71 355.55 346.33 351.41 346.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.16 342.26 343.57 336.64 343.58 340.71 342.17 346.33 342.16 342.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.31 342.27 346.32 346.33 342.17 346.33 342.16 342.26 346.31 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "342.16 342.26 343.57 336.64 347.72 336.65 346.31 342.27 342.16 342.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.31 342.27 347.72 336.65 347.73 340.71 346.32 346.33 346.31 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.64 346.34 362.05 340.72 366.19 340.72 364.78 346.34 360.64 346.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.39 342.27 352.8 336.65 352.82 340.71 351.41 346.33 351.39 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.54 342.27 356.95 336.65 356.96 340.71 355.55 346.33 355.54 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.39 342.27 352.8 336.65 356.95 336.65 355.54 342.27 351.39 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.15 339.37 343.56 333.75 347.71 333.75 346.3 339.37 342.15 339.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.63 342.27 362.04 336.65 362.05 340.72 360.64 346.34 360.63 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.63 342.27 362.04 336.65 366.18 336.65 364.77 342.27 360.63 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.77 342.27 366.18 336.65 366.19 340.72 364.78 346.34 364.77 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.77 342.27 364.78 346.34 360.64 346.34 360.63 342.27 364.77 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.38 339.37 352.79 333.75 356.94 333.75 355.53 339.37 351.38 339.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.14 335.3 343.55 329.68 343.56 333.75 342.15 339.37 342.14 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "342.14 335.3 343.55 329.68 347.7 329.68 346.29 335.3 342.14 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.29 335.3 347.7 329.68 347.71 333.75 346.3 339.37 346.29 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.62 339.37 362.03 333.75 366.17 333.75 364.76 339.37 360.62 339.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.37 335.3 352.78 329.68 352.79 333.75 351.38 339.37 351.37 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.52 335.3 356.93 329.68 356.94 333.75 355.53 339.37 355.52 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.37 335.3 352.78 329.68 356.93 329.68 355.52 335.3 351.37 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.52 335.3 355.53 339.37 351.38 339.37 351.37 335.3 355.52 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.13 332.4 343.54 326.78 347.69 326.78 346.28 332.4 342.13 332.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.61 335.3 362.02 329.68 362.03 333.75 360.62 339.37 360.61 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.61 335.3 362.02 329.68 366.16 329.68 364.75 335.3 360.61 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.75 335.3 366.16 329.68 366.17 333.75 364.76 339.37 364.75 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.36 332.4 352.77 326.78 356.92 326.78 355.51 332.4 351.36 332.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.12 328.33 343.53 322.71 343.54 326.78 342.13 332.4 342.12 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.27 328.33 347.68 322.71 347.69 326.78 346.28 332.4 346.27 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.27 328.33 346.28 332.4 342.13 332.4 342.12 328.33 346.27 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "342.12 328.33 343.53 322.71 347.68 322.71 346.27 328.33 342.12 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.35 328.33 352.76 322.71 352.77 326.78 351.36 332.4 351.35 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.5 328.33 356.91 322.71 356.92 326.78 355.51 332.4 355.5 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.35 328.33 352.76 322.71 356.91 322.71 355.5 328.33 351.35 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.5 328.33 355.51 332.4 351.36 332.4 351.35 328.33 355.5 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.11 325.43 343.52 319.81 347.67 319.81 346.26 325.43 342.11 325.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.34 325.43 352.75 319.81 356.9 319.81 355.49 325.43 351.34 325.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.1 321.36 343.51 315.74 343.52 319.81 342.11 325.43 342.1 321.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.25 321.36 347.66 315.74 347.67 319.81 346.26 325.43 346.25 321.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "342.1 321.36 343.51 315.74 347.66 315.74 346.25 321.36 342.1 321.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.25 321.36 346.26 325.43 342.11 325.43 342.1 321.36 346.25 321.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.58 325.44 361.99 319.82 366.13 319.82 364.72 325.44 360.58 325.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.33 321.36 352.74 315.74 352.75 319.81 351.34 325.43 351.33 321.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.33 321.36 352.74 315.74 356.89 315.75 355.48 321.37 351.33 321.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.48 321.37 356.89 315.75 356.9 319.81 355.49 325.43 355.48 321.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.09 318.47 343.5 312.85 347.65 312.85 346.24 318.47 342.09 318.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.57 321.37 361.98 315.75 361.99 319.82 360.58 325.44 360.57 321.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.71 321.37 364.72 325.44 360.58 325.44 360.57 321.37 364.71 321.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.57 321.37 361.98 315.75 366.12 315.75 364.71 321.37 360.57 321.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.71 321.37 366.12 315.75 366.13 319.82 364.72 325.44 364.71 321.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.08 314.4 343.49 308.78 343.5 312.85 342.09 318.47 342.08 314.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.23 314.4 347.64 308.78 347.65 312.85 346.24 318.47 346.23 314.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "342.08 314.4 343.49 308.78 347.64 308.78 346.23 314.4 342.08 314.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.23 314.4 346.24 318.47 342.09 318.47 342.08 314.4 346.23 314.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.56 318.47 361.97 312.85 366.11 312.85 364.7 318.47 360.56 318.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.07 311.49 343.48 305.87 347.63 305.87 346.22 311.49 342.07 311.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.55 314.4 361.96 308.78 361.97 312.85 360.56 318.47 360.55 314.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.69 314.4 366.1 308.78 366.11 312.85 364.7 318.47 364.69 314.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.55 314.4 361.96 308.78 366.1 308.78 364.69 314.4 360.55 314.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.3 311.49 352.71 305.87 356.86 305.87 355.45 311.49 351.3 311.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.06 307.43 343.47 301.81 343.48 305.87 342.07 311.49 342.06 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.2 307.43 347.61 301.81 347.63 305.87 346.22 311.49 346.2 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "342.06 307.43 343.47 301.81 347.61 301.81 346.2 307.43 342.06 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.54 311.49 361.95 305.87 366.09 305.87 364.68 311.49 360.54 311.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.29 307.43 352.7 301.81 352.71 305.87 351.3 311.49 351.29 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.29 307.43 352.7 301.81 356.85 301.81 355.44 307.43 351.29 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.44 307.43 356.85 301.81 356.86 305.87 355.45 311.49 355.44 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.53 307.43 361.94 301.81 361.95 305.87 360.54 311.49 360.53 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.53 307.43 361.94 301.81 366.08 301.81 364.67 307.43 360.53 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.67 307.43 366.08 301.81 366.09 305.87 364.68 311.49 364.67 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.28 304.52 352.69 298.9 356.84 298.91 355.43 304.53 351.28 304.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.52 304.53 361.93 298.91 366.07 298.91 364.66 304.53 360.52 304.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.27 300.46 352.68 294.84 352.69 298.9 351.28 304.52 351.27 300.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.41 300.47 356.82 294.85 356.84 298.91 355.43 304.53 355.41 300.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.41 300.47 355.43 304.53 351.28 304.52 351.27 300.46 355.41 300.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.27 300.46 352.68 294.84 356.82 294.85 355.41 300.47 351.27 300.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.03 297.56 343.44 291.94 347.58 291.94 346.17 297.56 342.03 297.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.51 300.47 361.92 294.85 361.93 298.91 360.52 304.53 360.51 300.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.51 300.47 361.92 294.85 366.05 294.85 364.64 300.47 360.51 300.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.64 300.47 364.66 304.53 360.52 304.53 360.51 300.47 364.64 300.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.64 300.47 366.05 294.85 366.07 298.91 364.66 304.53 364.64 300.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.26 297.56 352.67 291.94 356.82 291.94 355.41 297.56 351.26 297.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.02 293.5 343.43 287.88 343.44 291.94 342.03 297.56 342.02 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.16 293.5 347.57 287.88 347.58 291.94 346.17 297.56 346.16 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "342.02 293.5 343.43 287.88 347.57 287.88 346.16 293.5 342.02 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.5 297.56 361.91 291.94 366.05 291.94 364.64 297.56 360.5 297.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.25 293.5 352.66 287.88 352.67 291.94 351.26 297.56 351.25 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.25 293.5 352.66 287.88 356.8 287.88 355.39 293.5 351.25 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.39 293.5 356.8 287.88 356.82 291.94 355.41 297.56 355.39 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "342.01 290.59 343.42 284.97 347.56 284.97 346.15 290.59 342.01 290.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.48 293.5 361.89 287.88 361.91 291.94 360.5 297.56 360.48 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.62 293.5 366.03 287.88 366.05 291.94 364.64 297.56 364.62 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.48 293.5 361.89 287.88 366.03 287.88 364.62 293.5 360.48 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.24 290.59 352.65 284.97 356.79 284.97 355.38 290.59 351.24 290.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.99 286.53 343.4 280.91 343.42 284.97 342.01 290.59 341.99 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.14 286.53 347.55 280.91 347.56 284.97 346.15 290.59 346.14 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "341.99 286.53 343.4 280.91 347.55 280.91 346.14 286.53 341.99 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.48 290.59 361.89 284.97 366.02 284.97 364.61 290.59 360.48 290.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.22 286.53 352.63 280.91 352.65 284.97 351.24 290.59 351.22 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.22 286.53 352.63 280.91 356.78 280.91 355.37 286.53 351.22 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.37 286.53 355.38 290.59 351.24 290.59 351.22 286.53 355.37 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.37 286.53 356.78 280.91 356.79 284.97 355.38 290.59 355.37 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.99 283.62 343.4 278 347.54 278 346.13 283.62 341.99 283.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.46 286.53 361.87 280.91 361.89 284.97 360.48 290.59 360.46 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.6 286.53 364.61 290.59 360.48 290.59 360.46 286.53 364.6 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.46 286.53 361.87 280.91 366.01 280.91 364.6 286.53 360.46 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.6 286.53 366.01 280.91 366.02 284.97 364.61 290.59 364.6 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.97 279.56 343.38 273.94 343.4 278 341.99 283.62 341.97 279.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "341.97 279.56 343.38 273.94 347.53 273.94 346.12 279.56 341.97 279.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.12 279.56 347.53 273.94 347.54 278 346.13 283.62 346.12 279.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.46 283.63 361.87 278.01 366 278.01 364.59 283.63 360.46 283.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.96 276.66 343.37 271.04 347.52 271.04 346.11 276.66 341.96 276.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.44 279.56 361.85 273.94 361.87 278.01 360.46 283.63 360.44 279.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.58 279.57 365.99 273.95 366 278.01 364.59 283.63 364.58 279.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.44 279.56 361.85 273.94 365.99 273.95 364.58 279.57 360.44 279.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.19 276.66 352.6 271.04 356.75 271.04 355.34 276.66 351.19 276.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.95 272.59 343.36 266.97 343.37 271.04 341.96 276.66 341.95 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "341.95 272.59 343.36 266.97 347.51 266.97 346.1 272.59 341.95 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.1 272.59 347.51 266.97 347.52 271.04 346.11 276.66 346.1 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.43 276.66 361.84 271.04 365.98 271.04 364.57 276.66 360.43 276.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.18 272.59 352.59 266.97 352.6 271.04 351.19 276.66 351.18 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.18 272.59 352.59 266.97 356.74 266.97 355.33 272.59 351.18 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.33 272.59 356.74 266.97 356.75 271.04 355.34 276.66 355.33 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.94 269.69 343.35 264.07 347.5 264.07 346.09 269.69 341.94 269.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.42 272.59 361.83 266.97 361.84 271.04 360.43 276.66 360.42 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.56 272.59 365.97 266.97 365.98 271.04 364.57 276.66 364.56 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.42 272.59 361.83 266.97 365.97 266.97 364.56 272.59 360.42 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.17 269.69 352.58 264.07 356.73 264.07 355.32 269.69 351.17 269.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.93 265.62 343.34 260 343.35 264.07 341.94 269.69 341.93 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "341.93 265.62 343.34 260 347.49 260 346.08 265.62 341.93 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.08 265.62 347.49 260 347.5 264.07 346.09 269.69 346.08 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.41 269.69 361.82 264.07 365.96 264.07 364.55 269.69 360.41 269.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.16 265.62 352.57 260 352.58 264.07 351.17 269.69 351.16 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.16 265.62 352.57 260 356.72 260 355.31 265.62 351.16 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.31 265.62 356.72 260 356.73 264.07 355.32 269.69 355.31 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "360.4 265.62 361.81 260 361.82 264.07 360.41 269.69 360.4 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "364.54 265.62 365.95 260 365.96 264.07 364.55 269.69 364.54 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.4 265.62 361.81 260 365.95 260 364.54 265.62 360.4 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.15 262.72 352.56 257.1 356.71 257.1 355.3 262.72 351.15 262.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "351.14 258.65 352.55 253.03 352.56 257.1 351.15 262.72 351.14 258.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.29 258.65 355.3 262.72 351.15 262.72 351.14 258.65 355.29 258.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "355.29 258.65 356.7 253.03 356.71 257.1 355.3 262.72 355.29 258.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.14 258.65 352.55 253.03 356.7 253.03 355.29 258.65 351.14 258.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.9 255.76 343.31 250.14 347.46 250.14 346.05 255.76 341.9 255.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.89 251.69 343.3 246.07 343.31 250.14 341.9 255.76 341.89 251.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.04 251.69 346.05 255.76 341.9 255.76 341.89 251.69 346.04 251.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.04 251.69 347.45 246.07 347.46 250.14 346.05 255.76 346.04 251.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "341.89 251.69 343.3 246.07 347.45 246.07 346.04 251.69 341.89 251.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.75,280.53h.42s.24,78.96.24,78.96h-4.59s0-3.29,0-3.29h-4.14s0,3.29,0,3.29h-5.09s0-3.29,0-3.29h-4.15s0,3.29,0,3.29h-5.08s0-3.29,0-3.29h-4.15s0,3.29,0,3.29h-4.53s-.37-123.87-.37-123.87h2.42s.04,12.39.04,12.39c.03,0,.56-.04,1.54-.04,5.36,0,23.12,1.11,27.39,15.52l.05,17.04ZM355.34,276.66v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M346.05,255.76v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M346.11,276.66v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M355.32,269.69v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M355.3,262.72v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M346.09,269.69v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M355.57,353.3v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M355.53,339.37v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M355.49,325.43v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M346.3,339.37v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M346.26,325.43v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M355.51,332.4v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M346.28,332.4v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M355.55,346.33v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M346.24,318.47v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M346.32,346.33v-4.07s-4.16,0-4.16,0v4.07s4.16,0,4.16,0M355.38,290.59v-4.06s-4.16,0-4.16,0v4.06s4.16,0,4.16,0M346.15,290.59v-4.06s-4.16,0-4.16,0v4.06s4.16,0,4.16,0M364.57,276.66v-4.07s-4.15,0-4.15,0v4.07s4.15,0,4.15,0M364.55,269.69v-4.07s-4.15,0-4.15,0v4.07s4.15,0,4.15,0M364.76,339.37v-4.07s-4.15,0-4.15,0v4.07s4.15,0,4.15,0M364.8,353.3v-4.07s-4.15,0-4.15,0v4.07s4.15,0,4.15,0M364.72,325.44v-4.07s-4.15,0-4.15,0v4.07s4.15,0,4.15,0M355.45,311.49v-4.06s-4.16,0-4.16,0v4.06s4.16,0,4.16,0M346.22,311.49v-4.06s-4.16,0-4.16,0v4.06s4.16,0,4.16,0M355.41,297.56v-4.06s-4.16,0-4.16,0v4.06s4.16,0,4.16,0M355.43,304.53v-4.06s-4.16,0-4.16,0v4.06s4.16,0,4.16,0M346.17,297.56v-4.06s-4.16,0-4.16,0v4.06s4.16,0,4.16,0M346.13,283.62v-4.06s-4.16,0-4.16,0v4.06s4.16,0,4.16,0M364.78,346.34v-4.07s-4.15,0-4.15,0v4.07s4.15,0,4.15,0M364.7,318.47v-4.07s-4.15,0-4.15,0v4.07s4.15,0,4.15,0M364.61,290.59v-4.06s-4.15,0-4.15,0v4.06s4.15,0,4.15,0M364.68,311.49v-4.06s-4.15,0-4.15,0v4.06s4.15,0,4.15,0M364.59,283.63v-4.06s-4.15,0-4.15,0v4.06s4.15,0,4.15,0M364.64,297.56v-4.06s-4.15,0-4.15,0v4.06s4.15,0,4.15,0M364.66,304.53v-4.06s-4.15,0-4.15,0v4.06s4.15,0,4.15,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.54 342.27 355.55 346.33 351.41 346.33 351.39 342.27 355.54 342.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.29 335.3 346.3 339.37 342.15 339.37 342.14 335.3 346.29 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.75 335.3 364.76 339.37 360.62 339.37 360.61 335.3 364.75 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.48 321.37 355.49 325.43 351.34 325.43 351.33 321.36 355.48 321.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.69 314.4 364.7 318.47 360.56 318.47 360.55 314.4 364.69 314.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.2 307.43 346.22 311.49 342.07 311.49 342.06 307.43 346.2 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.44 307.43 355.45 311.49 351.3 311.49 351.29 307.43 355.44 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.67 307.43 364.68 311.49 360.54 311.49 360.53 307.43 364.67 307.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.16 293.5 346.17 297.56 342.03 297.56 342.02 293.5 346.16 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.39 293.5 355.41 297.56 351.26 297.56 351.25 293.5 355.39 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.62 293.5 364.64 297.56 360.5 297.56 360.48 293.5 364.62 293.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.14 286.53 346.15 290.59 342.01 290.59 341.99 286.53 346.14 286.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.12 279.56 346.13 283.62 341.99 283.62 341.97 279.56 346.12 279.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.58 279.57 364.59 283.63 360.46 283.63 360.44 279.56 364.58 279.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "369.17 280.53 370.58 274.91 370.82 353.87 369.41 359.49 369.17 280.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "368.75 280.53 370.16 274.91 370.58 274.91 369.17 280.53 368.75 280.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.1 272.59 346.11 276.66 341.96 276.66 341.95 272.59 346.1 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.33 272.59 355.34 276.66 351.19 276.66 351.18 272.59 355.33 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.56 272.59 364.57 276.66 360.43 276.66 360.42 272.59 364.56 272.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "346.08 265.62 346.09 269.69 341.94 269.69 341.93 265.62 346.08 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "355.31 265.62 355.32 269.69 351.17 269.69 351.16 265.62 355.31 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "364.54 265.62 364.55 269.69 360.41 269.69 360.4 265.62 364.54 265.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "368.7 263.49 370.11 257.87 370.16 274.91 368.75 280.53 368.7 263.49"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.77,248.01l1.41-5.62s.01,0,.03,0l-1.41,5.62s-.03,0-.03,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.8,248.01l1.41-5.62c.13,0,.65-.04,1.51-.03.61,0,1.38.01,2.28.06l-1.41,5.62c-.9-.05-1.67-.06-2.28-.06-.87,0-1.38.03-1.51.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343.59,248.04l1.41-5.62c1.47.08,3.28.24,5.25.58l-1.41,5.62c-1.97-.33-3.77-.5-5.25-.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.84,248.61l1.41-5.62c1.52.26,3.14.62,4.77,1.11l-1.41,5.62c-1.63-.5-3.25-.85-4.77-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.61,249.72l1.41-5.62c1.48.45,2.98,1.02,4.44,1.72l-1.41,5.62c-1.45-.71-2.95-1.27-4.44-1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M358.05,251.45l1.41-5.62c3.71,1.8,7.12,4.52,9.27,8.62l-1.41,5.62c-2.15-4.1-5.56-6.82-9.27-8.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367.31,260.06l1.41-5.62c.45.86.84,1.78,1.17,2.76l-1.41,5.62c-.33-.98-.72-1.9-1.17-2.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.49,262.82l1.41-5.62c.07.22.14.44.21.67l-1.41,5.62c-.07-.23-.14-.45-.21-.67"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "339.74 235.62 341.15 230 341.18 242.39 339.77 248.01 339.74 235.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "337.32 235.62 338.73 230 341.15 230 339.74 235.62 337.32 235.62"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.98 355.77 276.39 350.15 279.75 350.15 278.34 355.77 274.98 355.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.35 355.77 282.76 350.15 286.12 350.15 284.71 355.77 281.35 355.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.97 352.06 276.38 346.44 276.39 350.15 274.98 355.77 274.97 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.73 355.77 289.14 350.15 292.49 350.15 291.08 355.77 287.73 355.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.32 352.06 279.73 346.44 279.75 350.15 278.34 355.77 278.32 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.97 352.06 276.38 346.44 279.73 346.44 278.32 352.06 274.97 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.34 352.06 282.75 346.44 282.76 350.15 281.35 355.77 281.34 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.1 355.77 295.51 350.15 298.86 350.15 297.45 355.77 294.1 355.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.34 352.06 282.75 346.44 286.1 346.44 284.69 352.06 281.34 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.69 352.06 286.1 346.44 286.12 350.15 284.71 355.77 284.69 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.72 352.06 289.13 346.44 289.14 350.15 287.73 355.77 287.72 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.48 355.77 301.89 350.15 305.24 350.16 303.83 355.78 300.48 355.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.96 349.04 276.37 343.42 279.73 343.42 278.32 349.04 274.96 349.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "291.07 352.06 292.48 346.44 292.49 350.15 291.08 355.77 291.07 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.72 352.06 289.13 346.44 292.48 346.44 291.07 352.06 287.72 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.09 352.06 295.5 346.44 295.51 350.15 294.1 355.77 294.09 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.85 355.78 308.26 350.16 311.61 350.16 310.2 355.78 306.85 355.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.44 352.06 298.85 346.44 298.86 350.15 297.45 355.77 297.44 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "294.09 352.06 295.5 346.44 298.85 346.44 297.44 352.06 294.09 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.46 352.06 301.87 346.44 301.89 350.15 300.48 355.77 300.46 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.95 345.33 276.36 339.71 276.37 343.42 274.96 349.04 274.95 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.21 355.78 314.62 350.16 317.99 350.16 316.58 355.78 313.21 355.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.71 349.04 289.12 343.42 292.47 343.42 291.06 349.04 287.71 349.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.82 352.06 305.23 346.44 305.24 350.16 303.83 355.78 303.82 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.46 352.06 301.87 346.44 305.23 346.44 303.82 352.06 300.46 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.95 345.33 276.36 339.71 279.71 339.71 278.3 345.33 274.95 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.3 345.33 279.71 339.71 279.73 343.42 278.32 349.04 278.3 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.83 352.06 308.24 346.44 308.26 350.16 306.85 355.78 306.83 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.08 349.04 295.49 343.42 298.84 343.42 297.43 349.04 294.08 349.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.83 352.06 308.24 346.44 311.6 346.44 310.19 352.06 306.83 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "310.19 352.06 311.6 346.44 311.61 350.16 310.2 355.78 310.19 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.2 352.06 314.61 346.44 314.62 350.16 313.21 355.78 313.2 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.7 345.33 289.11 339.71 289.12 343.42 287.71 349.04 287.7 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.46 349.04 301.87 343.42 305.22 343.42 303.81 349.04 300.46 349.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.57 352.06 317.98 346.44 317.99 350.16 316.58 355.78 316.57 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.2 352.06 314.61 346.44 317.98 346.44 316.57 352.06 313.2 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.94 342.3 276.35 336.68 279.7 336.68 278.29 342.3 274.94 342.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "291.05 345.33 292.46 339.71 292.47 343.42 291.06 349.04 291.05 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.7 345.33 289.11 339.71 292.46 339.71 291.05 345.33 287.7 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.07 345.33 295.48 339.71 295.49 343.42 294.08 349.04 294.07 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.31 342.3 282.72 336.68 286.07 336.68 284.66 342.3 281.31 342.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.93 352.75 323.34 347.13 328.04 347.13 326.63 352.75 321.93 352.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.42 345.33 298.83 339.71 298.84 343.42 297.43 349.04 297.42 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "294.07 345.33 295.48 339.71 298.83 339.71 297.42 345.33 294.07 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.44 345.33 301.85 339.71 301.87 343.42 300.46 349.04 300.44 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.93 338.6 276.34 332.98 276.35 336.68 274.94 342.3 274.93 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.19 349.04 314.6 343.42 317.97 343.42 316.56 349.04 313.19 349.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.69 342.31 289.1 336.69 292.45 336.69 291.04 342.31 287.69 342.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.8 345.33 303.81 349.04 300.46 349.04 300.44 345.33 303.8 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.44 345.33 301.85 339.71 305.21 339.71 303.8 345.33 300.44 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.8 345.33 305.21 339.71 305.22 343.42 303.81 349.04 303.8 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.28 338.6 279.69 332.98 279.7 336.68 278.29 342.3 278.28 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.93 338.6 276.34 332.98 279.69 332.98 278.28 338.6 274.93 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.3 338.6 282.71 332.98 282.72 336.68 281.31 342.3 281.3 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.06 342.31 295.47 336.69 298.82 336.69 297.41 342.31 294.06 342.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.3 338.6 282.71 332.98 286.06 332.98 284.65 338.6 281.3 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.65 338.6 286.06 332.98 286.07 336.68 284.66 342.3 284.65 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.92 347.94 323.33 342.32 323.34 347.13 321.93 352.75 321.92 347.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.18 345.33 314.59 339.71 314.6 343.42 313.19 349.04 313.18 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.68 338.6 289.09 332.98 289.1 336.69 287.69 342.31 287.68 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.44 342.31 301.85 336.69 305.2 336.69 303.79 342.31 300.44 342.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.61 347.94 328.02 342.32 328.04 347.13 326.63 352.75 326.61 347.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.92 347.94 323.33 342.32 328.02 342.32 326.61 347.94 321.92 347.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.55 345.33 316.56 349.04 313.19 349.04 313.18 345.33 316.55 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.18 345.33 314.59 339.71 317.96 339.71 316.55 345.33 313.18 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.55 345.33 317.96 339.71 317.97 343.42 316.56 349.04 316.55 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.92 335.57 276.33 329.95 279.68 329.95 278.27 335.57 274.92 335.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.68 338.6 289.09 332.98 292.44 332.98 291.03 338.6 287.68 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "291.03 338.6 292.44 332.98 292.45 336.69 291.04 342.31 291.03 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.05 338.6 295.46 332.98 295.47 336.69 294.06 342.31 294.05 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.8 342.31 308.21 336.69 311.57 336.69 310.16 342.31 306.8 342.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.91 346.43 323.32 340.81 328.02 340.81 326.61 346.43 321.91 346.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.29 335.57 282.7 329.95 286.05 329.95 284.64 335.57 281.29 335.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "294.05 338.6 295.46 332.98 298.81 332.98 297.4 338.6 294.05 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.4 338.6 298.81 332.98 298.82 336.69 297.41 342.31 297.4 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.42 338.6 301.83 332.98 301.85 336.69 300.44 342.31 300.42 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.91 331.87 276.32 326.25 276.33 329.95 274.92 335.57 274.91 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.17 342.31 314.58 336.69 317.95 336.69 316.54 342.31 313.17 342.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.67 335.57 289.08 329.95 292.43 329.95 291.02 335.57 287.67 335.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.78 338.6 305.19 332.98 305.2 336.69 303.79 342.31 303.78 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.42 338.6 301.83 332.98 305.19 332.98 303.78 338.6 300.42 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.78 338.6 303.79 342.31 300.44 342.31 300.42 338.6 303.78 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.91 331.87 276.32 326.25 279.67 326.25 278.26 331.87 274.91 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.26 331.87 279.67 326.25 279.68 329.95 278.27 335.57 278.26 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.79 338.6 308.2 332.98 308.21 336.69 306.8 342.31 306.79 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.28 331.87 282.69 326.25 282.7 329.95 281.29 335.57 281.28 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.9 341.99 323.31 336.37 323.32 340.81 321.91 346.43 321.9 341.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.04 335.57 295.45 329.95 298.8 329.95 297.39 335.57 294.04 335.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "310.15 338.6 311.56 332.98 311.57 336.69 310.16 342.31 310.15 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "310.15 338.6 310.16 342.31 306.8 342.31 306.79 338.6 310.15 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.79 338.6 308.2 332.98 311.56 332.98 310.15 338.6 306.79 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.63 331.87 286.04 326.25 286.05 329.95 284.64 335.57 284.63 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.28 331.87 282.69 326.25 286.04 326.25 284.63 331.87 281.28 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.9 341.99 323.31 336.37 328.01 336.37 326.6 341.99 321.9 341.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.6 341.99 328.01 336.37 328.02 340.81 326.61 346.43 326.6 341.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.16 338.61 314.57 332.99 314.58 336.69 313.17 342.31 313.16 338.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.66 331.87 289.07 326.25 289.08 329.95 287.67 335.57 287.66 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.41 335.57 301.82 329.95 305.18 329.95 303.77 335.57 300.41 335.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.53 338.61 316.54 342.31 313.17 342.31 313.16 338.61 316.53 338.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.16 338.61 314.57 332.99 317.94 332.99 316.53 338.61 313.16 338.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.53 338.61 317.94 332.99 317.95 336.69 316.54 342.31 316.53 338.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.9 328.84 276.31 323.22 279.66 323.22 278.25 328.84 274.9 328.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "291.01 331.87 292.42 326.25 292.43 329.95 291.02 335.57 291.01 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.66 331.87 289.07 326.25 292.42 326.25 291.01 331.87 287.66 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.03 331.87 295.44 326.25 295.45 329.95 294.04 335.57 294.03 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.78 335.57 308.19 329.95 311.55 329.95 310.14 335.57 306.78 335.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.27 328.84 282.68 323.22 286.03 323.23 284.62 328.85 281.27 328.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "294.03 331.87 295.44 326.25 298.79 326.25 297.38 331.87 294.03 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.38 331.87 298.79 326.25 298.8 329.95 297.39 335.57 297.38 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.4 331.87 301.81 326.25 301.82 329.95 300.41 335.57 300.4 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.89 325.13 276.3 319.51 276.31 323.22 274.9 328.84 274.89 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.15 335.57 314.56 329.95 317.93 329.95 316.52 335.57 313.15 335.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.76 331.87 305.17 326.25 305.18 329.95 303.77 335.57 303.76 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.4 331.87 301.81 326.25 305.17 326.25 303.76 331.87 300.4 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.24 325.13 279.65 319.51 279.66 323.22 278.25 328.84 278.24 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.89 325.13 276.3 319.51 279.65 319.51 278.24 325.13 274.89 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.77 331.87 308.18 326.25 308.19 329.95 306.78 335.57 306.77 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.26 325.13 282.67 319.51 282.68 323.22 281.27 328.84 281.26 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.02 328.85 295.43 323.23 298.78 323.23 297.37 328.85 294.02 328.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "310.13 331.87 311.54 326.25 311.55 329.95 310.14 335.57 310.13 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.77 331.87 308.18 326.25 311.54 326.25 310.13 331.87 306.77 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.61 325.13 286.02 319.51 286.03 323.23 284.62 328.85 284.61 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.26 325.13 282.67 319.51 286.02 319.51 284.61 325.13 281.26 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.14 331.87 314.55 326.25 314.56 329.95 313.15 335.57 313.14 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.39 328.85 301.8 323.23 305.16 323.23 303.75 328.85 300.39 328.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.51 331.87 316.52 335.57 313.15 335.57 313.14 331.87 316.51 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.51 331.87 317.92 326.25 317.93 329.95 316.52 335.57 316.51 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.14 331.87 314.55 326.25 317.92 326.25 316.51 331.87 313.14 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.88 322.11 276.29 316.49 279.64 316.49 278.23 322.11 274.88 322.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294 325.13 295.41 319.51 295.43 323.23 294.02 328.85 294 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.25 322.11 282.66 316.49 286.01 316.49 284.6 322.11 281.25 322.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.36 325.13 298.77 319.51 298.78 323.23 297.37 328.85 297.36 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "294 325.13 295.41 319.51 298.77 319.51 297.36 325.13 294 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.38 325.13 301.79 319.51 301.8 323.23 300.39 328.85 300.38 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.87 318.41 276.28 312.79 276.29 316.49 274.88 322.11 274.87 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.13 328.85 314.54 323.23 317.91 323.23 316.5 328.85 313.13 328.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.63 322.11 289.04 316.49 292.39 316.49 290.98 322.11 287.63 322.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.74 325.14 305.15 319.52 305.16 323.23 303.75 328.85 303.74 325.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.74 325.14 303.75 328.85 300.39 328.85 300.38 325.13 303.74 325.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.38 325.13 301.79 319.51 305.15 319.52 303.74 325.14 300.38 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.87 318.41 276.28 312.79 279.63 312.79 278.22 318.41 274.87 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.22 318.41 279.63 312.79 279.64 316.49 278.23 322.11 278.22 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.86 329.86 323.27 324.24 327.97 324.24 326.56 329.86 321.86 329.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.24 318.41 282.65 312.79 282.66 316.49 281.25 322.11 281.24 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294 322.11 295.41 316.49 298.76 316.49 297.35 322.11 294 322.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.59 318.41 286 312.79 286.01 316.49 284.6 322.11 284.59 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.24 318.41 282.65 312.79 286 312.79 284.59 318.41 281.24 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.12 325.14 314.53 319.52 314.54 323.23 313.13 328.85 313.12 325.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.62 318.41 289.03 312.79 289.04 316.49 287.63 322.11 287.62 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.37 322.11 301.78 316.49 305.14 316.49 303.73 322.11 300.37 322.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.49 325.14 317.9 319.52 317.91 323.23 316.5 328.85 316.49 325.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.12 325.14 314.53 319.52 317.9 319.52 316.49 325.14 313.12 325.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.86 315.38 276.27 309.76 279.62 309.76 278.21 315.38 274.86 315.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.97 318.41 292.38 312.79 292.39 316.49 290.98 322.11 290.97 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.62 318.41 289.03 312.79 292.38 312.79 290.97 318.41 287.62 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.98 318.41 295.39 312.79 295.41 316.49 294 322.11 293.98 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.74 322.11 308.15 316.49 311.51 316.49 310.1 322.11 306.74 322.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.23 315.38 282.64 309.76 285.99 309.76 284.58 315.38 281.23 315.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.85 324.72 323.26 319.1 323.27 324.24 321.86 329.86 321.85 324.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.34 318.41 298.75 312.79 298.76 316.49 297.35 322.11 297.34 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.98 318.41 295.39 312.79 298.75 312.79 297.34 318.41 293.98 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.36 318.41 301.77 312.79 301.78 316.49 300.37 322.11 300.36 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.54 324.72 327.95 319.1 327.97 324.24 326.56 329.86 326.54 324.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.85 324.72 323.26 319.1 327.95 319.1 326.54 324.72 321.85 324.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.54 324.72 326.56 329.86 321.86 329.86 321.85 324.72 326.54 324.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.85 311.67 276.26 306.05 276.27 309.76 274.86 315.38 274.85 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.11 322.11 314.52 316.49 317.89 316.49 316.48 322.11 313.11 322.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.61 315.38 289.02 309.76 292.37 309.76 290.96 315.38 287.61 315.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.72 318.41 305.13 312.79 305.14 316.49 303.73 322.11 303.72 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.36 318.41 301.77 312.79 305.13 312.79 303.72 318.41 300.36 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.2 311.67 279.61 306.05 279.62 309.76 278.21 315.38 278.2 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.85 311.67 276.26 306.05 279.61 306.05 278.2 311.67 274.85 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.73 318.41 308.14 312.79 308.15 316.49 306.74 322.11 306.73 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.84 323.21 323.25 317.59 327.95 317.59 326.54 323.21 321.84 323.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.22 311.67 282.63 306.05 282.64 309.76 281.23 315.38 281.22 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.98 315.38 295.39 309.76 298.74 309.76 297.33 315.38 293.98 315.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.73 318.41 308.14 312.79 311.5 312.79 310.09 318.41 306.73 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "310.09 318.41 311.5 312.79 311.51 316.49 310.1 322.11 310.09 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.57 311.67 285.98 306.05 285.99 309.76 284.58 315.38 284.57 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.22 311.67 282.63 306.05 285.98 306.05 284.57 311.67 281.22 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.1 318.41 314.51 312.79 314.52 316.49 313.11 322.11 313.1 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.59 311.67 289 306.05 289.02 309.76 287.61 315.38 287.59 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.35 315.38 301.76 309.76 305.12 309.76 303.71 315.38 300.35 315.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.47 318.41 317.88 312.79 317.89 316.49 316.48 322.11 316.47 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.1 318.41 314.51 312.79 317.88 312.79 316.47 318.41 313.1 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.47 318.41 316.48 322.11 313.11 322.11 313.1 318.41 316.47 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.84 308.64 276.25 303.02 279.6 303.02 278.19 308.64 274.84 308.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.59 311.67 289 306.05 292.36 306.05 290.95 311.67 287.59 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.95 311.67 292.36 306.05 292.37 309.76 290.96 315.38 290.95 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.83 319.09 323.24 313.47 323.25 317.59 321.84 323.21 321.83 319.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.96 311.67 295.37 306.05 295.39 309.76 293.98 315.38 293.96 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.21 308.64 282.62 303.02 285.97 303.02 284.56 308.64 281.21 308.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.53 319.09 327.94 313.47 327.95 317.59 326.54 323.21 326.53 319.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.83 319.09 323.24 313.47 327.94 313.47 326.53 319.09 321.83 319.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.96 311.67 295.37 306.05 298.73 306.06 297.32 311.68 293.96 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.32 311.68 298.73 306.06 298.74 309.76 297.33 315.38 297.32 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.34 311.68 301.75 306.06 301.76 309.76 300.35 315.38 300.34 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.83 304.94 276.24 299.32 276.25 303.02 274.84 308.64 274.83 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.09 315.38 314.5 309.76 317.87 309.76 316.46 315.38 313.09 315.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.59 308.64 289 303.02 292.35 303.02 290.94 308.64 287.59 308.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.34 311.68 301.75 306.06 305.11 306.06 303.7 311.68 300.34 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.7 311.68 305.11 306.06 305.12 309.76 303.71 315.38 303.7 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.83 304.94 276.24 299.32 279.59 299.32 278.18 304.94 274.83 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.18 304.94 279.59 299.32 279.6 303.02 278.19 308.64 278.18 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.2 304.94 282.61 299.32 282.62 303.02 281.21 308.64 281.2 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.96 308.64 295.37 303.02 298.72 303.02 297.31 308.64 293.96 308.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.55 304.94 285.96 299.32 285.97 303.02 284.56 308.64 284.55 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.2 304.94 282.61 299.32 285.96 299.32 284.55 304.94 281.2 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.08 311.68 314.49 306.06 314.5 309.76 313.09 315.38 313.08 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.57 304.94 288.98 299.32 289 303.02 287.59 308.64 287.57 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.33 308.64 301.74 303.02 305.1 303.02 303.69 308.64 300.33 308.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.45 311.68 316.46 315.38 313.09 315.38 313.08 311.68 316.45 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.45 311.68 317.86 306.06 317.87 309.76 316.46 315.38 316.45 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.08 311.68 314.49 306.06 317.86 306.06 316.45 311.68 313.08 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.82 301.92 276.23 296.3 279.58 296.3 278.17 301.92 274.82 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.93 304.94 292.34 299.32 292.35 303.02 290.94 308.64 290.93 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.57 304.94 288.98 299.32 292.34 299.32 290.93 304.94 287.57 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.94 304.94 295.35 299.32 295.37 303.02 293.96 308.64 293.94 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.7 308.64 308.11 303.02 311.47 303.02 310.06 308.64 306.7 308.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.19 301.92 282.6 296.3 285.95 296.3 284.54 301.92 281.19 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.3 304.94 298.71 299.32 298.72 303.02 297.31 308.64 297.3 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.3 304.94 297.31 308.64 293.96 308.64 293.94 304.94 297.3 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.94 304.94 295.35 299.32 298.71 299.32 297.3 304.94 293.94 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.32 304.94 301.73 299.32 301.74 303.02 300.33 308.64 300.32 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.81 298.2 276.22 292.58 276.23 296.3 274.82 301.92 274.81 298.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.07 308.65 314.48 303.03 317.85 303.03 316.44 308.65 313.07 308.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.57 301.92 288.98 296.3 292.33 296.3 290.92 301.92 287.57 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.32 304.94 301.73 299.32 305.09 299.32 303.68 304.94 300.32 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.68 304.94 305.09 299.32 305.1 303.02 303.69 308.64 303.68 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.81 298.2 276.22 292.58 279.57 292.58 278.16 298.2 274.81 298.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.16 298.2 279.57 292.58 279.58 296.3 278.17 301.92 278.16 298.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.69 304.94 308.1 299.32 308.11 303.02 306.7 308.64 306.69 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.18 298.21 282.59 292.59 282.6 296.3 281.19 301.92 281.18 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.93 301.92 295.34 296.3 298.7 296.3 297.29 301.92 293.93 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.69 304.94 308.1 299.32 311.46 299.32 310.05 304.94 306.69 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "310.05 304.94 310.06 308.64 306.7 308.64 306.69 304.94 310.05 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "310.05 304.94 311.46 299.32 311.47 303.02 310.06 308.64 310.05 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.18 298.21 282.59 292.59 285.94 292.59 284.53 298.21 281.18 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.53 298.21 285.94 292.59 285.95 296.3 284.54 301.92 284.53 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.06 304.94 314.47 299.32 314.48 303.03 313.07 308.65 313.06 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.55 298.21 288.96 292.59 288.98 296.3 287.57 301.92 287.55 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.31 301.92 301.72 296.3 305.08 296.3 303.67 301.92 300.31 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.43 304.94 317.84 299.32 317.85 303.03 316.44 308.65 316.43 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.43 304.94 316.44 308.65 313.07 308.65 313.06 304.94 316.43 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.06 304.94 314.47 299.32 317.84 299.32 316.43 304.94 313.06 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.8 295.18 276.21 289.56 279.56 289.56 278.15 295.18 274.8 295.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.91 298.21 292.32 292.59 292.33 296.3 290.92 301.92 290.91 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.55 298.21 288.96 292.59 292.32 292.59 290.91 298.21 287.55 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.79 306.97 323.2 301.35 327.9 301.35 326.49 306.97 321.79 306.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.92 298.21 295.33 292.59 295.34 296.3 293.93 301.92 293.92 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.68 301.92 308.09 296.3 311.45 296.3 310.04 301.92 306.68 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.17 295.18 282.58 289.56 285.93 289.56 284.52 295.18 281.17 295.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.28 298.21 298.69 292.59 298.7 296.3 297.29 301.92 297.28 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.92 298.21 295.33 292.59 298.69 292.59 297.28 298.21 293.92 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.3 298.21 301.71 292.59 301.72 296.3 300.31 301.92 300.3 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.79 291.48 276.2 285.86 276.21 289.56 274.8 295.18 274.79 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.05 301.92 314.46 296.3 317.83 296.3 316.42 301.92 313.05 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.54 295.18 288.95 289.56 292.31 289.56 290.9 295.18 287.54 295.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.3 298.21 301.71 292.59 305.07 292.59 303.66 298.21 300.3 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.66 298.21 305.07 292.59 305.08 296.3 303.67 301.92 303.66 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.14 291.48 279.55 285.86 279.56 289.56 278.15 295.18 278.14 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.79 291.48 276.2 285.86 279.55 285.86 278.14 291.48 274.79 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.78 302.3 323.19 296.68 323.2 301.35 321.79 306.97 321.78 302.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.67 298.21 308.08 292.59 308.09 296.3 306.68 301.92 306.67 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.16 291.48 282.57 285.86 282.58 289.56 281.17 295.18 281.16 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.91 295.18 295.32 289.56 298.68 289.56 297.27 295.18 293.91 295.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.67 298.21 308.08 292.59 311.44 292.59 310.03 298.21 306.67 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "310.03 298.21 310.04 301.92 306.68 301.92 306.67 298.21 310.03 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "310.03 298.21 311.44 292.59 311.45 296.3 310.04 301.92 310.03 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.78 302.3 323.19 296.68 327.89 296.68 326.48 302.3 321.78 302.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.48 302.3 327.89 296.68 327.9 301.35 326.49 306.97 326.48 302.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.16 291.48 282.57 285.86 285.92 285.86 284.51 291.48 281.16 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.51 291.48 285.92 285.86 285.93 289.56 284.52 295.18 284.51 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.04 298.21 314.45 292.59 314.46 296.3 313.05 301.92 313.04 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.53 291.48 288.94 285.86 288.95 289.56 287.54 295.18 287.53 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.29 295.18 301.7 289.56 305.06 289.56 303.65 295.18 300.29 295.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.78 300.78 323.19 295.16 327.88 295.17 326.47 300.79 321.78 300.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.04 298.21 314.45 292.59 317.82 292.59 316.41 298.21 313.04 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.41 298.21 317.82 292.59 317.83 296.3 316.42 301.92 316.41 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.41 298.21 316.42 301.92 313.05 301.92 313.04 298.21 316.41 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.78 288.45 276.19 282.83 279.54 282.83 278.13 288.45 274.78 288.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.53 291.48 288.94 285.86 292.3 285.86 290.89 291.48 287.53 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.89 291.48 292.3 285.86 292.31 289.56 290.9 295.18 290.89 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.9 291.48 295.31 285.86 295.32 289.56 293.91 295.18 293.9 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.66 295.18 308.07 289.56 311.43 289.57 310.02 295.19 306.66 295.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.15 288.45 282.56 282.83 285.91 282.83 284.5 288.45 281.15 288.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.9 291.48 295.31 285.86 298.67 285.86 297.26 291.48 293.9 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.26 291.48 298.67 285.86 298.68 289.56 297.27 295.18 297.26 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.26 291.48 297.27 295.18 293.91 295.18 293.9 291.48 297.26 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.28 291.48 301.69 285.86 301.7 289.56 300.29 295.18 300.28 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.77 284.74 276.18 279.12 276.19 282.83 274.78 288.45 274.77 284.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.03 295.19 314.44 289.57 317.81 289.57 316.4 295.19 313.03 295.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.76 296.2 323.17 290.58 323.19 295.16 321.78 300.78 321.76 296.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.28 291.48 301.69 285.86 305.05 285.86 303.64 291.48 300.28 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.64 291.48 303.65 295.18 300.29 295.18 300.28 291.48 303.64 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.64 291.48 305.05 285.86 305.06 289.56 303.65 295.18 303.64 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.12 284.75 279.53 279.13 279.54 282.83 278.13 288.45 278.12 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.77 284.74 276.18 279.12 279.53 279.13 278.12 284.75 274.77 284.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.65 291.48 308.06 285.86 308.07 289.56 306.66 295.18 306.65 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.46 296.2 327.87 290.58 327.88 295.17 326.47 300.79 326.46 296.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.76 296.2 323.17 290.58 327.87 290.58 326.46 296.2 321.76 296.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.14 284.75 282.55 279.13 282.56 282.83 281.15 288.45 281.14 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.89 288.45 295.3 282.83 298.66 282.83 297.25 288.45 293.89 288.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.65 291.48 308.06 285.86 311.42 285.86 310.01 291.48 306.65 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "310.01 291.48 311.42 285.86 311.43 289.57 310.02 295.19 310.01 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "310.01 291.48 310.02 295.19 306.66 295.18 306.65 291.48 310.01 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.49 284.75 285.9 279.13 285.91 282.83 284.5 288.45 284.49 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.14 284.75 282.55 279.13 285.9 279.13 284.49 284.75 281.14 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.02 291.48 314.43 285.86 314.44 289.57 313.03 295.19 313.02 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.27 288.45 301.68 282.83 305.04 282.83 303.63 288.45 300.27 288.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313.02 291.48 314.43 285.86 317.8 285.86 316.39 291.48 313.02 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.39 291.48 316.4 295.19 313.03 295.19 313.02 291.48 316.39 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.39 291.48 317.8 285.86 317.81 289.57 316.4 295.19 316.39 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.76 281.71 276.17 276.09 279.52 276.09 278.11 281.71 274.76 281.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.88 284.75 295.29 279.13 295.3 282.83 293.89 288.45 293.88 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.64 288.45 308.05 282.83 311.41 282.83 310 288.45 306.64 288.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.13 281.71 282.54 276.09 285.89 276.09 284.48 281.71 281.13 281.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.88 284.75 295.29 279.13 298.65 279.13 297.24 284.75 293.88 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.24 284.75 298.65 279.13 298.66 282.83 297.25 288.45 297.24 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.26 284.75 301.67 279.13 301.68 282.83 300.27 288.45 300.26 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.75 278.01 276.16 272.39 276.17 276.09 274.76 281.71 274.75 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.01 288.45 314.42 282.83 317.79 282.83 316.38 288.45 313.01 288.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.5 281.71 288.91 276.09 292.27 276.09 290.86 281.71 287.5 281.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.26 284.75 301.67 279.13 305.03 279.13 303.62 284.75 300.26 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.62 284.75 305.03 279.13 305.04 282.83 303.63 288.45 303.62 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.1 278.01 279.51 272.39 279.52 276.09 278.11 281.71 278.1 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.75 278.01 276.16 272.39 279.51 272.39 278.1 278.01 274.75 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.63 284.75 308.04 279.13 308.05 282.83 306.64 288.45 306.63 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.11 278.01 282.52 272.39 282.54 276.09 281.13 281.71 281.11 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.63 284.75 308.04 279.13 311.4 279.13 309.99 284.75 306.63 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "309.99 284.75 311.4 279.13 311.41 282.83 310 288.45 309.99 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.11 278.01 282.52 272.39 285.88 272.39 284.47 278.01 281.11 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.47 278.01 285.88 272.39 285.89 276.09 284.48 281.71 284.47 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313 284.75 314.41 279.13 314.42 282.83 313.01 288.45 313 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.49 278.01 288.9 272.39 288.91 276.09 287.5 281.71 287.49 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.25 281.72 301.66 276.1 305.02 276.1 303.61 281.72 300.25 281.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.36 284.75 316.38 288.45 313.01 288.45 313 284.75 316.36 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.36 284.75 317.77 279.13 317.79 282.83 316.38 288.45 316.36 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "313 284.75 314.41 279.13 317.77 279.13 316.36 284.75 313 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.74 274.99 276.15 269.37 279.5 269.37 278.09 274.99 274.74 274.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.49 278.01 288.9 272.39 292.26 272.39 290.85 278.01 287.49 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.85 278.01 292.26 272.39 292.27 276.09 290.86 281.71 290.85 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.62 281.72 308.03 276.1 311.39 276.1 309.98 281.72 306.62 281.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.11 274.99 282.52 269.37 285.87 269.37 284.46 274.99 281.11 274.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.24 278.01 301.65 272.39 301.66 276.1 300.25 281.72 300.24 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.72 271.28 276.13 265.66 276.15 269.37 274.74 274.99 274.72 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.99 281.72 314.4 276.1 317.77 276.1 316.36 281.72 312.99 281.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.72 284.08 323.13 278.46 327.83 278.46 326.42 284.08 321.72 284.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.48 274.99 288.89 269.37 292.25 269.37 290.84 274.99 287.48 274.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.6 278.01 305.01 272.39 305.02 276.1 303.61 281.72 303.6 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.24 278.01 301.65 272.39 305.01 272.39 303.6 278.01 300.24 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.08 271.28 279.49 265.66 279.5 269.37 278.09 274.99 278.08 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.72 271.28 276.13 265.66 279.49 265.66 278.08 271.28 274.72 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.61 278.01 308.02 272.39 308.03 276.1 306.62 281.72 306.61 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.09 271.28 282.5 265.66 282.52 269.37 281.11 274.99 281.09 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.85 274.99 295.26 269.37 298.62 269.37 297.21 274.99 293.85 274.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "309.97 278.01 311.38 272.39 311.39 276.1 309.98 281.72 309.97 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.61 278.01 308.02 272.39 311.38 272.39 309.97 278.01 306.61 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.45 271.28 285.86 265.66 285.87 269.37 284.46 274.99 284.45 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.09 271.28 282.5 265.66 285.86 265.66 284.45 271.28 281.09 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.98 278.01 314.39 272.39 314.4 276.1 312.99 281.72 312.98 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.47 271.28 288.88 265.66 288.89 269.37 287.48 274.99 287.47 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.23 274.99 301.64 269.37 305 269.37 303.59 274.99 300.23 274.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.71 279.46 323.12 273.84 323.13 278.46 321.72 284.08 321.71 279.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.34 278.01 317.75 272.39 317.77 276.1 316.36 281.72 316.34 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "312.98 278.01 314.39 272.39 317.75 272.39 316.34 278.01 312.98 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.47 271.28 288.88 265.66 292.24 265.66 290.83 271.28 287.47 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.83 271.28 292.24 265.66 292.25 269.37 290.84 274.99 290.83 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.84 271.28 295.25 265.66 295.26 269.37 293.85 274.99 293.84 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.41 279.46 326.42 284.08 321.72 284.08 321.71 279.46 326.41 279.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.41 279.46 327.82 273.84 327.83 278.46 326.42 284.08 326.41 279.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.71 279.46 323.12 273.84 327.82 273.84 326.41 279.46 321.71 279.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.6 274.99 308.01 269.37 311.37 269.37 309.96 274.99 306.6 274.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.09 268.25 282.5 262.63 285.85 262.63 284.44 268.25 281.09 268.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.2 271.28 298.61 265.66 298.62 269.37 297.21 274.99 297.2 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.84 271.28 295.25 265.66 298.61 265.66 297.2 271.28 293.84 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.71 277.93 323.12 272.31 327.81 272.31 326.4 277.93 321.71 277.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.22 271.28 301.63 265.66 301.64 269.37 300.23 274.99 300.22 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.97 274.99 314.38 269.37 317.75 269.37 316.34 274.99 312.97 274.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.46 268.25 288.87 262.63 292.23 262.63 290.82 268.25 287.46 268.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.58 271.28 304.99 265.66 305 269.37 303.59 274.99 303.58 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.22 271.28 301.63 265.66 304.99 265.66 303.58 271.28 300.22 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.58 271.28 303.59 274.99 300.23 274.99 300.22 271.28 303.58 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.59 271.28 308 265.66 308.01 269.37 306.6 274.99 306.59 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.07 264.55 282.48 258.93 282.5 262.63 281.09 268.25 281.07 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.83 268.26 295.24 262.64 298.6 262.64 297.19 268.26 293.83 268.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.59 271.28 308 265.66 311.36 265.66 309.95 271.28 306.59 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "309.95 271.28 311.36 265.66 311.37 269.37 309.96 274.99 309.95 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "309.95 271.28 309.96 274.99 306.6 274.99 306.59 271.28 309.95 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.07 264.55 282.48 258.93 285.84 258.93 284.43 264.55 281.07 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.43 264.55 284.44 268.25 281.09 268.25 281.07 264.55 284.43 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.43 264.55 285.84 258.93 285.85 262.63 284.44 268.25 284.43 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.96 271.28 314.37 265.66 314.38 269.37 312.97 274.99 312.96 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.69 273.31 323.1 267.69 323.12 272.31 321.71 277.93 321.69 273.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.45 264.55 288.86 258.93 288.87 262.63 287.46 268.25 287.45 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.21 268.26 301.62 262.64 304.98 262.64 303.57 268.26 300.21 268.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.32 271.28 316.34 274.99 312.97 274.99 312.96 271.28 316.32 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.32 271.28 317.73 265.66 317.75 269.37 316.34 274.99 316.32 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "312.96 271.28 314.37 265.66 317.73 265.66 316.32 271.28 312.96 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.7 261.52 276.11 255.9 279.46 255.9 278.05 261.52 274.7 261.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.81 264.55 292.22 258.93 292.23 262.63 290.82 268.25 290.81 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.45 264.55 288.86 258.93 292.22 258.93 290.81 264.55 287.45 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.39 273.31 327.8 267.69 327.81 272.31 326.4 277.93 326.39 273.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.69 273.31 323.1 267.69 327.8 267.69 326.39 273.31 321.69 273.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.39 273.31 326.4 277.93 321.71 277.93 321.69 273.31 326.39 273.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "267.75 258.24 269.16 252.62 269.6 353.86 268.19 359.48 267.75 258.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.82 264.55 295.23 258.93 295.24 262.64 293.83 268.26 293.82 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.58 268.26 307.99 262.64 311.35 262.64 309.94 268.26 306.58 268.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.07 261.52 282.48 255.9 285.83 255.9 284.42 261.52 281.07 261.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.82 264.55 295.23 258.93 298.59 258.93 297.18 264.55 293.82 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.18 264.55 298.59 258.93 298.6 262.64 297.19 268.26 297.18 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.2 264.55 301.61 258.93 301.62 262.64 300.21 268.26 300.2 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.68 257.82 276.09 252.2 276.11 255.9 274.7 261.52 274.68 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.95 268.26 314.36 262.64 317.73 262.64 316.32 268.26 312.95 268.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "267.74 256.47 269.15 250.85 270.98 250.85 269.57 256.47 267.74 256.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.44 261.52 288.85 255.9 292.21 255.9 290.8 261.52 287.44 261.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.56 264.55 304.97 258.93 304.98 262.64 303.57 268.26 303.56 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.2 264.55 301.61 258.93 304.97 258.93 303.56 264.55 300.2 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.04 257.82 279.45 252.2 279.46 255.9 278.05 261.52 278.04 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.68 257.82 276.09 252.2 279.45 252.2 278.04 257.82 274.68 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.57 264.55 307.98 258.93 307.99 262.64 306.58 268.26 306.57 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.05 257.82 282.46 252.2 282.48 255.9 281.07 261.52 281.05 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.81 261.52 295.22 255.9 298.58 255.9 297.17 261.52 293.81 261.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.57 264.55 307.98 258.93 311.34 258.93 309.93 264.55 306.57 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "309.93 264.55 311.34 258.93 311.35 262.64 309.94 268.26 309.93 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "309.93 264.55 309.94 268.26 306.58 268.26 306.57 264.55 309.93 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.05 257.82 282.46 252.2 285.82 252.2 284.41 257.82 281.05 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.41 257.82 285.82 252.2 285.83 255.9 284.42 261.52 284.41 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.94 264.55 314.35 258.93 314.36 262.64 312.95 268.26 312.94 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.43 257.82 288.84 252.2 288.85 255.9 287.44 261.52 287.43 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.19 261.52 301.6 255.9 304.96 255.9 303.55 261.52 300.19 261.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.3 264.55 317.71 258.93 317.73 262.64 316.32 268.26 316.3 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "312.94 264.55 314.35 258.93 317.71 258.93 316.3 264.55 312.94 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.68 254.78 276.09 249.16 279.44 249.16 278.03 254.78 274.68 254.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.79 257.82 292.2 252.2 292.21 255.9 290.8 261.52 290.79 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.43 257.82 288.84 252.2 292.2 252.2 290.79 257.82 287.43 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.8 257.82 295.21 252.2 295.22 255.9 293.81 261.52 293.8 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.04 254.79 282.45 249.17 285.81 249.17 284.4 254.79 281.04 254.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.16 257.82 298.57 252.2 298.58 255.9 297.17 261.52 297.16 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.8 257.82 295.21 252.2 298.57 252.2 297.16 257.82 293.8 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.18 257.82 301.59 252.2 301.6 255.9 300.19 261.52 300.18 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.66 251.08 276.07 245.46 276.09 249.16 274.68 254.78 274.66 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.93 261.52 314.34 255.9 317.7 255.9 316.29 261.52 312.93 261.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.42 254.79 288.83 249.17 292.19 249.17 290.78 254.79 287.42 254.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.18 257.82 301.59 252.2 304.95 252.2 303.54 257.82 300.18 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.54 257.82 304.95 252.2 304.96 255.9 303.55 261.52 303.54 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278.02 251.08 279.43 245.46 279.44 249.16 278.03 254.78 278.02 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.66 251.08 276.07 245.46 279.43 245.46 278.02 251.08 274.66 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.03 251.08 282.44 245.46 282.45 249.17 281.04 254.79 281.03 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.79 254.79 295.2 249.17 298.56 249.17 297.15 254.79 293.79 254.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.39 251.08 285.8 245.46 285.81 249.17 284.4 254.79 284.39 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.03 251.08 282.44 245.46 285.8 245.46 284.39 251.08 281.03 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.92 257.82 314.33 252.2 314.34 255.9 312.93 261.52 312.92 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.66 261.19 323.07 255.57 327.76 255.57 326.35 261.19 321.66 261.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.41 251.08 288.82 245.46 288.83 249.17 287.42 254.79 287.41 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.17 254.79 301.58 249.17 304.94 249.17 303.53 254.79 300.17 254.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.28 257.82 317.69 252.2 317.7 255.9 316.29 261.52 316.28 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "312.92 257.82 314.33 252.2 317.69 252.2 316.28 257.82 312.92 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.65 248.06 276.06 242.44 279.42 242.44 278.01 248.06 274.65 248.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.41 251.08 288.82 245.46 292.18 245.46 290.77 251.08 287.41 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.77 251.08 292.18 245.46 292.19 249.17 290.78 254.79 290.77 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.78 251.08 295.19 245.46 295.2 249.17 293.79 254.79 293.78 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.54 254.79 307.95 249.17 311.31 249.17 309.9 254.79 306.54 254.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.02 248.06 282.43 242.44 285.79 242.44 284.38 248.06 281.02 248.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.78 251.08 295.19 245.46 298.55 245.46 297.14 251.08 293.78 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.14 251.08 298.55 245.46 298.56 249.17 297.15 254.79 297.14 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.16 251.08 301.57 245.46 301.58 249.17 300.17 254.79 300.16 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.64 256.35 323.05 250.73 323.07 255.57 321.66 261.19 321.64 256.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.64 244.35 276.05 238.73 276.06 242.44 274.65 248.06 274.64 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.91 254.79 314.32 249.17 317.68 249.17 316.27 254.79 312.91 254.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.52 251.08 304.93 245.46 304.94 249.17 303.53 254.79 303.52 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.16 251.08 301.57 245.46 304.93 245.46 303.52 251.08 300.16 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.64 244.35 276.05 238.73 279.41 238.73 278 244.35 274.64 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "278 244.35 279.41 238.73 279.42 242.44 278.01 248.06 278 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.34 256.35 327.75 250.73 327.76 255.57 326.35 261.19 326.34 256.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.64 256.35 323.05 250.73 327.75 250.73 326.34 256.35 321.64 256.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.34 256.35 326.35 261.19 321.66 261.19 321.64 256.35 326.34 256.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.53 251.09 307.94 245.47 307.95 249.17 306.54 254.79 306.53 251.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.01 244.35 282.42 238.73 282.43 242.44 281.02 248.06 281.01 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.77 248.06 295.18 242.44 298.54 242.44 297.13 248.06 293.77 248.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.53 251.09 307.94 245.47 311.29 245.47 309.88 251.09 306.53 251.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "309.88 251.09 309.9 254.79 306.54 254.79 306.53 251.09 309.88 251.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "309.88 251.09 311.29 245.47 311.31 249.17 309.9 254.79 309.88 251.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.37 244.35 285.78 238.73 285.79 242.44 284.38 248.06 284.37 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "281.01 244.35 282.42 238.73 285.78 238.73 284.37 244.35 281.01 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.64 254.83 323.05 249.21 327.74 249.21 326.33 254.83 321.64 254.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.9 251.09 314.31 245.47 314.32 249.17 312.91 254.79 312.9 251.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.15 248.06 301.56 242.44 304.92 242.44 303.51 248.06 300.15 248.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "312.9 251.09 314.31 245.47 317.67 245.47 316.26 251.09 312.9 251.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.26 251.09 317.67 245.47 317.68 249.17 316.27 254.79 316.26 251.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.26 251.09 316.27 254.79 312.91 254.79 312.9 251.09 316.26 251.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.63 241.32 276.04 235.7 279.4 235.71 277.99 241.33 274.63 241.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.76 244.35 295.17 238.73 295.18 242.44 293.77 248.06 293.76 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.52 248.06 307.93 242.44 311.29 242.44 309.88 248.06 306.52 248.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281 241.33 282.41 235.71 285.77 235.71 284.36 241.33 281 241.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.76 244.35 295.17 238.73 298.53 238.73 297.12 244.35 293.76 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.12 244.35 298.53 238.73 298.54 242.44 297.13 248.06 297.12 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.62 250.42 323.03 244.8 323.05 249.21 321.64 254.83 321.62 250.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.14 244.35 301.55 238.73 301.56 242.44 300.15 248.06 300.14 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.62 237.62 276.03 232 276.04 235.7 274.63 241.32 274.62 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.89 248.06 314.3 242.44 317.66 242.44 316.25 248.06 312.89 248.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "321.62 250.42 323.03 244.8 327.73 244.8 326.32 250.42 321.62 250.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "326.32 250.42 327.73 244.8 327.74 249.21 326.33 254.83 326.32 250.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "271.93 236.61 273.34 230.99 273.71 353.86 272.3 359.48 271.93 236.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.38 241.33 288.79 235.71 292.15 235.71 290.74 241.33 287.38 241.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "272.26 236.61 273.67 230.99 274.04 353.86 272.63 359.48 272.26 236.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "271.93 236.61 273.34 230.99 273.67 230.99 272.26 236.61 271.93 236.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.5 244.35 304.91 238.73 304.92 242.44 303.51 248.06 303.5 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.14 244.35 301.55 238.73 304.91 238.73 303.5 244.35 300.14 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.62 237.62 276.03 232 279.39 232 277.98 237.62 274.62 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "277.98 237.62 279.39 232 279.4 235.71 277.99 241.33 277.98 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.51 244.35 307.92 238.73 307.93 242.44 306.52 248.06 306.51 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "280.99 237.62 282.4 232 282.41 235.71 281 241.33 280.99 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.75 241.33 295.16 235.71 298.52 235.71 297.11 241.33 293.75 241.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "309.86 244.35 311.27 238.73 311.29 242.44 309.88 248.06 309.86 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.51 244.35 307.92 238.73 311.27 238.73 309.86 244.35 306.51 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "280.99 237.62 282.4 232 285.76 232 284.35 237.62 280.99 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "284.35 237.62 285.76 232 285.77 235.71 284.36 241.33 284.35 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.88 244.35 314.29 238.73 314.3 242.44 312.89 248.06 312.88 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "287.37 237.62 288.78 232 288.79 235.71 287.38 241.33 287.37 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.13 241.33 301.54 235.71 304.9 235.71 303.49 241.33 300.13 241.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.24 244.35 317.65 238.73 317.66 242.44 316.25 248.06 316.24 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "312.88 244.35 314.29 238.73 317.65 238.73 316.24 244.35 312.88 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "290.73 237.62 292.14 232 292.15 235.71 290.74 241.33 290.73 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "287.37 237.62 288.78 232 292.14 232 290.73 237.62 287.37 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "293.74 237.62 295.15 232 295.16 235.71 293.75 241.33 293.74 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.5 241.33 307.91 235.71 311.27 235.71 309.86 241.33 306.5 241.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "293.74 237.62 295.15 232 298.51 232 297.1 237.62 293.74 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "297.1 237.62 298.51 232 298.52 235.71 297.11 241.33 297.1 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.12 237.62 301.53 232 301.54 235.71 300.13 241.33 300.12 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.87 241.33 314.28 235.71 317.64 235.71 316.23 241.33 312.87 241.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "300.12 237.62 301.53 232 304.88 232.01 303.47 237.63 300.12 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "303.47 237.63 304.88 232.01 304.9 235.71 303.49 241.33 303.47 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "306.49 237.63 307.9 232.01 307.91 235.71 306.5 241.33 306.49 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "309.84 237.63 311.25 232.01 311.27 235.71 309.86 241.33 309.84 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "306.49 237.63 307.9 232.01 311.25 232.01 309.84 237.63 306.49 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "312.86 237.63 314.27 232.01 314.28 235.71 312.87 241.33 312.86 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "316.22 237.63 317.63 232.01 317.64 235.71 316.23 241.33 316.22 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "312.86 237.63 314.27 232.01 317.63 232.01 316.22 237.63 312.86 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "318.57 236.62 319.98 231 320.35 353.87 318.94 359.49 318.57 236.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "318.57 236.62 319.98 231 320.31 231 318.9 236.62 318.57 236.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "318.9 236.62 320.31 231 320.68 353.87 319.27 359.49 318.9 236.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.4,247.05h6.07s.34,112.44.34,112.44h-8.54s-.37-122.87-.37-122.87h-.33s.37,122.87.37,122.87h-46.3s-.37-122.88-.37-122.88h-.33s.37,122.87.37,122.87h-4.11s-.31-101.25-.31-101.25l-.14-1.77h1.83s-.07-22.22-.07-22.22h51.86s.04,12.8.04,12.8ZM326.56,329.86l-.02-5.14h-4.7s.02,5.14.02,5.14h4.7M326.35,261.19v-4.85s-4.71,0-4.71,0v4.85s4.71,0,4.71,0M326.63,352.75v-4.81s-4.71,0-4.71,0v4.81s4.71,0,4.71,0M326.49,306.97v-4.68s-4.71,0-4.71,0v4.68s4.71,0,4.71,0M326.42,284.08v-4.62s-4.71,0-4.71,0v4.62s4.71,0,4.71,0M326.4,277.93v-4.62s-4.71,0-4.71,0v4.62s4.71,0,4.71,0M326.47,300.79v-4.59s-4.71,0-4.71,0v4.59s4.71,0,4.71,0M326.61,346.43v-4.44s-4.71,0-4.71,0v4.44s4.71,0,4.71,0M326.33,254.83v-4.42s-4.71,0-4.71,0v4.42s4.71,0,4.71,0M326.54,323.21v-4.11s-4.71,0-4.71,0v4.11s4.71,0,4.71,0M316.5,328.85v-3.71s-3.38,0-3.38,0v3.71s3.38,0,3.38,0M316.56,349.04v-3.71s-3.38,0-3.38,0v3.71s3.38,0,3.38,0M316.34,274.99v-3.71s-3.38,0-3.38,0v3.71s3.38,0,3.38,0M316.42,301.92v-3.71s-3.38,0-3.38,0v3.71s3.38,0,3.38,0M316.25,248.06v-3.71s-3.38,0-3.38,0v3.71s3.38,0,3.38,0M316.58,355.78v-3.71s-3.38,0-3.38,0v3.71s3.38,0,3.38,0M316.54,342.31v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.27,254.79v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.44,308.65v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.36,281.72v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.46,315.38v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.52,335.57v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.29,261.52v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.4,295.19v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.23,241.33v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.32,268.26v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.38,288.45v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M316.48,322.11v-3.7s-3.38,0-3.38,0v3.7s3.38,0,3.38,0M297.37,328.85v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M303.75,328.85v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M278.25,328.84v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M284.62,328.85v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M291.06,349.04v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M290.84,274.99v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M309.96,274.99v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M290.92,301.92v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M291.08,355.77v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M310.2,355.78v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M310.04,301.92v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M309.88,248.06v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M278.09,274.99v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M303.59,274.99v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M284.46,274.99v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M297.21,274.99v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M278.32,349.04v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M297.43,349.04v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M303.81,349.04v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M303.83,355.78v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M297.45,355.77v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M278.34,355.77v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M278.01,248.06v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M284.71,355.77v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M303.51,248.06v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M284.38,248.06v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M297.13,248.06v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M284.54,301.92v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M278.17,301.92v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M297.29,301.92v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M303.67,301.92v-3.71s-3.37,0-3.37,0v3.71s3.37,0,3.37,0M290.94,308.64v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M290.78,254.79v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M291.04,342.31v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M310.16,342.31v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M309.9,254.79v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M310.06,308.64v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M291.02,335.57v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M290.96,315.38v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M290.86,281.71v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M310.14,335.57v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M309.98,281.72v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M290.9,295.18v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M290.74,241.33v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M290.8,261.52v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M309.86,241.33v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M310.02,295.19v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M290.82,268.25v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M309.94,268.26v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.79,342.31v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.41,342.31v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.31,308.64v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.03,254.78v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.66,342.3v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.29,342.3v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.56,308.64v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.4,254.79v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.15,254.79v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.19,308.64v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.69,308.64v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.53,254.79v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.21,315.38v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.11,281.71v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.71,315.38v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.39,335.57v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.77,335.57v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.64,335.57v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.58,315.38v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.27,335.57v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.61,281.72v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.33,315.38v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.48,281.71v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.55,261.52v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.11,241.33v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.49,241.33v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M277.99,241.33v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.65,295.18v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.27,295.18v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.52,295.18v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.05,261.52v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.42,261.52v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.15,295.18v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.36,241.33v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.17,261.52v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.57,268.26v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.19,268.26v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.44,268.25v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M310,288.45v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M290.98,322.11v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M310.1,322.11v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.13,288.45v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.25,288.45v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.5,288.45v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.63,288.45v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M284.6,322.11v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M303.73,322.11v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M297.35,322.11v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0M278.23,322.11v-3.7s-3.37,0-3.37,0v3.7s3.37,0,3.37,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.32 352.06 278.34 355.77 274.98 355.77 274.97 352.06 278.32 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.69 352.06 284.71 355.77 281.35 355.77 281.34 352.06 284.69 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "291.07 352.06 291.08 355.77 287.73 355.77 287.72 352.06 291.07 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.44 352.06 297.45 355.77 294.1 355.77 294.09 352.06 297.44 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.82 352.06 303.83 355.78 300.48 355.77 300.46 352.06 303.82 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.3 345.33 278.32 349.04 274.96 349.04 274.95 345.33 278.3 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "310.19 352.06 310.2 355.78 306.85 355.78 306.83 352.06 310.19 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.57 352.06 316.58 355.78 313.21 355.78 313.2 352.06 316.57 352.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "291.05 345.33 291.06 349.04 287.71 349.04 287.7 345.33 291.05 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.42 345.33 297.43 349.04 294.08 349.04 294.07 345.33 297.42 345.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.28 338.6 278.29 342.3 274.94 342.3 274.93 338.6 278.28 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.65 338.6 284.66 342.3 281.31 342.3 281.3 338.6 284.65 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.61 347.94 326.63 352.75 321.93 352.75 321.92 347.94 326.61 347.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "291.03 338.6 291.04 342.31 287.69 342.31 287.68 338.6 291.03 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.4 338.6 297.41 342.31 294.06 342.31 294.05 338.6 297.4 338.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.26 331.87 278.27 335.57 274.92 335.57 274.91 331.87 278.26 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.63 331.87 284.64 335.57 281.29 335.57 281.28 331.87 284.63 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.6 341.99 326.61 346.43 321.91 346.43 321.9 341.99 326.6 341.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "291.01 331.87 291.02 335.57 287.67 335.57 287.66 331.87 291.01 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.38 331.87 297.39 335.57 294.04 335.57 294.03 331.87 297.38 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.76 331.87 303.77 335.57 300.41 335.57 300.4 331.87 303.76 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.24 325.13 278.25 328.84 274.9 328.84 274.89 325.13 278.24 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "310.13 331.87 310.14 335.57 306.78 335.57 306.77 331.87 310.13 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.61 325.13 284.62 328.85 281.27 328.84 281.26 325.13 284.61 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.36 325.13 297.37 328.85 294.02 328.85 294 325.13 297.36 325.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.22 318.41 278.23 322.11 274.88 322.11 274.87 318.41 278.22 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.59 318.41 284.6 322.11 281.25 322.11 281.24 318.41 284.59 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.49 325.14 316.5 328.85 313.13 328.85 313.12 325.14 316.49 325.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.97 318.41 290.98 322.11 287.63 322.11 287.62 318.41 290.97 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.34 318.41 297.35 322.11 294 322.11 293.98 318.41 297.34 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.72 318.41 303.73 322.11 300.37 322.11 300.36 318.41 303.72 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.2 311.67 278.21 315.38 274.86 315.38 274.85 311.67 278.2 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "310.09 318.41 310.1 322.11 306.74 322.11 306.73 318.41 310.09 318.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.57 311.67 284.58 315.38 281.23 315.38 281.22 311.67 284.57 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.95 311.67 290.96 315.38 287.61 315.38 287.59 311.67 290.95 311.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.53 319.09 326.54 323.21 321.84 323.21 321.83 319.09 326.53 319.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.32 311.68 297.33 315.38 293.98 315.38 293.96 311.67 297.32 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.7 311.68 303.71 315.38 300.35 315.38 300.34 311.68 303.7 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.18 304.94 278.19 308.64 274.84 308.64 274.83 304.94 278.18 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.55 304.94 284.56 308.64 281.21 308.64 281.2 304.94 284.55 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.93 304.94 290.94 308.64 287.59 308.64 287.57 304.94 290.93 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.68 304.94 303.69 308.64 300.33 308.64 300.32 304.94 303.68 304.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.16 298.2 278.17 301.92 274.82 301.92 274.81 298.2 278.16 298.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.53 298.21 284.54 301.92 281.19 301.92 281.18 298.21 284.53 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.91 298.21 290.92 301.92 287.57 301.92 287.55 298.21 290.91 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.28 298.21 297.29 301.92 293.93 301.92 293.92 298.21 297.28 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.66 298.21 303.67 301.92 300.31 301.92 300.3 298.21 303.66 298.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.14 291.48 278.15 295.18 274.8 295.18 274.79 291.48 278.14 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.48 302.3 326.49 306.97 321.79 306.97 321.78 302.3 326.48 302.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.51 291.48 284.52 295.18 281.17 295.18 281.16 291.48 284.51 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.89 291.48 290.9 295.18 287.54 295.18 287.53 291.48 290.89 291.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.12 284.75 278.13 288.45 274.78 288.45 274.77 284.74 278.12 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.46 296.2 326.47 300.79 321.78 300.78 321.76 296.2 326.46 296.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.49 284.75 284.5 288.45 281.15 288.45 281.14 284.75 284.49 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.24 284.75 297.25 288.45 293.89 288.45 293.88 284.75 297.24 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.62 284.75 303.63 288.45 300.27 288.45 300.26 284.75 303.62 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.1 278.01 278.11 281.71 274.76 281.71 274.75 278.01 278.1 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "309.99 284.75 310 288.45 306.64 288.45 306.63 284.75 309.99 284.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.47 278.01 284.48 281.71 281.13 281.71 281.11 278.01 284.47 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.85 278.01 290.86 281.71 287.5 281.71 287.49 278.01 290.85 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.6 278.01 303.61 281.72 300.25 281.72 300.24 278.01 303.6 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.08 271.28 278.09 274.99 274.74 274.99 274.72 271.28 278.08 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "309.97 278.01 309.98 281.72 306.62 281.72 306.61 278.01 309.97 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.45 271.28 284.46 274.99 281.11 274.99 281.09 271.28 284.45 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.34 278.01 316.36 281.72 312.99 281.72 312.98 278.01 316.34 278.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.83 271.28 290.84 274.99 287.48 274.99 287.47 271.28 290.83 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.2 271.28 297.21 274.99 293.85 274.99 293.84 271.28 297.2 271.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.81 264.55 290.82 268.25 287.46 268.25 287.45 264.55 290.81 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.18 264.55 297.19 268.26 293.83 268.26 293.82 264.55 297.18 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.56 264.55 303.57 268.26 300.21 268.26 300.2 264.55 303.56 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.04 257.82 278.05 261.52 274.7 261.52 274.68 257.82 278.04 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.41 257.82 284.42 261.52 281.06 261.52 281.05 257.82 284.41 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.3 264.55 316.32 268.26 312.95 268.26 312.94 264.55 316.3 264.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.79 257.82 290.8 261.52 287.44 261.52 287.43 257.82 290.79 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.16 257.82 297.17 261.52 293.81 261.52 293.8 257.82 297.16 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.54 257.82 303.55 261.52 300.19 261.52 300.18 257.82 303.54 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278.02 251.08 278.03 254.78 274.68 254.78 274.66 251.08 278.02 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.39 251.08 284.4 254.79 281.04 254.79 281.03 251.08 284.39 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.28 257.82 316.29 261.52 312.93 261.52 312.92 257.82 316.28 257.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.77 251.08 290.78 254.79 287.42 254.79 287.41 251.08 290.77 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.14 251.08 297.15 254.79 293.79 254.79 293.78 251.08 297.14 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.52 251.08 303.53 254.79 300.17 254.79 300.16 251.08 303.52 251.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "278 244.35 278.01 248.06 274.65 248.06 274.64 244.35 278 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.37 244.35 284.38 248.06 281.02 248.06 281.01 244.35 284.37 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.12 244.35 297.13 248.06 293.77 248.06 293.76 244.35 297.12 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.32 250.42 326.33 254.83 321.64 254.83 321.62 250.42 326.32 250.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "272.26 236.61 272.63 359.48 272.3 359.48 271.93 236.61 272.26 236.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.5 244.35 303.51 248.06 300.15 248.06 300.14 244.35 303.5 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "277.98 237.62 277.99 241.33 274.63 241.32 274.62 237.62 277.98 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "309.86 244.35 309.88 248.06 306.52 248.06 306.51 244.35 309.86 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "284.35 237.62 284.36 241.33 281 241.33 280.99 237.62 284.35 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.24 244.35 316.25 248.06 312.89 248.06 312.88 244.35 316.24 244.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.4 247.05 322.81 241.43 328.88 241.43 327.47 247.05 321.4 247.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "327.47 247.05 328.88 241.43 329.22 353.87 327.81 359.49 327.47 247.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.73 237.62 290.74 241.33 287.38 241.33 287.37 237.62 290.73 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "297.1 237.62 297.11 241.33 293.75 241.33 293.74 237.62 297.1 237.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.47 237.63 303.49 241.33 300.13 241.33 300.12 237.62 303.47 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "309.84 237.63 309.86 241.33 306.5 241.33 306.49 237.63 309.84 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "316.22 237.63 316.23 241.33 312.87 241.33 312.86 237.63 316.22 237.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "318.9 236.62 319.27 359.49 318.94 359.49 318.57 236.62 318.9 236.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "321.36 234.26 322.77 228.64 322.81 241.43 321.4 247.05 321.36 234.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "269.5 234.25 270.91 228.63 322.77 228.64 321.36 234.26 269.5 234.25"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M427.13,356.23c-.01-.24-.01-.47-.01-.71H57.11v5.42h370.02v-4.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M427.12,119.94c-2.08-2.47-17.23-18.99-18.47-19.5-1.13-.47-1.7.1-1.7,1.27-5.99,13.19-13.83,25.49-19.77,38.69-.37.82-1.71,1.69-1.65,2.65,33.35,35.45,53.79,83.18,53.79,135.69,0,109.4-88.68,198.08-198.08,198.08-10.16,0-20.14-.77-29.88-2.24,0,.02-.02.03-.03.05-14.13,27.07-28.51,54.03-41.98,81.42l46.7-37.72c54.3,4.4,107.87-7.14,154.06-35.8,125.45-77.83,152.48-249.3,57.02-362.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M310.42,0c-13.47,27.4-27.85,54.36-41.98,81.42-.01.02-.02.04-.03.05-.2-.03-.4-.06-.6-.09-18.61-2.38-37.6-1.77-56.19,1.47-95.35,14.3-168.46,96.54-168.46,195.87,0,51.91,19.97,99.14,52.64,134.46l-21.89,37.93c-13.4-13.32-25.78-28.06-35.89-44.03C-15.57,322.45-12.32,215.04,46.61,134.08,96.8,65.12,181.55,27.12,266.16,35.76L310.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M341.21,105.42l-15.48,28.97c-1.19-.8-1.35-1.99-1.8-3.2-3.55-9.59-8.78-29.61-10.7-39.76l-.83-4.39,59.78-41.57-30.97,59.95Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8dde4fe002c17b30c15f881c87a5325b.svg";
export { ForwardRef as ReactComponent };